import i18n from '@/services/lang'
//TO delete this file

export const DocFormExample = {
  name: 'My form',
  description: 'Testt',
  id: 3,
  docSubCategoryDataEntries: [
    {
      id: 90,
      name: 'hello',
      description: 'Hello',
      primitives: [
        {
          name: 'stringb',
          hint: 'string',
          priority: 0,
          type: 'boolean',
          max: 4,
          isMandatory: true,
          docSubCategoryDataEntry: 'string',
          id: 'string',
          createdAt: '2021-10-18T12:21:12.409Z',
          updatedAt: '2021-10-18T12:21:12.409Z',
          deletedAt: '2021-10-18T12:21:12.409Z',
          version: 0
        },
        {
          name: 'stringc',
          hint: 'Es tu le vrai Joker ?',
          priority: 0,
          type: 'boolean',
          max: 4,
          docSubCategoryDataEntry: 'string',
          id: 'string',
          createdAt: '2021-10-18T12:21:12.409Z',
          updatedAt: '2021-10-18T12:21:12.409Z',
          deletedAt: '2021-10-18T12:21:12.409Z',
          version: 0
        },
        {
          name: 'stringdate1',
          hint: 'string',
          priority: 0,
          type: 'date',
          constraintMessage: 'string',
          docSubCategoryDataEntry: 'string',
          id: 'string',
          createdAt: '2021-10-18T12:21:12.409Z',
          updatedAt: '2021-10-18T12:21:12.409Z',
          deletedAt: '2021-10-18T12:21:12.409Z',
          version: 0,
          isMandatory: true,
          min: '2021-10-23'
        },
        {
          name: 'stringdate12',
          hint: 'string',
          priority: 0,
          type: 'date',
          constraintMessage: 'string',
          docSubCategoryDataEntry: 'string',
          id: 'string',
          createdAt: '2021-10-18T12:21:12.409Z',
          updatedAt: '2021-10-18T12:21:12.409Z',
          deletedAt: '2021-10-18T12:21:12.409Z',
          version: 0,
          isMandatory: true,
          max: '2021-10-03'
        },
        {
          name: 'stringflo',
          hint: 'float value',
          priority: 0,
          type: 'float',
          isMandatory: true,
          max: 5,
          min: 0,
          constraintMessage: 'string',
          docSubCategoryDataEntry: 'string',
          id: 'string',
          createdAt: '2021-10-18T12:21:12.409Z',
          updatedAt: '2021-10-18T12:21:12.409Z',
          deletedAt: '2021-10-18T12:21:12.409Z',
          version: 0
        },
        {
          name: 'string',
          hint: 'string',
          type: 'string',
          priority: 3,
          isMandatory: true,
          maxLength: 6,
          minLength: 2,
          constraintMessage: 'string',
          id: 1,
          version: 0
        },
        {
          name: 'string1',
          hint: 'string',
          type: 'string',
          priority: 2,
          isMandatory: true,
          maxLength: 7,
          minLength: 2,
          constraintMessage: 'string',
          id: 2,
          version: 0
        },
        {
          name: 'string0',
          hint: 'string',
          priority: 3,
          type: 'string',
          isMandatory: true,
          maxLength: 9,
          minLength: 2,
          constraintMessage: 'string',
          id: 4,
          version: 0
        },
        {
          name: 'string2',
          hint: 'string',
          type: 'string',
          priority: 3,
          isMandatory: true,
          maxLength: 7,
          minLength: 2,
          constraintMessage: 'string',
          id: 9,
          version: 0
        },
        {
          name: 'stringint',
          hint: 'string',
          priority: 0,
          type: 'number',
          isMandatory: true,
          max: 'string',
          min: 0,
          constraintMessage: 'string',
          docSubCategoryDataEntry: 'string',
          id: 'string',
          createdAt: '2021-10-18T12:21:12.409Z',
          updatedAt: '2021-10-18T12:21:12.409Z',
          deletedAt: '2021-10-18T12:21:12.409Z',
          version: 0
        },
        {
          name: 'stringde',
          hint: 'string',
          priority: 0,
          type: 'enum',
          docSubCategoryDataEntry: 'string',
          id: 'string',
          values: [],
          createdAt: '2021-10-18T12:21:12.409Z',
          updatedAt: '2021-10-18T12:21:12.409Z',
          deletedAt: '2021-10-18T12:21:12.409Z',
          version: 0
        }
      ]
    }
  ]
}

export const EventFormExample = [
  {
    name: 'My super event category',
    description: 'This is a test cat',
    id: '1222223',
    createdAt: '01/01/2021',
    updatedAt: '01/01/2021',
    version: 1,
    eventSubCategories: [
      {
        id: '90',
        name: 'Sub 1',
        description: 'Something',
        eventCategory: {
          name: 'My super event category',
          description: 'This is a test cat',
          id: '1222223',
          createdAt: '01/01/2021',
          updatedAt: '01/01/2021',
          version: 1
        },
        events: [],
        eventSubCategoryForm: {
          name: 'Event form 1',
          description: 'Event form 1 desc',
          eventSubCategoryDataEntries: [
            {
              id: '111',
              name: 'What',
              description: 'dafaq',
              primitives: [
                {
                  name: 'Are we cool yet?',
                  hint: 'Test',
                  priority: 0,
                  type: 'boolean',
                  max: 4,
                  isMandatory: true,
                  docSubCategoryDataEntry: 'string',
                  id: 'string',
                  createdAt: '2021-10-18T12:21:12.409Z',
                  updatedAt: '2021-10-18T12:21:12.409Z',
                  deletedAt: '2021-10-18T12:21:12.409Z',
                  version: 0
                },
                {
                  name: 'On a scale of 0 to 5',
                  hint: 'float value',
                  priority: 0,
                  type: 'float',
                  isMandatory: true,
                  max: 5,
                  min: 0,
                  constraintMessage: 'string',
                  docSubCategoryDataEntry: 'string',
                  id: 'string',
                  createdAt: '2021-10-18T12:21:12.409Z',
                  updatedAt: '2021-10-18T12:21:12.409Z',
                  deletedAt: '2021-10-18T12:21:12.409Z',
                  version: 0
                }
              ]
            }
          ]
        }
      }
    ]
  },
  {
    name: 'This is the second category',
    description: 'This is another test cat',
    id: '122222ddd3',
    createdAt: '01/01/2021',
    updatedAt: '01/01/2021',
    version: 1,
    eventSubCategories: [
      {
        id: '91',
        name: 'Sub 2-1',
        description: 'Something else',
        eventCategory: {
          name: 'This is the second category',
          description: 'This is another test cat',
          id: '122222ddd3',
          createdAt: '01/01/2021',
          updatedAt: '01/01/2021',
          version: 1
        },
        events: [],
        eventSubCategoryForm: {
          name: 'Event form 2',
          description: 'Event form 2 desc',
          eventSubCategoryDataEntries: [
            {
              id: '3333',
              name: 'omgz',
              description: 'idgi',
              primitives: [
                {
                  name: 'string',
                  hint: 'string',
                  priority: 3,
                  type: 'string',
                  isMandatory: true,
                  maxLength: 6,
                  minLength: 2,
                  constraintMessage: 'string',
                  id: 1,
                  version: 0
                },
                {
                  name: 'Name one number',
                  hint: 'string',
                  priority: 0,
                  type: 'number',
                  isMandatory: true,
                  max: 'string',
                  min: 0,
                  constraintMessage: 'string',
                  docSubCategoryDataEntry: 'string',
                  id: 'string',
                  createdAt: '2021-10-18T12:21:12.409Z',
                  updatedAt: '2021-10-18T12:21:12.409Z',
                  deletedAt: '2021-10-18T12:21:12.409Z',
                  version: 0
                },
                {
                  name: 'the date',
                  hint: 'string',
                  priority: 0,
                  type: 'date',
                  constraintMessage: 'string',
                  docSubCategoryDataEntry: 'string',
                  id: 'string',
                  createdAt: '2021-10-18T12:21:12.409Z',
                  updatedAt: '2021-10-18T12:21:12.409Z',
                  deletedAt: '2021-10-18T12:21:12.409Z',
                  version: 0,
                  isMandatory: true,
                  min: '2021-10-23'
                }
              ]
            }
          ]
        }
      }
    ]
  }
]

export const contactsMocks = [
  {
    id: '89fe7d49-59e2-11e8-9f5c-fa163ecedb5e',
    type: 'NATURAL',
    firstname: 'Alban ',
    lastname: 'Jaubert',
    gender: 'MALE',
    birthdayAt: '1958-05-22',
    commercialName: null,
    birthPlace: 'Philadelphie',
    situation: 'SINGLE',
    denomination: null,
    immatriculation: null,
    address: '3, rue de la guitare jazz',
    address_complement: null,
    postalCode: '75000',
    city: 'Paris',
    country: 'France',
    nationality: 'française',
    email: '',
    phonenumber: '',
    constitutedAt: null,
    website: '',
    closeAt: null,
    ape: null,
    tva: null,
    Company: {
      id: 'c1610166-cf4c-49d3-92a1-ae80d4302719',
      isActive: true,
      CreatedByUser: null
    },
    RepresentativeContact: null,
    FormType: null,
    pictureUrl:
      'https://uplaw-prod-public-content.s3.eu-west-3.amazonaws.com/pictures/c1610166-cf4c-49d3-92a1-ae80d4302719/89fe7d49-59e2-11e8-9f5c-fa163ecedb5e.jpg?v=1526577829000',
    Group: {
      id: 'f343b804-be4e-42eb-951e-8f7c92802e0d',
      name: i18n.global.t('groups.founders'),
      color: '598CEF',
      order: 1
    },
    CreatedByUser: null,
    Documents: [
      {
        id: '5f3a4f14-13b2-11eb-8d78-068d0b27b94e',
        name: 'democorp',
        state: 'READY',
        signedAt: null,
        uploadedAt: '2021-02-22T05:42:08.000Z',
        processedAt: '2021-02-23T09:33:14.000Z',
        readyAt: '2021-03-09T11:54:49.000Z',
        hasOCR: true,
        auditState: 'ANOMALY',
        isUnreadable: false,
        hasMissingInfo: false,
        hasMissingPage: false,
        hasMissingSignature: false,
        hasExtractionContactsDone: false,
        Company: {
          id: 'c1610166-cf4c-49d3-92a1-ae80d4302719',
          isActive: true
        },
        downloadUrl:
          '/company/c1610166-cf4c-49d3-92a1-ae80d4302719/document/5f3a4f14-13b2-11eb-8d78-068d0b27b94e/url',
        CreatedByUser: null,
        attachmentState: 'NONE'
      },
      {
        id: 'f38abe37-1908-11eb-8d78-068d0b27b94e',
        name: 'Proces-verbal_d_assemblee_generale_',
        state: 'READY',
        signedAt: null,
        uploadedAt: '2021-02-22T05:42:11.000Z',
        processedAt: '2021-02-23T09:33:15.000Z',
        readyAt: '2021-06-07T02:22:54.000Z',
        hasOCR: true,
        auditState: 'COMPLETED',
        isUnreadable: false,
        hasMissingInfo: false,
        hasMissingPage: false,
        hasMissingSignature: false,
        hasExtractionContactsDone: false,
        Company: {
          id: 'c1610166-cf4c-49d3-92a1-ae80d4302719',
          isActive: true
        },
        downloadUrl:
          '/company/c1610166-cf4c-49d3-92a1-ae80d4302719/document/f38abe37-1908-11eb-8d78-068d0b27b94e/url',
        CreatedByUser: null,
        attachmentState: 'NONE'
      },
      {
        id: '96e0b27f-1909-11eb-8d78-068d0b27b94e',
        name: 'Proces-verbal_d_assemblee_generale_',
        state: 'READY',
        signedAt: '2021-10-13',
        uploadedAt: '2021-02-22T05:42:12.000Z',
        processedAt: '2021-02-23T09:33:16.000Z',
        readyAt: '2021-10-25T12:12:30.000Z',
        hasOCR: true,
        auditState: 'ANOMALY',
        isUnreadable: false,
        hasMissingInfo: false,
        hasMissingPage: true,
        hasMissingSignature: false,
        hasExtractionContactsDone: false,
        Company: {
          id: 'c1610166-cf4c-49d3-92a1-ae80d4302719',
          isActive: true
        },
        downloadUrl:
          '/company/c1610166-cf4c-49d3-92a1-ae80d4302719/document/96e0b27f-1909-11eb-8d78-068d0b27b94e/url',
        CreatedByUser: null,
        attachmentState: 'NONE'
      }
    ],
    linkedToCE: true,
    fd: 10000,
    nfd: 9800
  },
  {
    id: '89fe8238-59e2-11e8-9f5c-fa163ecedb5e1',
    type: 'LEGAL',
    firstname: null,
    lastname: null,
    gender: 'OTHER',
    birthdayAt: null,
    commercialName: 'AQuont',
    birthPlace: null,
    situation: 'NC',
    denomination: 'AQuont',
    immatriculation: '456204809',
    address: '',
    address_complement: null,
    postalCode: '',
    city: '',
    country: '',
    nationality: null,
    email: '',
    phonenumber: '',
    constitutedAt: null,
    website: '',
    closeAt: null,
    ape: null,
    tva: null,
    Company: {
      id: 'c1610166-cf4c-49d3-92a1-ae80d4302719',
      isActive: true,
      CreatedByUser: null
    },
    RepresentativeContact: null,
    FormType: null,
    pictureUrl:
      'https://uplaw-prod-public-content.s3.eu-west-3.amazonaws.com/pictures/c1610166-cf4c-49d3-92a1-ae80d4302719/89fe8238-59e2-11e8-9f5c-fa163ecedb5e.jpg?v=1526577829000',
    Group: {
      id: '17e33530-c245-42b9-a06f-2bce943661a7',
      name: 'others',
      color: '598CEF',
      order: 13
    },
    CreatedByUser: null,
    Documents: [
      {
        id: 'f38abe37-1908-11eb-8d78-068d0b27b94e',
        name: 'Proces-verbal_d_assemblee_generale_',
        state: 'READY',
        signedAt: null,
        uploadedAt: '2021-02-22T05:42:11.000Z',
        processedAt: '2021-02-23T09:33:15.000Z',
        readyAt: '2021-06-07T02:22:54.000Z',
        hasOCR: true,
        auditState: 'COMPLETED',
        isUnreadable: false,
        hasMissingInfo: false,
        hasMissingPage: false,
        hasMissingSignature: false,
        hasExtractionContactsDone: false,
        Company: {
          id: 'c1610166-cf4c-49d3-92a1-ae80d4302719',
          isActive: true
        },
        downloadUrl:
          '/company/c1610166-cf4c-49d3-92a1-ae80d4302719/document/f38abe37-1908-11eb-8d78-068d0b27b94e/url',
        CreatedByUser: null,
        attachmentState: 'NONE'
      }
    ],
    linkedToCE: false
  },
  {
    id: '89fe8353-59e2-11e8-9f5c-fa163ecedb5e2',
    type: 'LEGAL',
    firstname: null,
    lastname: null,
    gender: 'OTHER',
    birthdayAt: null,
    commercialName: 'Yelloworks',
    birthPlace: null,
    situation: 'NC',
    denomination: 'Yelloworks',
    immatriculation: '818969115',
    address: '100, rue de la Paix',
    address_complement: null,
    postalCode: '75002',
    city: 'Paris',
    country: 'France',
    nationality: null,
    email: '',
    phonenumber: '',
    constitutedAt: null,
    website: '',
    closeAt: null,
    ape: null,
    tva: null,
    Company: {
      id: 'c1610166-cf4c-49d3-92a1-ae80d4302719',
      isActive: true,
      CreatedByUser: null
    },
    RepresentativeContact: null,
    FormType: null,
    pictureUrl:
      'https://uplaw-prod-public-content.s3.eu-west-3.amazonaws.com/pictures/c1610166-cf4c-49d3-92a1-ae80d4302719/89fe8353-59e2-11e8-9f5c-fa163ecedb5e.jpg?v=1526577829000',
    Group: {
      id: 'fb5dcad8-0424-4c9d-8c0b-b42878603d68',
      name: 'investors',
      color: '598CEF',
      order: 12
    },
    CreatedByUser: null,
    Documents: [],
    linkedToCE: true
  },
  {
    id: '89fe8425-59e2-11e8-9f5c-fa163ecedb5e3',
    type: 'LEGAL',
    firstname: null,
    lastname: null,
    gender: 'OTHER',
    birthdayAt: null,
    commercialName: 'Vinyl Records',
    birthPlace: null,
    situation: 'NC',
    denomination: 'Vinyl Records',
    immatriculation: '821693785',
    address: '150 rue du Faubourg Saint Honoré ',
    address_complement: null,
    postalCode: '75008',
    city: 'PARIS-8E-ARRONDISSEMENT',
    country: 'France',
    nationality: null,
    email: '',
    phonenumber: '',
    constitutedAt: null,
    website: '',
    closeAt: null,
    ape: null,
    tva: null,
    Company: {
      id: 'c1610166-cf4c-49d3-92a1-ae80d4302719',
      isActive: true,
      CreatedByUser: null
    },
    RepresentativeContact: null,
    FormType: null,
    pictureUrl:
      'https://uplaw-prod-public-content.s3.eu-west-3.amazonaws.com/pictures/c1610166-cf4c-49d3-92a1-ae80d4302719/89fe8425-59e2-11e8-9f5c-fa163ecedb5e.jpg?v=1526577829000',
    Group: {
      id: 'fb5dcad8-0424-4c9d-8c0b-b42878603d68',
      name: 'investors',
      color: '598CEF',
      order: 12
    },
    CreatedByUser: null,
    Documents: [],
    linkedToCE: true,
    fd: 1757,
    nfd: 1757
  },
  {
    id: '89fe84ed-59e2-11e8-9f5c-fa163ecedb5e4',
    type: 'LEGAL',
    firstname: null,
    lastname: null,
    gender: 'OTHER',
    birthdayAt: null,
    commercialName: 'Hyperism Venture',
    birthPlace: null,
    situation: 'NC',
    denomination: 'Hyperism Venture',
    immatriculation: '825269145',
    address: '91 rue du Faubourg Saint Honoré ',
    address_complement: null,
    postalCode: '75008',
    city: 'PARIS-8E-ARRONDISSEMENT',
    country: 'France',
    nationality: null,
    email: '',
    phonenumber: '',
    constitutedAt: null,
    website: '',
    closeAt: null,
    ape: null,
    tva: null,
    Company: {
      id: 'c1610166-cf4c-49d3-92a1-ae80d4302719',
      isActive: true,
      CreatedByUser: null
    },
    RepresentativeContact: {
      id: '89fe7d49-59e2-11e8-9f5c-fa163ecedb5e',
      type: 'NATURAL',
      firstname: 'Alban ',
      lastname: 'Jaubert',
      gender: 'MALE',
      birthdayAt: '1958-05-22',
      commercialName: null,
      birthPlace: 'Philadelphie',
      situation: 'SINGLE',
      denomination: null,
      immatriculation: null,
      address: '3, rue de la guitare jazz',
      address_complement: null,
      postalCode: '75000',
      city: 'Paris',
      country: 'France',
      nationality: 'française',
      email: '',
      phonenumber: '',
      constitutedAt: null,
      website: '',
      closeAt: null,
      ape: null,
      tva: null,
      pictureUrl: null,
      CreatedByUser: null
    },
    FormType: null,
    pictureUrl:
      'https://uplaw-prod-public-content.s3.eu-west-3.amazonaws.com/pictures/c1610166-cf4c-49d3-92a1-ae80d4302719/89fe84ed-59e2-11e8-9f5c-fa163ecedb5e.jpg?v=1526577829000',
    Group: {
      id: 'fb5dcad8-0424-4c9d-8c0b-b42878603d68',
      name: 'investors',
      color: '598CEF',
      order: 12
    },
    CreatedByUser: null,
    Documents: [],
    linkedToCE: true,
    fd: 1578,
    nfd: 1578
  }
]

export const eventsMocks = [
  {
    event: {
      id: 'bb97e463-3010-4da6-84e4-cf4ee4fe1e2a',
      name: 'Annulation de titres',
      type: 'cancel',
      isScalar: true,
      elements: [
        {
          method: 'getCompaniesStockAlias',
          name: 'currentCompaniesStock',
          modelType: 'CompaniesStockAlias',
          isOptional: true,
          type: 'dynamic',
          id: '9dbb2ddc-5aae-4ed7-97b7-798188939f8f',
          isScalar: true,
          value:
            '{"id":"2fabac98-de0a-11e9-bb02-0e04bd33b2e4","name":"BCE 2017","isPrincipal":true,"color":null,"isCombined":false,"isComposed":true,"inNFD":false,"inFD":true,"inESOP":true,"inValoGraph":false,"expireAt":null,"companiesStockId":"9c395b54-3cdd-4bc6-8f81-419462828476","stockId":"a7ad7eee-83a0-4fbe-ad4f-1557dfd11f16","composedStock":{"id":"9fd7ce67-5b43-48e4-88e9-61974808e0cc","name":"AO Gen 2","parity":1}}',
          ptag: {
            name: 'oldStock',
            id: 'b7c6061c-e25a-4dff-8703-55e52e543bde'
          },
          order: 0
        },
        {
          name: 'contact',
          modelType: 'Contact',
          isOptional: true,
          type: 'model',
          id: '06679ccb-9e03-415a-bac1-db2b325020f6',
          isScalar: true,
          value:
            '{"key":"Lucas Sala","id":"e858ce4a-c678-11ea-ab94-068d0b27b94e","options":{"id":"e858ce4a-c678-11ea-ab94-068d0b27b94e","firstname":"Lucas","lastname":"Sala","denomination":null,"type":"NATURAL","pictureUrl":"https://uplaw-dev-public-content.s3.eu-west-3.amazonaws.com/pictures/c1610166-cf4c-49d3-92a1-ae80d4302719/e858ce4a-c678-11ea-ab94-068d0b27b94e.jpg?v=1594771200000","color":null,"representativeContact":null,"formType":null,"group":{"id":"17e33530-c245-42b9-a06f-2bce943661a7","name":"others","color":"598CEF","order":13}}}',
          ptag: {
            name: 'contact',
            id: 'af5cbd7f-1924-4731-a6a7-bf67a228e98d'
          },
          order: 1
        },
        {
          name: 'quantity',
          modelType: null,
          isOptional: true,
          type: 'integer',
          id: 'ddfcf2e1-0df4-4c2f-b1d2-bcfadea4750f',
          isScalar: true,
          ptag: {
            name: 'quantity',
            id: '58e75274-7c6b-4e27-ac4c-e08eb8a24d66'
          },
          order: 2
        },
        {
          name: 'finalExitAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: '3754ca58-d4ee-4642-8387-03b40ac3454c',
          isScalar: true,
          value: '2020-07-05',
          ptag: {
            name: 'endDate',
            id: 'bbf6c789-ced3-47c3-8b85-161157218484'
          },
          order: 3
        }
      ],
      eventGroup: {
        id: '63525afd-e402-4161-a3c9-475092c0a307',
        name: 'Titres'
      },
      processes: [
        {
          name: 'cancelVesting',
          ptags: null,
          id: 'ba102a3e-934b-41bd-aff6-d546688d6817'
        },
        {
          name: 'cancelStock',
          ptags: null,
          id: 'e6ae02a8-33f3-4330-9d01-527d544d1606'
        }
      ],
      timelineTags: []
    },
    effectiveAt: '2020-07-05',
    effectiveAtSearch: '05/07/2020',
    isDraft: false,
    documents: [
      {
        documentType: {
          timelineTags: [],
          name: 'import | Acte enregistré (Statuts)',
          id: '9a3253a0-73d0-11e8-9c67-fa163ecedb5e'
        },
        name: 'democorp',
        signedAt: null,
        id: '5f3a4f14-13b2-11eb-8d78-068d0b27b94e'
      }
    ],
    companyId: 'c1610166-cf4c-49d3-92a1-ae80d4302719',
    hash: '600505d79006d26f00d9ef51abc51d1699f9418af3ea1399e3140547f2f571de',
    audits: [],
    locked: false,
    id: 'eb2a0563-c739-11ea-ab94-068d0b27b94e'
  },
  {
    event: {
      id: 'bb97e463-3010-4da6-84e4-cf4ee4fe1e2a',
      name: 'Annulation de titres',
      type: 'cancel',
      isScalar: true,
      elements: [
        {
          method: 'getCompaniesStockAlias',
          name: 'currentCompaniesStock',
          modelType: 'CompaniesStockAlias',
          isOptional: true,
          type: 'dynamic',
          id: '9dbb2ddc-5aae-4ed7-97b7-798188939f8f',
          isScalar: true,
          value:
            '{"id":"2fabac98-de0a-11e9-bb02-0e04bd33b2e4","name":"BCE 2017","isPrincipal":true,"color":null,"isCombined":false,"isComposed":true,"inNFD":false,"inFD":true,"inESOP":true,"inValoGraph":false,"expireAt":null,"companiesStockId":"9c395b54-3cdd-4bc6-8f81-419462828476","stockId":"a7ad7eee-83a0-4fbe-ad4f-1557dfd11f16","composedStock":{"id":"9fd7ce67-5b43-48e4-88e9-61974808e0cc","name":"AO Gen 2","parity":1}}',
          ptag: {
            name: 'oldStock',
            id: 'b7c6061c-e25a-4dff-8703-55e52e543bde'
          },
          order: 0
        },
        {
          name: 'contact',
          modelType: 'Contact',
          isOptional: true,
          type: 'model',
          id: '06679ccb-9e03-415a-bac1-db2b325020f6',
          isScalar: true,
          value:
            '{"key":"Florent Chirac","id":"15521bcd-c679-11ea-ab94-068d0b27b94e","options":{"id":"15521bcd-c679-11ea-ab94-068d0b27b94e","firstname":"Florent","lastname":"Chirac","denomination":null,"type":"NATURAL","pictureUrl":"https://uplaw-dev-public-content.s3.eu-west-3.amazonaws.com/pictures/c1610166-cf4c-49d3-92a1-ae80d4302719/15521bcd-c679-11ea-ab94-068d0b27b94e.jpg?v=1594771200000","color":null,"representativeContact":null,"formType":null,"group":{"id":"17e33530-c245-42b9-a06f-2bce943661a7","name":"others","color":"598CEF","order":13}}}',
          ptag: {
            name: 'contact',
            id: 'af5cbd7f-1924-4731-a6a7-bf67a228e98d'
          },
          order: 1
        },
        {
          name: 'quantity',
          modelType: null,
          isOptional: true,
          type: 'integer',
          id: 'ddfcf2e1-0df4-4c2f-b1d2-bcfadea4750f',
          isScalar: true,
          value: '2000',
          ptag: {
            name: 'quantity',
            id: '58e75274-7c6b-4e27-ac4c-e08eb8a24d66'
          },
          order: 2
        },
        {
          name: 'finalExitAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: '3754ca58-d4ee-4642-8387-03b40ac3454c',
          isScalar: true,
          ptag: {
            name: 'endDate',
            id: 'bbf6c789-ced3-47c3-8b85-161157218484'
          },
          order: 3
        }
      ],
      eventGroup: {
        id: '63525afd-e402-4161-a3c9-475092c0a307',
        name: 'Titres'
      },
      processes: [
        {
          name: 'cancelVesting',
          ptags: null,
          id: 'ba102a3e-934b-41bd-aff6-d546688d6817'
        },
        {
          name: 'cancelStock',
          ptags: null,
          id: 'e6ae02a8-33f3-4330-9d01-527d544d1606'
        }
      ],
      timelineTags: []
    },
    effectiveAt: '2020-07-05',
    effectiveAtSearch: '05/07/2020',
    isDraft: false,
    documents: [
      {
        documentType: {
          timelineTags: [],
          name: 'import | Acte enregistré (Statuts)',
          id: '9a3253a0-73d0-11e8-9c67-fa163ecedb5e'
        },
        name: 'democorp',
        signedAt: null,
        id: '5f3a4f14-13b2-11eb-8d78-068d0b27b94e'
      }
    ],
    companyId: 'c1610166-cf4c-49d3-92a1-ae80d4302719',
    hash: '600505d79006d26f00d9ef51abc51d1699f9418af3ea1399e3140547f2f571de',
    audits: [],
    locked: false,
    id: 'a2108a8e-e77d-11ea-8d78-068d0b27b94e'
  },
  {
    event: {
      id: '3130a41c-fc7e-410d-9bc9-a67e4fe7cbec',
      name: 'Emission de titres',
      type: 'emit',
      isScalar: true,
      elements: [
        {
          name: 'CompaniesStock',
          modelType: 'CompaniesStockAlias',
          isOptional: false,
          type: 'model',
          id: '649accdc-5697-4372-a458-eacc48e428e6',
          isScalar: false,
          value:
            '{"id":"2fabac98-de0a-11e9-bb02-0e04bd33b2e4","name":"BCE 2017","isPrincipal":true,"color":null,"isCombined":false,"isComposed":true,"inNFD":false,"inFD":true,"inESOP":true,"inValoGraph":false,"expireAt":null,"companiesStockId":"9c395b54-3cdd-4bc6-8f81-419462828476","stockId":"a7ad7eee-83a0-4fbe-ad4f-1557dfd11f16","composedStock":{"id":"9fd7ce67-5b43-48e4-88e9-61974808e0cc","name":"AO Gen 2","parity":1}}',
          ptag: {
            name: 'companiesStock',
            id: 'cf0f727d-2983-43a7-be3d-01f295d57963'
          },
          order: 0
        },
        {
          method: 'getDelegations',
          name: 'delegation',
          modelType: 'CompaniesEvent',
          isOptional: true,
          type: 'dynamic',
          id: 'e4a58542-735b-4ac1-8652-fff26de4d89b',
          isScalar: false,
          value:
            '{"key":{"effectiveAt":"2020-06-01","name":"Délégation de compétence","priority":2},"id":"e62d1eb4-c679-11ea-ab94-068d0b27b94e"}',
          ptag: {
            name: 'delegation',
            id: '78fd4cce-b813-4d7e-8ab3-ad766fc14505'
          },
          order: 1
        },
        {
          name: 'contact',
          modelType: 'Contact',
          isOptional: false,
          type: 'model',
          id: '06679ccb-9e03-415a-bac1-db2b325020f6',
          isScalar: true,
          value:
            '{"key":"Roseline-Mathis Brun","id":"dbb4d070-c678-11ea-ab94-068d0b27b94e","options":{"id":"dbb4d070-c678-11ea-ab94-068d0b27b94e","firstname":"Roseline-Mathis","lastname":"Brun","denomination":null,"type":"NATURAL","pictureUrl":"https://uplaw-dev-public-content.s3.eu-west-3.amazonaws.com/pictures/c1610166-cf4c-49d3-92a1-ae80d4302719/dbb4d070-c678-11ea-ab94-068d0b27b94e.jpg?v=1594771200000","color":null,"representativeContact":null,"formType":null,"group":{"id":"17e33530-c245-42b9-a06f-2bce943661a7","name":"others","color":"598CEF","order":13}}}',
          ptag: {
            name: 'contact',
            id: 'af5cbd7f-1924-4731-a6a7-bf67a228e98d'
          },
          order: 2
        },
        {
          name: 'quantity',
          modelType: null,
          isOptional: false,
          type: 'integer',
          id: 'ddfcf2e1-0df4-4c2f-b1d2-bcfadea4750f',
          isScalar: true,
          value: '2000',
          ptag: {
            name: 'quantity',
            id: '58e75274-7c6b-4e27-ac4c-e08eb8a24d66'
          },
          order: 3
        },
        {
          name: 'parity',
          modelType: null,
          isOptional: true,
          type: 'double',
          id: 'e91a2149-c077-4cc0-8e0f-cd3bbebc653c',
          isScalar: true,
          ptag: {
            name: 'parity',
            id: '87335f2b-3461-414e-8917-e9fb8e7e13e4'
          },
          order: 4
        },
        {
          name: 'subscriptionPrice',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: '5d628535-e875-4d76-8945-34c0d5644190',
          isScalar: true,
          value: '0',
          ptag: {
            name: 'subscriptionPrice',
            id: '6f2b0ec5-3296-4f2d-b6c7-c8c558e8639b'
          },
          order: 5
        },
        {
          name: 'exercisePrice',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: 'acc9e613-e52f-477b-bbf4-7be37c56af7e',
          isScalar: true,
          value: '90',
          ptag: {
            name: 'exercisePrice',
            id: '3a52986b-5d3d-4d38-b956-11f5201a8b41'
          },
          order: 6
        },
        {
          name: 'liberatedAmount',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: '47eb9ae4-8ecb-4e18-8dfe-9e0ef503316a',
          isScalar: true,
          ptag: {
            name: 'liberatedAmount',
            id: '28ebec26-9c4b-44be-9778-7bd2056db8da'
          },
          order: 7
        },
        {
          name: 'expireAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: 'bc082efd-7ea5-4eba-934c-46057c79d204',
          isScalar: true,
          value: '2030-06-01',
          ptag: {
            name: 'endDate',
            id: 'bbf6c789-ced3-47c3-8b85-161157218484'
          },
          order: 8
        },
        {
          name: 'vesting',
          modelType: 'CompaniesVesting',
          isOptional: true,
          type: 'model',
          id: '4dfa00c6-7f03-47bf-97c5-a98ac76d3cd5',
          isScalar: true,
          value:
            '{"id":"6bcdb585-c67a-11ea-ab94-068d0b27b94e","name":"BSPCE2017-1","exerciseDelayUnit":null,"exerciseDelayQuantity":null,"useSplitValue":false,"vestingPeriods":[{"id":"7131f3b2-16cb-439c-bceb-8862d409eac5","order":0,"quantity":null,"percentage":0,"fraction":null,"periodUnit":"DAYS","periodQty":0,"periodType":"VESTING","startDateType":"ENTRY","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"ANNIVERSARY"},{"id":"41a4b010-e38a-4488-a9a0-726007ef2de7","order":1,"quantity":null,"percentage":25,"fraction":null,"periodUnit":"MONTHS","periodQty":12,"periodType":"WAIT","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"ANNIVERSARY"},{"id":"8368a55c-335f-4635-839c-34fd0862fc19","order":2,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"8fad6f2e-cba9-4a7e-8ee4-9ba5bcc5ca66","order":3,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"64e23373-e4f9-4a95-8000-98cbee8e56a3","order":4,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"e5d15ebd-8a1b-40b3-b35c-caf9e4aca233","order":5,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"899c7267-fde9-44bc-86e2-5a29fbf647ae","order":6,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f876c88f-cf55-4447-83f2-5af47aa8fcf6","order":7,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"7bcf3559-ed00-4900-8dbb-4c0926d4a0c1","order":8,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"9904da0d-5ecf-4ac2-85d6-f79df00beb40","order":9,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"d24a9664-56b6-4fad-a876-5f1210fa5e6d","order":10,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"8996df1d-83b0-4dd1-82ff-8a049fdbb2e7","order":11,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"889ce04a-8c29-48c1-9599-516a103d03d1","order":12,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"69cbce43-769e-4fc0-b78b-507a949c22d1","order":13,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"2b0726cf-bbfa-497d-86d5-d69d810b606a","order":14,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"5a7ead1d-6dd9-4c52-8edd-117bcac016b2","order":15,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f533a15c-53d1-4eed-937d-ea0fea0c61f6","order":16,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"b870da00-a85f-431d-ab68-3e9bece39802","order":17,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"39e51db7-e6ba-485b-a5eb-30bdd02c7945","order":18,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"3687f079-bb21-45bf-a90d-6c804956f826","order":19,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"60db5a08-d255-4ac3-818d-50520f096542","order":20,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"cb8d0288-4a15-4bc7-b070-6a2932c1d944","order":21,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"55315ecb-5441-48fa-8814-1cb60c053330","order":22,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"9d26964d-1515-4e54-b784-7959978bac5d","order":23,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"24d47438-7fad-4fc8-af46-f948ffd82ff8","order":24,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"9b0f2747-30f1-45e5-bf90-f1d0c9d9b4b7","order":25,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f5881fd8-b6d3-4571-b9eb-937df493fc62","order":26,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"a4f99b4d-9090-436a-84f2-c89f722c80c4","order":27,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"43438a17-f5b7-444e-8b88-a3c909454cb9","order":28,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f1dc69d8-0bf3-452a-b779-46eca915410e","order":29,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"ee774449-140f-4450-a34f-0d5bdd20028b","order":30,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"658e1423-35c3-4473-a47f-41db58ce87e7","order":31,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"1e528b38-5787-4118-82b6-dfa1e4d1c7ba","order":32,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"02dd17a5-0d59-47b4-b82b-88abd35d42d1","order":33,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"c739d132-48f4-475c-a610-ccd149369d6f","order":34,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"6ec70f7a-cabd-4008-9df0-adeb3479eeb3","order":35,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"82b40382-628b-4906-9c71-42e903d8d1fa","order":36,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"bd1d7d82-7d2c-47e2-b4e9-80833cedf705","order":37,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"ANNIVERSARY"}]}',
          ptag: {
            name: 'vesting',
            id: '466a5e2b-9b98-42f8-b49b-7ad3c5001c73'
          },
          order: 9
        },
        {
          name: 'startAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: 'e96fcf7c-0856-4de6-ae8f-c41ccc4694f7',
          isScalar: true,
          ptag: {
            name: 'startDate',
            id: '9bc9e5ac-aa2a-42e1-9c92-50abd2c8c763'
          },
          order: 10
        }
      ],
      eventGroup: {
        id: '63525afd-e402-4161-a3c9-475092c0a307',
        name: 'Titres'
      },
      processes: [
        {
          name: 'emitStock',
          ptags: null,
          id: '30bbf0ba-93f5-498c-85a7-549a17c97eb6'
        },
        {
          name: 'cancelDelegation',
          ptags: null,
          id: '5c4c761a-f568-40c7-95e5-14634d8eb164'
        },
        {
          name: 'createVesting',
          ptags: null,
          id: 'c637258e-6bd1-4934-8be9-827daffa4535'
        }
      ],
      timelineTags: []
    },
    effectiveAt: '2020-06-01',
    effectiveAtSearch: '01/06/2020',
    isDraft: false,
    documents: [
      {
        documentType: {
          timelineTags: [],
          name: 'import | Acte enregistré (Statuts)',
          id: '9a3253a0-73d0-11e8-9c67-fa163ecedb5e'
        },
        name: 'democorp',
        signedAt: null,
        id: '5f3a4f14-13b2-11eb-8d78-068d0b27b94e'
      }
    ],
    companyId: 'c1610166-cf4c-49d3-92a1-ae80d4302719',
    hash: '229f65fc36069dac378151d47d722ca2e2b9d9c0cb6aa247c4e7c9998a2fbf21',
    audits: [],
    locked: false,
    id: '2ef3707a-c67d-11ea-ab94-068d0b27b94e'
  },
  {
    event: {
      id: '3130a41c-fc7e-410d-9bc9-a67e4fe7cbec',
      name: 'Emission de titres',
      type: 'emit',
      isScalar: true,
      elements: [
        {
          name: 'CompaniesStock',
          modelType: 'CompaniesStockAlias',
          isOptional: false,
          type: 'model',
          id: '649accdc-5697-4372-a458-eacc48e428e6',
          isScalar: false,
          value:
            '{"id":"2fabac98-de0a-11e9-bb02-0e04bd33b2e4","name":"BCE 2017","isPrincipal":true,"color":null,"isCombined":false,"isComposed":true,"inNFD":false,"inFD":true,"inESOP":true,"inValoGraph":false,"expireAt":null,"companiesStockId":"9c395b54-3cdd-4bc6-8f81-419462828476","stockId":"a7ad7eee-83a0-4fbe-ad4f-1557dfd11f16","composedStock":{"id":"9fd7ce67-5b43-48e4-88e9-61974808e0cc","name":"AO Gen 2","parity":1}}',
          ptag: {
            name: 'companiesStock',
            id: 'cf0f727d-2983-43a7-be3d-01f295d57963'
          },
          order: 0
        },
        {
          method: 'getDelegations',
          name: 'delegation',
          modelType: 'CompaniesEvent',
          isOptional: true,
          type: 'dynamic',
          id: 'e4a58542-735b-4ac1-8652-fff26de4d89b',
          isScalar: false,
          value:
            '{"key":{"effectiveAt":"2020-06-01","name":"Délégation de compétence","priority":2},"id":"e62d1eb4-c679-11ea-ab94-068d0b27b94e"}',
          ptag: {
            name: 'delegation',
            id: '78fd4cce-b813-4d7e-8ab3-ad766fc14505'
          },
          order: 1
        },
        {
          name: 'contact',
          modelType: 'Contact',
          isOptional: false,
          type: 'model',
          id: '06679ccb-9e03-415a-bac1-db2b325020f6',
          isScalar: true,
          value:
            '{"key":"Moïse  Guerard","id":"a76d4ce5-c678-11ea-ab94-068d0b27b94e","options":{"id":"a76d4ce5-c678-11ea-ab94-068d0b27b94e","firstname":"Moïse ","lastname":"Guerard","denomination":null,"type":"NATURAL","pictureUrl":"https://uplaw-dev-public-content.s3.eu-west-3.amazonaws.com/pictures/c1610166-cf4c-49d3-92a1-ae80d4302719/a76d4ce5-c678-11ea-ab94-068d0b27b94e.jpg?v=1594771200000","color":null,"representativeContact":null,"formType":null,"group":{"id":"17e33530-c245-42b9-a06f-2bce943661a7","name":"others","color":"598CEF","order":13}}}',
          ptag: {
            name: 'contact',
            id: 'af5cbd7f-1924-4731-a6a7-bf67a228e98d'
          },
          order: 2
        },
        {
          name: 'quantity',
          modelType: null,
          isOptional: false,
          type: 'integer',
          id: 'ddfcf2e1-0df4-4c2f-b1d2-bcfadea4750f',
          isScalar: true,
          value: '2000',
          ptag: {
            name: 'quantity',
            id: '58e75274-7c6b-4e27-ac4c-e08eb8a24d66'
          },
          order: 3
        },
        {
          name: 'parity',
          modelType: null,
          isOptional: true,
          type: 'double',
          id: 'e91a2149-c077-4cc0-8e0f-cd3bbebc653c',
          isScalar: true,
          ptag: {
            name: 'parity',
            id: '87335f2b-3461-414e-8917-e9fb8e7e13e4'
          },
          order: 4
        },
        {
          name: 'subscriptionPrice',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: '5d628535-e875-4d76-8945-34c0d5644190',
          isScalar: true,
          value: '0',
          ptag: {
            name: 'subscriptionPrice',
            id: '6f2b0ec5-3296-4f2d-b6c7-c8c558e8639b'
          },
          order: 5
        },
        {
          name: 'exercisePrice',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: 'acc9e613-e52f-477b-bbf4-7be37c56af7e',
          isScalar: true,
          value: '90',
          ptag: {
            name: 'exercisePrice',
            id: '3a52986b-5d3d-4d38-b956-11f5201a8b41'
          },
          order: 6
        },
        {
          name: 'liberatedAmount',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: '47eb9ae4-8ecb-4e18-8dfe-9e0ef503316a',
          isScalar: true,
          ptag: {
            name: 'liberatedAmount',
            id: '28ebec26-9c4b-44be-9778-7bd2056db8da'
          },
          order: 7
        },
        {
          name: 'expireAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: 'bc082efd-7ea5-4eba-934c-46057c79d204',
          isScalar: true,
          value: '2030-06-01',
          ptag: {
            name: 'endDate',
            id: 'bbf6c789-ced3-47c3-8b85-161157218484'
          },
          order: 8
        },
        {
          name: 'vesting',
          modelType: 'CompaniesVesting',
          isOptional: true,
          type: 'model',
          id: '4dfa00c6-7f03-47bf-97c5-a98ac76d3cd5',
          isScalar: true,
          value:
            '{"id":"6bcdb585-c67a-11ea-ab94-068d0b27b94e","name":"BSPCE2017-1","exerciseDelayUnit":null,"exerciseDelayQuantity":null,"useSplitValue":false,"vestingPeriods":[{"id":"7131f3b2-16cb-439c-bceb-8862d409eac5","order":0,"quantity":null,"percentage":0,"fraction":null,"periodUnit":"DAYS","periodQty":0,"periodType":"VESTING","startDateType":"ENTRY","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"ANNIVERSARY"},{"id":"41a4b010-e38a-4488-a9a0-726007ef2de7","order":1,"quantity":null,"percentage":25,"fraction":null,"periodUnit":"MONTHS","periodQty":12,"periodType":"WAIT","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"ANNIVERSARY"},{"id":"8368a55c-335f-4635-839c-34fd0862fc19","order":2,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"8fad6f2e-cba9-4a7e-8ee4-9ba5bcc5ca66","order":3,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"64e23373-e4f9-4a95-8000-98cbee8e56a3","order":4,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"e5d15ebd-8a1b-40b3-b35c-caf9e4aca233","order":5,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"899c7267-fde9-44bc-86e2-5a29fbf647ae","order":6,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f876c88f-cf55-4447-83f2-5af47aa8fcf6","order":7,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"7bcf3559-ed00-4900-8dbb-4c0926d4a0c1","order":8,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"9904da0d-5ecf-4ac2-85d6-f79df00beb40","order":9,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"d24a9664-56b6-4fad-a876-5f1210fa5e6d","order":10,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"8996df1d-83b0-4dd1-82ff-8a049fdbb2e7","order":11,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"889ce04a-8c29-48c1-9599-516a103d03d1","order":12,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"69cbce43-769e-4fc0-b78b-507a949c22d1","order":13,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"2b0726cf-bbfa-497d-86d5-d69d810b606a","order":14,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"5a7ead1d-6dd9-4c52-8edd-117bcac016b2","order":15,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f533a15c-53d1-4eed-937d-ea0fea0c61f6","order":16,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"b870da00-a85f-431d-ab68-3e9bece39802","order":17,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"39e51db7-e6ba-485b-a5eb-30bdd02c7945","order":18,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"3687f079-bb21-45bf-a90d-6c804956f826","order":19,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"60db5a08-d255-4ac3-818d-50520f096542","order":20,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"cb8d0288-4a15-4bc7-b070-6a2932c1d944","order":21,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"55315ecb-5441-48fa-8814-1cb60c053330","order":22,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"9d26964d-1515-4e54-b784-7959978bac5d","order":23,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"24d47438-7fad-4fc8-af46-f948ffd82ff8","order":24,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"9b0f2747-30f1-45e5-bf90-f1d0c9d9b4b7","order":25,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f5881fd8-b6d3-4571-b9eb-937df493fc62","order":26,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"a4f99b4d-9090-436a-84f2-c89f722c80c4","order":27,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"43438a17-f5b7-444e-8b88-a3c909454cb9","order":28,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f1dc69d8-0bf3-452a-b779-46eca915410e","order":29,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"ee774449-140f-4450-a34f-0d5bdd20028b","order":30,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"658e1423-35c3-4473-a47f-41db58ce87e7","order":31,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"1e528b38-5787-4118-82b6-dfa1e4d1c7ba","order":32,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"02dd17a5-0d59-47b4-b82b-88abd35d42d1","order":33,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"c739d132-48f4-475c-a610-ccd149369d6f","order":34,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"6ec70f7a-cabd-4008-9df0-adeb3479eeb3","order":35,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"82b40382-628b-4906-9c71-42e903d8d1fa","order":36,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"bd1d7d82-7d2c-47e2-b4e9-80833cedf705","order":37,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"ANNIVERSARY"}]}',
          ptag: {
            name: 'vesting',
            id: '466a5e2b-9b98-42f8-b49b-7ad3c5001c73'
          },
          order: 9
        },
        {
          name: 'startAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: 'e96fcf7c-0856-4de6-ae8f-c41ccc4694f7',
          isScalar: true,
          ptag: {
            name: 'startDate',
            id: '9bc9e5ac-aa2a-42e1-9c92-50abd2c8c763'
          },
          order: 10
        }
      ],
      eventGroup: {
        id: '63525afd-e402-4161-a3c9-475092c0a307',
        name: 'Titres'
      },
      processes: [
        {
          name: 'emitStock',
          ptags: null,
          id: '30bbf0ba-93f5-498c-85a7-549a17c97eb6'
        },
        {
          name: 'cancelDelegation',
          ptags: null,
          id: '5c4c761a-f568-40c7-95e5-14634d8eb164'
        },
        {
          name: 'createVesting',
          ptags: null,
          id: 'c637258e-6bd1-4934-8be9-827daffa4535'
        }
      ],
      timelineTags: []
    },
    effectiveAt: '2020-06-01',
    effectiveAtSearch: '01/06/2020',
    isDraft: false,
    documents: [
      {
        documentType: {
          timelineTags: [],
          name: 'import | Acte enregistré (Statuts)',
          id: '9a3253a0-73d0-11e8-9c67-fa163ecedb5e'
        },
        name: 'democorp',
        signedAt: null,
        id: '5f3a4f14-13b2-11eb-8d78-068d0b27b94e'
      }
    ],
    companyId: 'c1610166-cf4c-49d3-92a1-ae80d4302719',
    hash: '229f65fc36069dac378151d47d722ca2e2b9d9c0cb6aa247c4e7c9998a2fbf21',
    audits: [],
    locked: false,
    id: '2ef32fc8-c67d-11ea-ab94-068d0b27b94e'
  },
  {
    event: {
      id: '3130a41c-fc7e-410d-9bc9-a67e4fe7cbec',
      name: 'Emission de titres',
      type: 'emit',
      isScalar: true,
      elements: [
        {
          name: 'CompaniesStock',
          modelType: 'CompaniesStockAlias',
          isOptional: false,
          type: 'model',
          id: '649accdc-5697-4372-a458-eacc48e428e6',
          isScalar: false,
          value:
            '{"id":"2fabac98-de0a-11e9-bb02-0e04bd33b2e4","name":"BCE 2017","isPrincipal":true,"color":null,"isCombined":false,"isComposed":true,"inNFD":false,"inFD":true,"inESOP":true,"inValoGraph":false,"expireAt":null,"companiesStockId":"9c395b54-3cdd-4bc6-8f81-419462828476","stockId":"a7ad7eee-83a0-4fbe-ad4f-1557dfd11f16","composedStock":{"id":"9fd7ce67-5b43-48e4-88e9-61974808e0cc","name":"AO Gen 2","parity":1}}',
          ptag: {
            name: 'companiesStock',
            id: 'cf0f727d-2983-43a7-be3d-01f295d57963'
          },
          order: 0
        },
        {
          method: 'getDelegations',
          name: 'delegation',
          modelType: 'CompaniesEvent',
          isOptional: true,
          type: 'dynamic',
          id: 'e4a58542-735b-4ac1-8652-fff26de4d89b',
          isScalar: false,
          value:
            '{"key":{"effectiveAt":"2020-06-01","name":"Délégation de compétence","priority":2},"id":"e62d1eb4-c679-11ea-ab94-068d0b27b94e"}',
          ptag: {
            name: 'delegation',
            id: '78fd4cce-b813-4d7e-8ab3-ad766fc14505'
          },
          order: 1
        },
        {
          name: 'contact',
          modelType: 'Contact',
          isOptional: false,
          type: 'model',
          id: '06679ccb-9e03-415a-bac1-db2b325020f6',
          isScalar: true,
          value:
            '{"key":"Florence Lasserre","id":"2a24d344-c678-11ea-ab94-068d0b27b94e","options":{"id":"2a24d344-c678-11ea-ab94-068d0b27b94e","firstname":"Florence","lastname":"Lasserre","denomination":null,"type":"NATURAL","pictureUrl":"https://uplaw-dev-public-content.s3.eu-west-3.amazonaws.com/pictures/c1610166-cf4c-49d3-92a1-ae80d4302719/2a24d344-c678-11ea-ab94-068d0b27b94e.jpg?v=1594771200000","color":null,"representativeContact":null,"formType":null,"group":{"id":"17e33530-c245-42b9-a06f-2bce943661a7","name":"others","color":"598CEF","order":13}}}',
          ptag: {
            name: 'contact',
            id: 'af5cbd7f-1924-4731-a6a7-bf67a228e98d'
          },
          order: 2
        },
        {
          name: 'quantity',
          modelType: null,
          isOptional: false,
          type: 'integer',
          id: 'ddfcf2e1-0df4-4c2f-b1d2-bcfadea4750f',
          isScalar: true,
          value: '2000',
          ptag: {
            name: 'quantity',
            id: '58e75274-7c6b-4e27-ac4c-e08eb8a24d66'
          },
          order: 3
        },
        {
          name: 'parity',
          modelType: null,
          isOptional: true,
          type: 'double',
          id: 'e91a2149-c077-4cc0-8e0f-cd3bbebc653c',
          isScalar: true,
          ptag: {
            name: 'parity',
            id: '87335f2b-3461-414e-8917-e9fb8e7e13e4'
          },
          order: 4
        },
        {
          name: 'subscriptionPrice',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: '5d628535-e875-4d76-8945-34c0d5644190',
          isScalar: true,
          value: '0',
          ptag: {
            name: 'subscriptionPrice',
            id: '6f2b0ec5-3296-4f2d-b6c7-c8c558e8639b'
          },
          order: 5
        },
        {
          name: 'exercisePrice',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: 'acc9e613-e52f-477b-bbf4-7be37c56af7e',
          isScalar: true,
          value: '90',
          ptag: {
            name: 'exercisePrice',
            id: '3a52986b-5d3d-4d38-b956-11f5201a8b41'
          },
          order: 6
        },
        {
          name: 'liberatedAmount',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: '47eb9ae4-8ecb-4e18-8dfe-9e0ef503316a',
          isScalar: true,
          ptag: {
            name: 'liberatedAmount',
            id: '28ebec26-9c4b-44be-9778-7bd2056db8da'
          },
          order: 7
        },
        {
          name: 'expireAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: 'bc082efd-7ea5-4eba-934c-46057c79d204',
          isScalar: true,
          value: '2030-06-01',
          ptag: {
            name: 'endDate',
            id: 'bbf6c789-ced3-47c3-8b85-161157218484'
          },
          order: 8
        },
        {
          name: 'vesting',
          modelType: 'CompaniesVesting',
          isOptional: true,
          type: 'model',
          id: '4dfa00c6-7f03-47bf-97c5-a98ac76d3cd5',
          isScalar: true,
          value:
            '{"id":"6bcdb585-c67a-11ea-ab94-068d0b27b94e","name":"BSPCE2017-1","exerciseDelayUnit":null,"exerciseDelayQuantity":null,"useSplitValue":false,"vestingPeriods":[{"id":"7131f3b2-16cb-439c-bceb-8862d409eac5","order":0,"quantity":null,"percentage":0,"fraction":null,"periodUnit":"DAYS","periodQty":0,"periodType":"VESTING","startDateType":"ENTRY","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"ANNIVERSARY"},{"id":"41a4b010-e38a-4488-a9a0-726007ef2de7","order":1,"quantity":null,"percentage":25,"fraction":null,"periodUnit":"MONTHS","periodQty":12,"periodType":"WAIT","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"ANNIVERSARY"},{"id":"8368a55c-335f-4635-839c-34fd0862fc19","order":2,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"8fad6f2e-cba9-4a7e-8ee4-9ba5bcc5ca66","order":3,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"64e23373-e4f9-4a95-8000-98cbee8e56a3","order":4,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"e5d15ebd-8a1b-40b3-b35c-caf9e4aca233","order":5,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"899c7267-fde9-44bc-86e2-5a29fbf647ae","order":6,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f876c88f-cf55-4447-83f2-5af47aa8fcf6","order":7,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"7bcf3559-ed00-4900-8dbb-4c0926d4a0c1","order":8,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"9904da0d-5ecf-4ac2-85d6-f79df00beb40","order":9,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"d24a9664-56b6-4fad-a876-5f1210fa5e6d","order":10,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"8996df1d-83b0-4dd1-82ff-8a049fdbb2e7","order":11,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"889ce04a-8c29-48c1-9599-516a103d03d1","order":12,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"69cbce43-769e-4fc0-b78b-507a949c22d1","order":13,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"2b0726cf-bbfa-497d-86d5-d69d810b606a","order":14,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"5a7ead1d-6dd9-4c52-8edd-117bcac016b2","order":15,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f533a15c-53d1-4eed-937d-ea0fea0c61f6","order":16,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"b870da00-a85f-431d-ab68-3e9bece39802","order":17,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"39e51db7-e6ba-485b-a5eb-30bdd02c7945","order":18,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"3687f079-bb21-45bf-a90d-6c804956f826","order":19,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"60db5a08-d255-4ac3-818d-50520f096542","order":20,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"cb8d0288-4a15-4bc7-b070-6a2932c1d944","order":21,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"55315ecb-5441-48fa-8814-1cb60c053330","order":22,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"9d26964d-1515-4e54-b784-7959978bac5d","order":23,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"24d47438-7fad-4fc8-af46-f948ffd82ff8","order":24,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"9b0f2747-30f1-45e5-bf90-f1d0c9d9b4b7","order":25,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f5881fd8-b6d3-4571-b9eb-937df493fc62","order":26,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"a4f99b4d-9090-436a-84f2-c89f722c80c4","order":27,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"43438a17-f5b7-444e-8b88-a3c909454cb9","order":28,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f1dc69d8-0bf3-452a-b779-46eca915410e","order":29,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"ee774449-140f-4450-a34f-0d5bdd20028b","order":30,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"658e1423-35c3-4473-a47f-41db58ce87e7","order":31,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"1e528b38-5787-4118-82b6-dfa1e4d1c7ba","order":32,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"02dd17a5-0d59-47b4-b82b-88abd35d42d1","order":33,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"c739d132-48f4-475c-a610-ccd149369d6f","order":34,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"6ec70f7a-cabd-4008-9df0-adeb3479eeb3","order":35,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"82b40382-628b-4906-9c71-42e903d8d1fa","order":36,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"bd1d7d82-7d2c-47e2-b4e9-80833cedf705","order":37,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"ANNIVERSARY"}]}',
          ptag: {
            name: 'vesting',
            id: '466a5e2b-9b98-42f8-b49b-7ad3c5001c73'
          },
          order: 9
        },
        {
          name: 'startAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: 'e96fcf7c-0856-4de6-ae8f-c41ccc4694f7',
          isScalar: true,
          ptag: {
            name: 'startDate',
            id: '9bc9e5ac-aa2a-42e1-9c92-50abd2c8c763'
          },
          order: 10
        }
      ],
      eventGroup: {
        id: '63525afd-e402-4161-a3c9-475092c0a307',
        name: 'Titres'
      },
      processes: [
        {
          name: 'emitStock',
          ptags: null,
          id: '30bbf0ba-93f5-498c-85a7-549a17c97eb6'
        },
        {
          name: 'cancelDelegation',
          ptags: null,
          id: '5c4c761a-f568-40c7-95e5-14634d8eb164'
        },
        {
          name: 'createVesting',
          ptags: null,
          id: 'c637258e-6bd1-4934-8be9-827daffa4535'
        }
      ],
      timelineTags: []
    },
    effectiveAt: '2020-06-01',
    effectiveAtSearch: '01/06/2020',
    isDraft: false,
    documents: [
      {
        documentType: {
          timelineTags: [],
          name: 'import | Acte enregistré (Statuts)',
          id: '9a3253a0-73d0-11e8-9c67-fa163ecedb5e'
        },
        name: 'democorp',
        signedAt: null,
        id: '5f3a4f14-13b2-11eb-8d78-068d0b27b94e'
      }
    ],
    companyId: 'c1610166-cf4c-49d3-92a1-ae80d4302719',
    hash: '229f65fc36069dac378151d47d722ca2e2b9d9c0cb6aa247c4e7c9998a2fbf21',
    audits: [],
    locked: false,
    id: '2ef2e127-c67d-11ea-ab94-068d0b27b94e'
  },
  {
    event: {
      id: '3130a41c-fc7e-410d-9bc9-a67e4fe7cbec',
      name: 'Emission de titres',
      type: 'emit',
      isScalar: true,
      elements: [
        {
          name: 'CompaniesStock',
          modelType: 'CompaniesStockAlias',
          isOptional: false,
          type: 'model',
          id: '649accdc-5697-4372-a458-eacc48e428e6',
          isScalar: false,
          value:
            '{"id":"2fabac98-de0a-11e9-bb02-0e04bd33b2e4","name":"BCE 2017","isPrincipal":true,"color":null,"isCombined":false,"isComposed":true,"inNFD":false,"inFD":true,"inESOP":true,"inValoGraph":false,"expireAt":null,"companiesStockId":"9c395b54-3cdd-4bc6-8f81-419462828476","stockId":"a7ad7eee-83a0-4fbe-ad4f-1557dfd11f16","composedStock":{"id":"9fd7ce67-5b43-48e4-88e9-61974808e0cc","name":"AO Gen 2","parity":1}}',
          ptag: {
            name: 'companiesStock',
            id: 'cf0f727d-2983-43a7-be3d-01f295d57963'
          },
          order: 0
        },
        {
          method: 'getDelegations',
          name: 'delegation',
          modelType: 'CompaniesEvent',
          isOptional: true,
          type: 'dynamic',
          id: 'e4a58542-735b-4ac1-8652-fff26de4d89b',
          isScalar: false,
          value:
            '{"key":{"effectiveAt":"2020-06-01","name":"Délégation de compétence","priority":2},"id":"e62d1eb4-c679-11ea-ab94-068d0b27b94e"}',
          ptag: {
            name: 'delegation',
            id: '78fd4cce-b813-4d7e-8ab3-ad766fc14505'
          },
          order: 1
        },
        {
          name: 'contact',
          modelType: 'Contact',
          isOptional: false,
          type: 'model',
          id: '06679ccb-9e03-415a-bac1-db2b325020f6',
          isScalar: true,
          value:
            '{"key":"Lucas Sala","id":"e858ce4a-c678-11ea-ab94-068d0b27b94e","options":{"id":"e858ce4a-c678-11ea-ab94-068d0b27b94e","firstname":"Lucas","lastname":"Sala","denomination":null,"type":"NATURAL","pictureUrl":"https://uplaw-dev-public-content.s3.eu-west-3.amazonaws.com/pictures/c1610166-cf4c-49d3-92a1-ae80d4302719/e858ce4a-c678-11ea-ab94-068d0b27b94e.jpg?v=1594771200000","color":null,"representativeContact":null,"formType":null,"group":{"id":"17e33530-c245-42b9-a06f-2bce943661a7","name":"others","color":"598CEF","order":13}}}',
          ptag: {
            name: 'contact',
            id: 'af5cbd7f-1924-4731-a6a7-bf67a228e98d'
          },
          order: 2
        },
        {
          name: 'quantity',
          modelType: null,
          isOptional: false,
          type: 'integer',
          id: 'ddfcf2e1-0df4-4c2f-b1d2-bcfadea4750f',
          isScalar: true,
          value: '2000',
          ptag: {
            name: 'quantity',
            id: '58e75274-7c6b-4e27-ac4c-e08eb8a24d66'
          },
          order: 3
        },
        {
          name: 'parity',
          modelType: null,
          isOptional: true,
          type: 'double',
          id: 'e91a2149-c077-4cc0-8e0f-cd3bbebc653c',
          isScalar: true,
          ptag: {
            name: 'parity',
            id: '87335f2b-3461-414e-8917-e9fb8e7e13e4'
          },
          order: 4
        },
        {
          name: 'subscriptionPrice',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: '5d628535-e875-4d76-8945-34c0d5644190',
          isScalar: true,
          value: '0',
          ptag: {
            name: 'subscriptionPrice',
            id: '6f2b0ec5-3296-4f2d-b6c7-c8c558e8639b'
          },
          order: 5
        },
        {
          name: 'exercisePrice',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: 'acc9e613-e52f-477b-bbf4-7be37c56af7e',
          isScalar: true,
          value: '90',
          ptag: {
            name: 'exercisePrice',
            id: '3a52986b-5d3d-4d38-b956-11f5201a8b41'
          },
          order: 6
        },
        {
          name: 'liberatedAmount',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: '47eb9ae4-8ecb-4e18-8dfe-9e0ef503316a',
          isScalar: true,
          ptag: {
            name: 'liberatedAmount',
            id: '28ebec26-9c4b-44be-9778-7bd2056db8da'
          },
          order: 7
        },
        {
          name: 'expireAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: 'bc082efd-7ea5-4eba-934c-46057c79d204',
          isScalar: true,
          value: '2030-06-01',
          ptag: {
            name: 'endDate',
            id: 'bbf6c789-ced3-47c3-8b85-161157218484'
          },
          order: 8
        },
        {
          name: 'vesting',
          modelType: 'CompaniesVesting',
          isOptional: true,
          type: 'model',
          id: '4dfa00c6-7f03-47bf-97c5-a98ac76d3cd5',
          isScalar: true,
          value:
            '{"id":"6bcdb585-c67a-11ea-ab94-068d0b27b94e","name":"BSPCE2017-1","exerciseDelayUnit":null,"exerciseDelayQuantity":null,"useSplitValue":false,"vestingPeriods":[{"id":"7131f3b2-16cb-439c-bceb-8862d409eac5","order":0,"quantity":null,"percentage":0,"fraction":null,"periodUnit":"DAYS","periodQty":0,"periodType":"VESTING","startDateType":"ENTRY","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"ANNIVERSARY"},{"id":"41a4b010-e38a-4488-a9a0-726007ef2de7","order":1,"quantity":null,"percentage":25,"fraction":null,"periodUnit":"MONTHS","periodQty":12,"periodType":"WAIT","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"ANNIVERSARY"},{"id":"8368a55c-335f-4635-839c-34fd0862fc19","order":2,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"8fad6f2e-cba9-4a7e-8ee4-9ba5bcc5ca66","order":3,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"64e23373-e4f9-4a95-8000-98cbee8e56a3","order":4,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"e5d15ebd-8a1b-40b3-b35c-caf9e4aca233","order":5,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"899c7267-fde9-44bc-86e2-5a29fbf647ae","order":6,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f876c88f-cf55-4447-83f2-5af47aa8fcf6","order":7,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"7bcf3559-ed00-4900-8dbb-4c0926d4a0c1","order":8,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"9904da0d-5ecf-4ac2-85d6-f79df00beb40","order":9,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"d24a9664-56b6-4fad-a876-5f1210fa5e6d","order":10,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"8996df1d-83b0-4dd1-82ff-8a049fdbb2e7","order":11,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"889ce04a-8c29-48c1-9599-516a103d03d1","order":12,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"69cbce43-769e-4fc0-b78b-507a949c22d1","order":13,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"2b0726cf-bbfa-497d-86d5-d69d810b606a","order":14,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"5a7ead1d-6dd9-4c52-8edd-117bcac016b2","order":15,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f533a15c-53d1-4eed-937d-ea0fea0c61f6","order":16,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"b870da00-a85f-431d-ab68-3e9bece39802","order":17,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"39e51db7-e6ba-485b-a5eb-30bdd02c7945","order":18,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"3687f079-bb21-45bf-a90d-6c804956f826","order":19,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"60db5a08-d255-4ac3-818d-50520f096542","order":20,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"cb8d0288-4a15-4bc7-b070-6a2932c1d944","order":21,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"55315ecb-5441-48fa-8814-1cb60c053330","order":22,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"9d26964d-1515-4e54-b784-7959978bac5d","order":23,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"24d47438-7fad-4fc8-af46-f948ffd82ff8","order":24,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"9b0f2747-30f1-45e5-bf90-f1d0c9d9b4b7","order":25,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f5881fd8-b6d3-4571-b9eb-937df493fc62","order":26,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"a4f99b4d-9090-436a-84f2-c89f722c80c4","order":27,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"43438a17-f5b7-444e-8b88-a3c909454cb9","order":28,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f1dc69d8-0bf3-452a-b779-46eca915410e","order":29,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"ee774449-140f-4450-a34f-0d5bdd20028b","order":30,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"658e1423-35c3-4473-a47f-41db58ce87e7","order":31,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"1e528b38-5787-4118-82b6-dfa1e4d1c7ba","order":32,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"02dd17a5-0d59-47b4-b82b-88abd35d42d1","order":33,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"c739d132-48f4-475c-a610-ccd149369d6f","order":34,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"6ec70f7a-cabd-4008-9df0-adeb3479eeb3","order":35,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"82b40382-628b-4906-9c71-42e903d8d1fa","order":36,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"bd1d7d82-7d2c-47e2-b4e9-80833cedf705","order":37,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"ANNIVERSARY"}]}',
          ptag: {
            name: 'vesting',
            id: '466a5e2b-9b98-42f8-b49b-7ad3c5001c73'
          },
          order: 9
        },
        {
          name: 'startAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: 'e96fcf7c-0856-4de6-ae8f-c41ccc4694f7',
          isScalar: true,
          ptag: {
            name: 'startDate',
            id: '9bc9e5ac-aa2a-42e1-9c92-50abd2c8c763'
          },
          order: 10
        }
      ],
      eventGroup: {
        id: '63525afd-e402-4161-a3c9-475092c0a307',
        name: 'Titres'
      },
      processes: [
        {
          name: 'emitStock',
          ptags: null,
          id: '30bbf0ba-93f5-498c-85a7-549a17c97eb6'
        },
        {
          name: 'cancelDelegation',
          ptags: null,
          id: '5c4c761a-f568-40c7-95e5-14634d8eb164'
        },
        {
          name: 'createVesting',
          ptags: null,
          id: 'c637258e-6bd1-4934-8be9-827daffa4535'
        }
      ],
      timelineTags: []
    },
    effectiveAt: '2020-06-01',
    effectiveAtSearch: '01/06/2020',
    isDraft: false,
    documents: [
      {
        documentType: {
          timelineTags: [],
          name: 'import | Acte enregistré (Statuts)',
          id: '9a3253a0-73d0-11e8-9c67-fa163ecedb5e'
        },
        name: 'democorp',
        signedAt: null,
        id: '5f3a4f14-13b2-11eb-8d78-068d0b27b94e'
      }
    ],
    companyId: 'c1610166-cf4c-49d3-92a1-ae80d4302719',
    hash: '229f65fc36069dac378151d47d722ca2e2b9d9c0cb6aa247c4e7c9998a2fbf21',
    audits: [],
    locked: false,
    id: '2ef3bf62-c67d-11ea-ab94-068d0b27b94e'
  },
  {
    event: {
      id: '3130a41c-fc7e-410d-9bc9-a67e4fe7cbec',
      name: 'Emission de titres',
      type: 'emit',
      isScalar: true,
      elements: [
        {
          name: 'CompaniesStock',
          modelType: 'CompaniesStockAlias',
          isOptional: false,
          type: 'model',
          id: '649accdc-5697-4372-a458-eacc48e428e6',
          isScalar: false,
          value:
            '{"id":"2fabac98-de0a-11e9-bb02-0e04bd33b2e4","name":"BCE 2017","isPrincipal":true,"color":null,"isCombined":false,"isComposed":true,"inNFD":false,"inFD":true,"inESOP":true,"inValoGraph":false,"expireAt":null,"companiesStockId":"9c395b54-3cdd-4bc6-8f81-419462828476","stockId":"a7ad7eee-83a0-4fbe-ad4f-1557dfd11f16","composedStock":{"id":"9fd7ce67-5b43-48e4-88e9-61974808e0cc","name":"AO Gen 2","parity":1}}',
          ptag: {
            name: 'companiesStock',
            id: 'cf0f727d-2983-43a7-be3d-01f295d57963'
          },
          order: 0
        },
        {
          method: 'getDelegations',
          name: 'delegation',
          modelType: 'CompaniesEvent',
          isOptional: true,
          type: 'dynamic',
          id: 'e4a58542-735b-4ac1-8652-fff26de4d89b',
          isScalar: false,
          value:
            '{"key":{"effectiveAt":"2020-06-01","name":"Délégation de compétence","priority":2},"id":"e62d1eb4-c679-11ea-ab94-068d0b27b94e"}',
          ptag: {
            name: 'delegation',
            id: '78fd4cce-b813-4d7e-8ab3-ad766fc14505'
          },
          order: 1
        },
        {
          name: 'contact',
          modelType: 'Contact',
          isOptional: false,
          type: 'model',
          id: '06679ccb-9e03-415a-bac1-db2b325020f6',
          isScalar: true,
          value:
            '{"key":"Ferdinand-Acace Mignon","id":"0fe18399-c679-11ea-ab94-068d0b27b94e","options":{"id":"0fe18399-c679-11ea-ab94-068d0b27b94e","firstname":"Ferdinand-Acace","lastname":"Mignon","denomination":null,"type":"NATURAL","pictureUrl":"https://uplaw-dev-public-content.s3.eu-west-3.amazonaws.com/pictures/c1610166-cf4c-49d3-92a1-ae80d4302719/0fe18399-c679-11ea-ab94-068d0b27b94e.jpg?v=1594771200000","color":null,"representativeContact":null,"formType":null,"group":{"id":"17e33530-c245-42b9-a06f-2bce943661a7","name":"others","color":"598CEF","order":13}}}',
          ptag: {
            name: 'contact',
            id: 'af5cbd7f-1924-4731-a6a7-bf67a228e98d'
          },
          order: 2
        },
        {
          name: 'quantity',
          modelType: null,
          isOptional: false,
          type: 'integer',
          id: 'ddfcf2e1-0df4-4c2f-b1d2-bcfadea4750f',
          isScalar: true,
          value: '2000',
          ptag: {
            name: 'quantity',
            id: '58e75274-7c6b-4e27-ac4c-e08eb8a24d66'
          },
          order: 3
        },
        {
          name: 'parity',
          modelType: null,
          isOptional: true,
          type: 'double',
          id: 'e91a2149-c077-4cc0-8e0f-cd3bbebc653c',
          isScalar: true,
          ptag: {
            name: 'parity',
            id: '87335f2b-3461-414e-8917-e9fb8e7e13e4'
          },
          order: 4
        },
        {
          name: 'subscriptionPrice',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: '5d628535-e875-4d76-8945-34c0d5644190',
          isScalar: true,
          value: '0',
          ptag: {
            name: 'subscriptionPrice',
            id: '6f2b0ec5-3296-4f2d-b6c7-c8c558e8639b'
          },
          order: 5
        },
        {
          name: 'exercisePrice',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: 'acc9e613-e52f-477b-bbf4-7be37c56af7e',
          isScalar: true,
          value: '90',
          ptag: {
            name: 'exercisePrice',
            id: '3a52986b-5d3d-4d38-b956-11f5201a8b41'
          },
          order: 6
        },
        {
          name: 'liberatedAmount',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: '47eb9ae4-8ecb-4e18-8dfe-9e0ef503316a',
          isScalar: true,
          ptag: {
            name: 'liberatedAmount',
            id: '28ebec26-9c4b-44be-9778-7bd2056db8da'
          },
          order: 7
        },
        {
          name: 'expireAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: 'bc082efd-7ea5-4eba-934c-46057c79d204',
          isScalar: true,
          value: '2030-06-01',
          ptag: {
            name: 'endDate',
            id: 'bbf6c789-ced3-47c3-8b85-161157218484'
          },
          order: 8
        },
        {
          name: 'vesting',
          modelType: 'CompaniesVesting',
          isOptional: true,
          type: 'model',
          id: '4dfa00c6-7f03-47bf-97c5-a98ac76d3cd5',
          isScalar: true,
          value:
            '{"id":"6bcdb585-c67a-11ea-ab94-068d0b27b94e","name":"BSPCE2017-1","exerciseDelayUnit":null,"exerciseDelayQuantity":null,"useSplitValue":false,"vestingPeriods":[{"id":"7131f3b2-16cb-439c-bceb-8862d409eac5","order":0,"quantity":null,"percentage":0,"fraction":null,"periodUnit":"DAYS","periodQty":0,"periodType":"VESTING","startDateType":"ENTRY","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"ANNIVERSARY"},{"id":"41a4b010-e38a-4488-a9a0-726007ef2de7","order":1,"quantity":null,"percentage":25,"fraction":null,"periodUnit":"MONTHS","periodQty":12,"periodType":"WAIT","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"ANNIVERSARY"},{"id":"8368a55c-335f-4635-839c-34fd0862fc19","order":2,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"8fad6f2e-cba9-4a7e-8ee4-9ba5bcc5ca66","order":3,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"64e23373-e4f9-4a95-8000-98cbee8e56a3","order":4,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"e5d15ebd-8a1b-40b3-b35c-caf9e4aca233","order":5,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"899c7267-fde9-44bc-86e2-5a29fbf647ae","order":6,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f876c88f-cf55-4447-83f2-5af47aa8fcf6","order":7,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"7bcf3559-ed00-4900-8dbb-4c0926d4a0c1","order":8,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"9904da0d-5ecf-4ac2-85d6-f79df00beb40","order":9,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"d24a9664-56b6-4fad-a876-5f1210fa5e6d","order":10,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"8996df1d-83b0-4dd1-82ff-8a049fdbb2e7","order":11,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"889ce04a-8c29-48c1-9599-516a103d03d1","order":12,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"69cbce43-769e-4fc0-b78b-507a949c22d1","order":13,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"2b0726cf-bbfa-497d-86d5-d69d810b606a","order":14,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"5a7ead1d-6dd9-4c52-8edd-117bcac016b2","order":15,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f533a15c-53d1-4eed-937d-ea0fea0c61f6","order":16,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"b870da00-a85f-431d-ab68-3e9bece39802","order":17,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"39e51db7-e6ba-485b-a5eb-30bdd02c7945","order":18,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"3687f079-bb21-45bf-a90d-6c804956f826","order":19,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"60db5a08-d255-4ac3-818d-50520f096542","order":20,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"cb8d0288-4a15-4bc7-b070-6a2932c1d944","order":21,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"55315ecb-5441-48fa-8814-1cb60c053330","order":22,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"9d26964d-1515-4e54-b784-7959978bac5d","order":23,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"24d47438-7fad-4fc8-af46-f948ffd82ff8","order":24,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"9b0f2747-30f1-45e5-bf90-f1d0c9d9b4b7","order":25,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f5881fd8-b6d3-4571-b9eb-937df493fc62","order":26,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"a4f99b4d-9090-436a-84f2-c89f722c80c4","order":27,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"43438a17-f5b7-444e-8b88-a3c909454cb9","order":28,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f1dc69d8-0bf3-452a-b779-46eca915410e","order":29,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"ee774449-140f-4450-a34f-0d5bdd20028b","order":30,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"658e1423-35c3-4473-a47f-41db58ce87e7","order":31,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"1e528b38-5787-4118-82b6-dfa1e4d1c7ba","order":32,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"02dd17a5-0d59-47b4-b82b-88abd35d42d1","order":33,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"c739d132-48f4-475c-a610-ccd149369d6f","order":34,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"6ec70f7a-cabd-4008-9df0-adeb3479eeb3","order":35,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"82b40382-628b-4906-9c71-42e903d8d1fa","order":36,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"bd1d7d82-7d2c-47e2-b4e9-80833cedf705","order":37,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"ANNIVERSARY"}]}',
          ptag: {
            name: 'vesting',
            id: '466a5e2b-9b98-42f8-b49b-7ad3c5001c73'
          },
          order: 9
        },
        {
          name: 'startAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: 'e96fcf7c-0856-4de6-ae8f-c41ccc4694f7',
          isScalar: true,
          ptag: {
            name: 'startDate',
            id: '9bc9e5ac-aa2a-42e1-9c92-50abd2c8c763'
          },
          order: 10
        }
      ],
      eventGroup: {
        id: '63525afd-e402-4161-a3c9-475092c0a307',
        name: 'Titres'
      },
      processes: [
        {
          name: 'emitStock',
          ptags: null,
          id: '30bbf0ba-93f5-498c-85a7-549a17c97eb6'
        },
        {
          name: 'cancelDelegation',
          ptags: null,
          id: '5c4c761a-f568-40c7-95e5-14634d8eb164'
        },
        {
          name: 'createVesting',
          ptags: null,
          id: 'c637258e-6bd1-4934-8be9-827daffa4535'
        }
      ],
      timelineTags: []
    },
    effectiveAt: '2020-06-01',
    effectiveAtSearch: '01/06/2020',
    isDraft: false,
    documents: [
      {
        documentType: {
          timelineTags: [],
          name: 'import | Acte enregistré (Statuts)',
          id: '9a3253a0-73d0-11e8-9c67-fa163ecedb5e'
        },
        name: 'democorp',
        signedAt: null,
        id: '5f3a4f14-13b2-11eb-8d78-068d0b27b94e'
      }
    ],
    companyId: 'c1610166-cf4c-49d3-92a1-ae80d4302719',
    hash: '229f65fc36069dac378151d47d722ca2e2b9d9c0cb6aa247c4e7c9998a2fbf21',
    audits: [],
    locked: false,
    id: 'b730c268-c67e-11ea-ab94-068d0b27b94e'
  },
  {
    event: {
      id: '3130a41c-fc7e-410d-9bc9-a67e4fe7cbec',
      name: 'Emission de titres',
      type: 'emit',
      isScalar: true,
      elements: [
        {
          name: 'CompaniesStock',
          modelType: 'CompaniesStockAlias',
          isOptional: false,
          type: 'model',
          id: '649accdc-5697-4372-a458-eacc48e428e6',
          isScalar: false,
          value:
            '{"id":"2fabac98-de0a-11e9-bb02-0e04bd33b2e4","name":"BCE 2017","isPrincipal":true,"color":null,"isCombined":false,"isComposed":true,"inNFD":false,"inFD":true,"inESOP":true,"inValoGraph":false,"expireAt":null,"companiesStockId":"9c395b54-3cdd-4bc6-8f81-419462828476","stockId":"a7ad7eee-83a0-4fbe-ad4f-1557dfd11f16","composedStock":{"id":"9fd7ce67-5b43-48e4-88e9-61974808e0cc","name":"AO Gen 2","parity":1}}',
          ptag: {
            name: 'companiesStock',
            id: 'cf0f727d-2983-43a7-be3d-01f295d57963'
          },
          order: 0
        },
        {
          method: 'getDelegations',
          name: 'delegation',
          modelType: 'CompaniesEvent',
          isOptional: true,
          type: 'dynamic',
          id: 'e4a58542-735b-4ac1-8652-fff26de4d89b',
          isScalar: false,
          value:
            '{"key":{"effectiveAt":"2020-06-01","name":"Délégation de compétence","priority":2},"id":"e62d1eb4-c679-11ea-ab94-068d0b27b94e"}',
          ptag: {
            name: 'delegation',
            id: '78fd4cce-b813-4d7e-8ab3-ad766fc14505'
          },
          order: 1
        },
        {
          name: 'contact',
          modelType: 'Contact',
          isOptional: false,
          type: 'model',
          id: '06679ccb-9e03-415a-bac1-db2b325020f6',
          isScalar: true,
          value:
            '{"key":"Perceval Aubert","id":"05445e3f-c679-11ea-ab94-068d0b27b94e","options":{"id":"05445e3f-c679-11ea-ab94-068d0b27b94e","firstname":"Perceval","lastname":"Aubert","denomination":null,"type":"NATURAL","pictureUrl":"https://uplaw-dev-public-content.s3.eu-west-3.amazonaws.com/pictures/c1610166-cf4c-49d3-92a1-ae80d4302719/05445e3f-c679-11ea-ab94-068d0b27b94e.jpg?v=1594771200000","color":null,"representativeContact":null,"formType":null,"group":{"id":"17e33530-c245-42b9-a06f-2bce943661a7","name":"others","color":"598CEF","order":13}}}',
          ptag: {
            name: 'contact',
            id: 'af5cbd7f-1924-4731-a6a7-bf67a228e98d'
          },
          order: 2
        },
        {
          name: 'quantity',
          modelType: null,
          isOptional: false,
          type: 'integer',
          id: 'ddfcf2e1-0df4-4c2f-b1d2-bcfadea4750f',
          isScalar: true,
          value: '2000',
          ptag: {
            name: 'quantity',
            id: '58e75274-7c6b-4e27-ac4c-e08eb8a24d66'
          },
          order: 3
        },
        {
          name: 'parity',
          modelType: null,
          isOptional: true,
          type: 'double',
          id: 'e91a2149-c077-4cc0-8e0f-cd3bbebc653c',
          isScalar: true,
          ptag: {
            name: 'parity',
            id: '87335f2b-3461-414e-8917-e9fb8e7e13e4'
          },
          order: 4
        },
        {
          name: 'subscriptionPrice',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: '5d628535-e875-4d76-8945-34c0d5644190',
          isScalar: true,
          value: '0',
          ptag: {
            name: 'subscriptionPrice',
            id: '6f2b0ec5-3296-4f2d-b6c7-c8c558e8639b'
          },
          order: 5
        },
        {
          name: 'exercisePrice',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: 'acc9e613-e52f-477b-bbf4-7be37c56af7e',
          isScalar: true,
          value: '90',
          ptag: {
            name: 'exercisePrice',
            id: '3a52986b-5d3d-4d38-b956-11f5201a8b41'
          },
          order: 6
        },
        {
          name: 'liberatedAmount',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: '47eb9ae4-8ecb-4e18-8dfe-9e0ef503316a',
          isScalar: true,
          ptag: {
            name: 'liberatedAmount',
            id: '28ebec26-9c4b-44be-9778-7bd2056db8da'
          },
          order: 7
        },
        {
          name: 'expireAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: 'bc082efd-7ea5-4eba-934c-46057c79d204',
          isScalar: true,
          value: '2030-06-01',
          ptag: {
            name: 'endDate',
            id: 'bbf6c789-ced3-47c3-8b85-161157218484'
          },
          order: 8
        },
        {
          name: 'vesting',
          modelType: 'CompaniesVesting',
          isOptional: true,
          type: 'model',
          id: '4dfa00c6-7f03-47bf-97c5-a98ac76d3cd5',
          isScalar: true,
          value:
            '{"id":"e538abb1-c67a-11ea-ab94-068d0b27b94e","name":"BSPCE2017-2","exerciseDelayUnit":null,"exerciseDelayQuantity":null,"useSplitValue":false,"vestingPeriods":[{"id":"d5ee9fdf-b9e3-4e16-a6d8-eb2806364bbf","order":0,"quantity":null,"percentage":0,"fraction":null,"periodUnit":"DAYS","periodQty":0,"periodType":"VESTING","startDateType":"ENTRY","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"fb81ae9e-bbe5-4487-a19d-64043f9e63d3","order":1,"quantity":null,"percentage":25,"fraction":null,"periodUnit":"MONTHS","periodQty":12,"periodType":"WAIT","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"370eb48d-d52e-4f8b-8747-448208275409","order":2,"quantity":null,"percentage":25,"fraction":null,"periodUnit":"MONTHS","periodQty":12,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"2452e6d9-f610-45cc-a313-2b234b7bc662","order":3,"quantity":null,"percentage":25,"fraction":null,"periodUnit":"MONTHS","periodQty":12,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"d3bba33a-7076-499b-b0a2-897934df5649","order":4,"quantity":null,"percentage":25,"fraction":null,"periodUnit":"MONTHS","periodQty":12,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"}]}',
          ptag: {
            name: 'vesting',
            id: '466a5e2b-9b98-42f8-b49b-7ad3c5001c73'
          },
          order: 9
        },
        {
          name: 'startAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: 'e96fcf7c-0856-4de6-ae8f-c41ccc4694f7',
          isScalar: true,
          ptag: {
            name: 'startDate',
            id: '9bc9e5ac-aa2a-42e1-9c92-50abd2c8c763'
          },
          order: 10
        }
      ],
      eventGroup: {
        id: '63525afd-e402-4161-a3c9-475092c0a307',
        name: 'Titres'
      },
      processes: [
        {
          name: 'emitStock',
          ptags: null,
          id: '30bbf0ba-93f5-498c-85a7-549a17c97eb6'
        },
        {
          name: 'cancelDelegation',
          ptags: null,
          id: '5c4c761a-f568-40c7-95e5-14634d8eb164'
        },
        {
          name: 'createVesting',
          ptags: null,
          id: 'c637258e-6bd1-4934-8be9-827daffa4535'
        }
      ],
      timelineTags: []
    },
    effectiveAt: '2020-06-01',
    effectiveAtSearch: '01/06/2020',
    isDraft: false,
    documents: [
      {
        documentType: {
          timelineTags: [],
          name: 'import | Acte enregistré (Statuts)',
          id: '9a3253a0-73d0-11e8-9c67-fa163ecedb5e'
        },
        name: 'democorp',
        signedAt: null,
        id: '5f3a4f14-13b2-11eb-8d78-068d0b27b94e'
      }
    ],
    companyId: 'c1610166-cf4c-49d3-92a1-ae80d4302719',
    hash: '229f65fc36069dac378151d47d722ca2e2b9d9c0cb6aa247c4e7c9998a2fbf21',
    audits: [],
    locked: false,
    id: 'b730ab48-c67e-11ea-ab94-068d0b27b94e'
  },
  {
    event: {
      id: '3130a41c-fc7e-410d-9bc9-a67e4fe7cbec',
      name: 'Emission de titres',
      type: 'emit',
      isScalar: true,
      elements: [
        {
          name: 'CompaniesStock',
          modelType: 'CompaniesStockAlias',
          isOptional: false,
          type: 'model',
          id: '649accdc-5697-4372-a458-eacc48e428e6',
          isScalar: false,
          value:
            '{"id":"2fabac98-de0a-11e9-bb02-0e04bd33b2e4","name":"BCE 2017","isPrincipal":true,"color":null,"isCombined":false,"isComposed":true,"inNFD":false,"inFD":true,"inESOP":true,"inValoGraph":false,"expireAt":null,"companiesStockId":"9c395b54-3cdd-4bc6-8f81-419462828476","stockId":"a7ad7eee-83a0-4fbe-ad4f-1557dfd11f16","composedStock":{"id":"9fd7ce67-5b43-48e4-88e9-61974808e0cc","name":"AO Gen 2","parity":1}}',
          ptag: {
            name: 'companiesStock',
            id: 'cf0f727d-2983-43a7-be3d-01f295d57963'
          },
          order: 0
        },
        {
          method: 'getDelegations',
          name: 'delegation',
          modelType: 'CompaniesEvent',
          isOptional: true,
          type: 'dynamic',
          id: 'e4a58542-735b-4ac1-8652-fff26de4d89b',
          isScalar: false,
          value:
            '{"key":{"effectiveAt":"2020-06-01","name":"Délégation de compétence","priority":2},"id":"e62d1eb4-c679-11ea-ab94-068d0b27b94e"}',
          ptag: {
            name: 'delegation',
            id: '78fd4cce-b813-4d7e-8ab3-ad766fc14505'
          },
          order: 1
        },
        {
          name: 'contact',
          modelType: 'Contact',
          isOptional: false,
          type: 'model',
          id: '06679ccb-9e03-415a-bac1-db2b325020f6',
          isScalar: true,
          value:
            '{"key":"Laureline-Titen Peres","id":"d4967096-c678-11ea-ab94-068d0b27b94e","options":{"id":"d4967096-c678-11ea-ab94-068d0b27b94e","firstname":"Laureline-Titen","lastname":"Peres","denomination":null,"type":"NATURAL","pictureUrl":"https://uplaw-dev-public-content.s3.eu-west-3.amazonaws.com/pictures/c1610166-cf4c-49d3-92a1-ae80d4302719/d4967096-c678-11ea-ab94-068d0b27b94e.jpg?v=1594771200000","color":null,"representativeContact":null,"formType":null,"group":{"id":"17e33530-c245-42b9-a06f-2bce943661a7","name":"others","color":"598CEF","order":13}}}',
          ptag: {
            name: 'contact',
            id: 'af5cbd7f-1924-4731-a6a7-bf67a228e98d'
          },
          order: 2
        },
        {
          name: 'quantity',
          modelType: null,
          isOptional: false,
          type: 'integer',
          id: 'ddfcf2e1-0df4-4c2f-b1d2-bcfadea4750f',
          isScalar: true,
          value: '2000',
          ptag: {
            name: 'quantity',
            id: '58e75274-7c6b-4e27-ac4c-e08eb8a24d66'
          },
          order: 3
        },
        {
          name: 'parity',
          modelType: null,
          isOptional: true,
          type: 'double',
          id: 'e91a2149-c077-4cc0-8e0f-cd3bbebc653c',
          isScalar: true,
          ptag: {
            name: 'parity',
            id: '87335f2b-3461-414e-8917-e9fb8e7e13e4'
          },
          order: 4
        },
        {
          name: 'subscriptionPrice',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: '5d628535-e875-4d76-8945-34c0d5644190',
          isScalar: true,
          value: '0',
          ptag: {
            name: 'subscriptionPrice',
            id: '6f2b0ec5-3296-4f2d-b6c7-c8c558e8639b'
          },
          order: 5
        },
        {
          name: 'exercisePrice',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: 'acc9e613-e52f-477b-bbf4-7be37c56af7e',
          isScalar: true,
          value: '90',
          ptag: {
            name: 'exercisePrice',
            id: '3a52986b-5d3d-4d38-b956-11f5201a8b41'
          },
          order: 6
        },
        {
          name: 'liberatedAmount',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: '47eb9ae4-8ecb-4e18-8dfe-9e0ef503316a',
          isScalar: true,
          ptag: {
            name: 'liberatedAmount',
            id: '28ebec26-9c4b-44be-9778-7bd2056db8da'
          },
          order: 7
        },
        {
          name: 'expireAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: 'bc082efd-7ea5-4eba-934c-46057c79d204',
          isScalar: true,
          value: '2030-06-01',
          ptag: {
            name: 'endDate',
            id: 'bbf6c789-ced3-47c3-8b85-161157218484'
          },
          order: 8
        },
        {
          name: 'vesting',
          modelType: 'CompaniesVesting',
          isOptional: true,
          type: 'model',
          id: '4dfa00c6-7f03-47bf-97c5-a98ac76d3cd5',
          isScalar: true,
          value:
            '{"id":"e538abb1-c67a-11ea-ab94-068d0b27b94e","name":"BSPCE2017-2","exerciseDelayUnit":null,"exerciseDelayQuantity":null,"useSplitValue":false,"vestingPeriods":[{"id":"d5ee9fdf-b9e3-4e16-a6d8-eb2806364bbf","order":0,"quantity":null,"percentage":0,"fraction":null,"periodUnit":"DAYS","periodQty":0,"periodType":"VESTING","startDateType":"ENTRY","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"fb81ae9e-bbe5-4487-a19d-64043f9e63d3","order":1,"quantity":null,"percentage":25,"fraction":null,"periodUnit":"MONTHS","periodQty":12,"periodType":"WAIT","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"370eb48d-d52e-4f8b-8747-448208275409","order":2,"quantity":null,"percentage":25,"fraction":null,"periodUnit":"MONTHS","periodQty":12,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"2452e6d9-f610-45cc-a313-2b234b7bc662","order":3,"quantity":null,"percentage":25,"fraction":null,"periodUnit":"MONTHS","periodQty":12,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"d3bba33a-7076-499b-b0a2-897934df5649","order":4,"quantity":null,"percentage":25,"fraction":null,"periodUnit":"MONTHS","periodQty":12,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"}]}',
          ptag: {
            name: 'vesting',
            id: '466a5e2b-9b98-42f8-b49b-7ad3c5001c73'
          },
          order: 9
        },
        {
          name: 'startAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: 'e96fcf7c-0856-4de6-ae8f-c41ccc4694f7',
          isScalar: true,
          ptag: {
            name: 'startDate',
            id: '9bc9e5ac-aa2a-42e1-9c92-50abd2c8c763'
          },
          order: 10
        }
      ],
      eventGroup: {
        id: '63525afd-e402-4161-a3c9-475092c0a307',
        name: 'Titres'
      },
      processes: [
        {
          name: 'emitStock',
          ptags: null,
          id: '30bbf0ba-93f5-498c-85a7-549a17c97eb6'
        },
        {
          name: 'cancelDelegation',
          ptags: null,
          id: '5c4c761a-f568-40c7-95e5-14634d8eb164'
        },
        {
          name: 'createVesting',
          ptags: null,
          id: 'c637258e-6bd1-4934-8be9-827daffa4535'
        }
      ],
      timelineTags: []
    },
    effectiveAt: '2020-06-01',
    effectiveAtSearch: '01/06/2020',
    isDraft: false,
    documents: [
      {
        documentType: {
          timelineTags: [],
          name: 'import | Acte enregistré (Statuts)',
          id: '9a3253a0-73d0-11e8-9c67-fa163ecedb5e'
        },
        name: 'democorp',
        signedAt: null,
        id: '5f3a4f14-13b2-11eb-8d78-068d0b27b94e'
      }
    ],
    companyId: 'c1610166-cf4c-49d3-92a1-ae80d4302719',
    hash: '229f65fc36069dac378151d47d722ca2e2b9d9c0cb6aa247c4e7c9998a2fbf21',
    audits: [],
    locked: false,
    id: '2ef35b0f-c67d-11ea-ab94-068d0b27b94e'
  },
  {
    event: {
      id: '3130a41c-fc7e-410d-9bc9-a67e4fe7cbec',
      name: 'Emission de titres',
      type: 'emit',
      isScalar: true,
      elements: [
        {
          name: 'CompaniesStock',
          modelType: 'CompaniesStockAlias',
          isOptional: false,
          type: 'model',
          id: '649accdc-5697-4372-a458-eacc48e428e6',
          isScalar: false,
          value:
            '{"id":"2fabac98-de0a-11e9-bb02-0e04bd33b2e4","name":"BCE 2017","isPrincipal":true,"color":null,"isCombined":false,"isComposed":true,"inNFD":false,"inFD":true,"inESOP":true,"inValoGraph":false,"expireAt":null,"companiesStockId":"9c395b54-3cdd-4bc6-8f81-419462828476","stockId":"a7ad7eee-83a0-4fbe-ad4f-1557dfd11f16","composedStock":{"id":"9fd7ce67-5b43-48e4-88e9-61974808e0cc","name":"AO Gen 2","parity":1}}',
          ptag: {
            name: 'companiesStock',
            id: 'cf0f727d-2983-43a7-be3d-01f295d57963'
          },
          order: 0
        },
        {
          method: 'getDelegations',
          name: 'delegation',
          modelType: 'CompaniesEvent',
          isOptional: true,
          type: 'dynamic',
          id: 'e4a58542-735b-4ac1-8652-fff26de4d89b',
          isScalar: false,
          value:
            '{"key":{"effectiveAt":"2020-06-01","name":"Délégation de compétence","priority":2},"id":"e62d1eb4-c679-11ea-ab94-068d0b27b94e"}',
          ptag: {
            name: 'delegation',
            id: '78fd4cce-b813-4d7e-8ab3-ad766fc14505'
          },
          order: 1
        },
        {
          name: 'contact',
          modelType: 'Contact',
          isOptional: false,
          type: 'model',
          id: '06679ccb-9e03-415a-bac1-db2b325020f6',
          isScalar: true,
          value:
            '{"key":"Florent Chirac","id":"15521bcd-c679-11ea-ab94-068d0b27b94e","options":{"id":"15521bcd-c679-11ea-ab94-068d0b27b94e","firstname":"Florent","lastname":"Chirac","denomination":null,"type":"NATURAL","pictureUrl":"https://uplaw-dev-public-content.s3.eu-west-3.amazonaws.com/pictures/c1610166-cf4c-49d3-92a1-ae80d4302719/15521bcd-c679-11ea-ab94-068d0b27b94e.jpg?v=1594771200000","color":null,"representativeContact":null,"formType":null,"group":{"id":"17e33530-c245-42b9-a06f-2bce943661a7","name":"others","color":"598CEF","order":13}}}',
          ptag: {
            name: 'contact',
            id: 'af5cbd7f-1924-4731-a6a7-bf67a228e98d'
          },
          order: 2
        },
        {
          name: 'quantity',
          modelType: null,
          isOptional: false,
          type: 'integer',
          id: 'ddfcf2e1-0df4-4c2f-b1d2-bcfadea4750f',
          isScalar: true,
          value: '500',
          ptag: {
            name: 'quantity',
            id: '58e75274-7c6b-4e27-ac4c-e08eb8a24d66'
          },
          order: 3
        },
        {
          name: 'parity',
          modelType: null,
          isOptional: true,
          type: 'double',
          id: 'e91a2149-c077-4cc0-8e0f-cd3bbebc653c',
          isScalar: true,
          ptag: {
            name: 'parity',
            id: '87335f2b-3461-414e-8917-e9fb8e7e13e4'
          },
          order: 4
        },
        {
          name: 'subscriptionPrice',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: '5d628535-e875-4d76-8945-34c0d5644190',
          isScalar: true,
          value: '0',
          ptag: {
            name: 'subscriptionPrice',
            id: '6f2b0ec5-3296-4f2d-b6c7-c8c558e8639b'
          },
          order: 5
        },
        {
          name: 'exercisePrice',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: 'acc9e613-e52f-477b-bbf4-7be37c56af7e',
          isScalar: true,
          value: '90',
          ptag: {
            name: 'exercisePrice',
            id: '3a52986b-5d3d-4d38-b956-11f5201a8b41'
          },
          order: 6
        },
        {
          name: 'liberatedAmount',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: '47eb9ae4-8ecb-4e18-8dfe-9e0ef503316a',
          isScalar: true,
          ptag: {
            name: 'liberatedAmount',
            id: '28ebec26-9c4b-44be-9778-7bd2056db8da'
          },
          order: 7
        },
        {
          name: 'expireAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: 'bc082efd-7ea5-4eba-934c-46057c79d204',
          isScalar: true,
          value: '2030-06-01',
          ptag: {
            name: 'endDate',
            id: 'bbf6c789-ced3-47c3-8b85-161157218484'
          },
          order: 8
        },
        {
          name: 'vesting',
          modelType: 'CompaniesVesting',
          isOptional: true,
          type: 'model',
          id: '4dfa00c6-7f03-47bf-97c5-a98ac76d3cd5',
          isScalar: true,
          ptag: {
            name: 'vesting',
            id: '466a5e2b-9b98-42f8-b49b-7ad3c5001c73'
          },
          order: 9
        },
        {
          name: 'startAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: 'e96fcf7c-0856-4de6-ae8f-c41ccc4694f7',
          isScalar: true,
          ptag: {
            name: 'startDate',
            id: '9bc9e5ac-aa2a-42e1-9c92-50abd2c8c763'
          },
          order: 10
        }
      ],
      eventGroup: {
        id: '63525afd-e402-4161-a3c9-475092c0a307',
        name: 'Titres'
      },
      processes: [
        {
          name: 'emitStock',
          ptags: null,
          id: '30bbf0ba-93f5-498c-85a7-549a17c97eb6'
        },
        {
          name: 'cancelDelegation',
          ptags: null,
          id: '5c4c761a-f568-40c7-95e5-14634d8eb164'
        },
        {
          name: 'createVesting',
          ptags: null,
          id: 'c637258e-6bd1-4934-8be9-827daffa4535'
        }
      ],
      timelineTags: []
    },
    effectiveAt: '2020-06-01',
    effectiveAtSearch: '01/06/2020',
    isDraft: false,
    documents: [
      {
        documentType: {
          timelineTags: [],
          name: 'import | Acte enregistré (Statuts)',
          id: '9a3253a0-73d0-11e8-9c67-fa163ecedb5e'
        },
        name: 'democorp',
        signedAt: null,
        id: '5f3a4f14-13b2-11eb-8d78-068d0b27b94e'
      }
    ],
    companyId: 'c1610166-cf4c-49d3-92a1-ae80d4302719',
    hash: '229f65fc36069dac378151d47d722ca2e2b9d9c0cb6aa247c4e7c9998a2fbf21',
    audits: [],
    locked: false,
    id: '49f61362-e77d-11ea-8d78-068d0b27b94e'
  },
  {
    event: {
      id: '3130a41c-fc7e-410d-9bc9-a67e4fe7cbec',
      name: 'Emission de titres',
      type: 'emit',
      isScalar: true,
      elements: [
        {
          name: 'CompaniesStock',
          modelType: 'CompaniesStockAlias',
          isOptional: false,
          type: 'model',
          id: '649accdc-5697-4372-a458-eacc48e428e6',
          isScalar: false,
          value:
            '{"id":"2fabac98-de0a-11e9-bb02-0e04bd33b2e4","name":"BCE 2017","isPrincipal":true,"color":null,"isCombined":false,"isComposed":true,"inNFD":false,"inFD":true,"inESOP":true,"inValoGraph":false,"expireAt":null,"companiesStockId":"9c395b54-3cdd-4bc6-8f81-419462828476","stockId":"a7ad7eee-83a0-4fbe-ad4f-1557dfd11f16","composedStock":{"id":"9fd7ce67-5b43-48e4-88e9-61974808e0cc","name":"AO Gen 2","parity":1}}',
          ptag: {
            name: 'companiesStock',
            id: 'cf0f727d-2983-43a7-be3d-01f295d57963'
          },
          order: 0
        },
        {
          method: 'getDelegations',
          name: 'delegation',
          modelType: 'CompaniesEvent',
          isOptional: true,
          type: 'dynamic',
          id: 'e4a58542-735b-4ac1-8652-fff26de4d89b',
          isScalar: false,
          value:
            '{"key":{"effectiveAt":"2020-06-01","name":"Délégation de compétence","priority":2},"id":"e62d1eb4-c679-11ea-ab94-068d0b27b94e"}',
          ptag: {
            name: 'delegation',
            id: '78fd4cce-b813-4d7e-8ab3-ad766fc14505'
          },
          order: 1
        },
        {
          name: 'contact',
          modelType: 'Contact',
          isOptional: false,
          type: 'model',
          id: '06679ccb-9e03-415a-bac1-db2b325020f6',
          isScalar: true,
          value:
            '{"key":"Alphonse Krebs","id":"3ecca6e3-c679-11ea-ab94-068d0b27b94e","options":{"id":"3ecca6e3-c679-11ea-ab94-068d0b27b94e","firstname":"Alphonse","lastname":"Krebs","denomination":null,"type":"NATURAL","pictureUrl":"https://uplaw-dev-public-content.s3.eu-west-3.amazonaws.com/pictures/c1610166-cf4c-49d3-92a1-ae80d4302719/3ecca6e3-c679-11ea-ab94-068d0b27b94e.jpg?v=1594771200000","color":null,"representativeContact":null,"formType":null,"group":{"id":"17e33530-c245-42b9-a06f-2bce943661a7","name":"others","color":"598CEF","order":13}}}',
          ptag: {
            name: 'contact',
            id: 'af5cbd7f-1924-4731-a6a7-bf67a228e98d'
          },
          order: 2
        },
        {
          name: 'quantity',
          modelType: null,
          isOptional: false,
          type: 'integer',
          id: 'ddfcf2e1-0df4-4c2f-b1d2-bcfadea4750f',
          isScalar: true,
          value: '2000',
          ptag: {
            name: 'quantity',
            id: '58e75274-7c6b-4e27-ac4c-e08eb8a24d66'
          },
          order: 3
        },
        {
          name: 'parity',
          modelType: null,
          isOptional: true,
          type: 'double',
          id: 'e91a2149-c077-4cc0-8e0f-cd3bbebc653c',
          isScalar: true,
          ptag: {
            name: 'parity',
            id: '87335f2b-3461-414e-8917-e9fb8e7e13e4'
          },
          order: 4
        },
        {
          name: 'subscriptionPrice',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: '5d628535-e875-4d76-8945-34c0d5644190',
          isScalar: true,
          value: '0',
          ptag: {
            name: 'subscriptionPrice',
            id: '6f2b0ec5-3296-4f2d-b6c7-c8c558e8639b'
          },
          order: 5
        },
        {
          name: 'exercisePrice',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: 'acc9e613-e52f-477b-bbf4-7be37c56af7e',
          isScalar: true,
          value: '90',
          ptag: {
            name: 'exercisePrice',
            id: '3a52986b-5d3d-4d38-b956-11f5201a8b41'
          },
          order: 6
        },
        {
          name: 'liberatedAmount',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: '47eb9ae4-8ecb-4e18-8dfe-9e0ef503316a',
          isScalar: true,
          ptag: {
            name: 'liberatedAmount',
            id: '28ebec26-9c4b-44be-9778-7bd2056db8da'
          },
          order: 7
        },
        {
          name: 'expireAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: 'bc082efd-7ea5-4eba-934c-46057c79d204',
          isScalar: true,
          value: '2030-06-01',
          ptag: {
            name: 'endDate',
            id: 'bbf6c789-ced3-47c3-8b85-161157218484'
          },
          order: 8
        },
        {
          name: 'vesting',
          modelType: 'CompaniesVesting',
          isOptional: true,
          type: 'model',
          id: '4dfa00c6-7f03-47bf-97c5-a98ac76d3cd5',
          isScalar: true,
          value:
            '{"id":"6bcdb585-c67a-11ea-ab94-068d0b27b94e","name":"BSPCE2017-1","exerciseDelayUnit":null,"exerciseDelayQuantity":null,"useSplitValue":false,"vestingPeriods":[{"id":"7131f3b2-16cb-439c-bceb-8862d409eac5","order":0,"quantity":null,"percentage":0,"fraction":null,"periodUnit":"DAYS","periodQty":0,"periodType":"VESTING","startDateType":"ENTRY","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"ANNIVERSARY"},{"id":"41a4b010-e38a-4488-a9a0-726007ef2de7","order":1,"quantity":null,"percentage":25,"fraction":null,"periodUnit":"MONTHS","periodQty":12,"periodType":"WAIT","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"ANNIVERSARY"},{"id":"8368a55c-335f-4635-839c-34fd0862fc19","order":2,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"8fad6f2e-cba9-4a7e-8ee4-9ba5bcc5ca66","order":3,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"64e23373-e4f9-4a95-8000-98cbee8e56a3","order":4,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"e5d15ebd-8a1b-40b3-b35c-caf9e4aca233","order":5,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"899c7267-fde9-44bc-86e2-5a29fbf647ae","order":6,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f876c88f-cf55-4447-83f2-5af47aa8fcf6","order":7,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"7bcf3559-ed00-4900-8dbb-4c0926d4a0c1","order":8,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"9904da0d-5ecf-4ac2-85d6-f79df00beb40","order":9,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"d24a9664-56b6-4fad-a876-5f1210fa5e6d","order":10,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"8996df1d-83b0-4dd1-82ff-8a049fdbb2e7","order":11,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"889ce04a-8c29-48c1-9599-516a103d03d1","order":12,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"69cbce43-769e-4fc0-b78b-507a949c22d1","order":13,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"2b0726cf-bbfa-497d-86d5-d69d810b606a","order":14,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"5a7ead1d-6dd9-4c52-8edd-117bcac016b2","order":15,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f533a15c-53d1-4eed-937d-ea0fea0c61f6","order":16,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"b870da00-a85f-431d-ab68-3e9bece39802","order":17,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"39e51db7-e6ba-485b-a5eb-30bdd02c7945","order":18,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"3687f079-bb21-45bf-a90d-6c804956f826","order":19,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"60db5a08-d255-4ac3-818d-50520f096542","order":20,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"cb8d0288-4a15-4bc7-b070-6a2932c1d944","order":21,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"55315ecb-5441-48fa-8814-1cb60c053330","order":22,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"9d26964d-1515-4e54-b784-7959978bac5d","order":23,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"24d47438-7fad-4fc8-af46-f948ffd82ff8","order":24,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"9b0f2747-30f1-45e5-bf90-f1d0c9d9b4b7","order":25,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f5881fd8-b6d3-4571-b9eb-937df493fc62","order":26,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"a4f99b4d-9090-436a-84f2-c89f722c80c4","order":27,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"43438a17-f5b7-444e-8b88-a3c909454cb9","order":28,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f1dc69d8-0bf3-452a-b779-46eca915410e","order":29,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"ee774449-140f-4450-a34f-0d5bdd20028b","order":30,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"658e1423-35c3-4473-a47f-41db58ce87e7","order":31,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"1e528b38-5787-4118-82b6-dfa1e4d1c7ba","order":32,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"02dd17a5-0d59-47b4-b82b-88abd35d42d1","order":33,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"c739d132-48f4-475c-a610-ccd149369d6f","order":34,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"6ec70f7a-cabd-4008-9df0-adeb3479eeb3","order":35,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"82b40382-628b-4906-9c71-42e903d8d1fa","order":36,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"bd1d7d82-7d2c-47e2-b4e9-80833cedf705","order":37,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"ANNIVERSARY"}]}',
          ptag: {
            name: 'vesting',
            id: '466a5e2b-9b98-42f8-b49b-7ad3c5001c73'
          },
          order: 9
        },
        {
          name: 'startAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: 'e96fcf7c-0856-4de6-ae8f-c41ccc4694f7',
          isScalar: true,
          ptag: {
            name: 'startDate',
            id: '9bc9e5ac-aa2a-42e1-9c92-50abd2c8c763'
          },
          order: 10
        }
      ],
      eventGroup: {
        id: '63525afd-e402-4161-a3c9-475092c0a307',
        name: 'Titres'
      },
      processes: [
        {
          name: 'emitStock',
          ptags: null,
          id: '30bbf0ba-93f5-498c-85a7-549a17c97eb6'
        },
        {
          name: 'cancelDelegation',
          ptags: null,
          id: '5c4c761a-f568-40c7-95e5-14634d8eb164'
        },
        {
          name: 'createVesting',
          ptags: null,
          id: 'c637258e-6bd1-4934-8be9-827daffa4535'
        }
      ],
      timelineTags: []
    },
    effectiveAt: '2020-06-01',
    effectiveAtSearch: '01/06/2020',
    isDraft: false,
    documents: [
      {
        documentType: {
          timelineTags: [],
          name: 'import | Acte enregistré (Statuts)',
          id: '9a3253a0-73d0-11e8-9c67-fa163ecedb5e'
        },
        name: 'democorp',
        signedAt: null,
        id: '5f3a4f14-13b2-11eb-8d78-068d0b27b94e'
      }
    ],
    companyId: 'c1610166-cf4c-49d3-92a1-ae80d4302719',
    hash: '229f65fc36069dac378151d47d722ca2e2b9d9c0cb6aa247c4e7c9998a2fbf21',
    audits: [],
    locked: false,
    id: 'b7319819-c67e-11ea-ab94-068d0b27b94e'
  },
  {
    event: {
      id: '3130a41c-fc7e-410d-9bc9-a67e4fe7cbec',
      name: 'Emission de titres',
      type: 'emit',
      isScalar: true,
      elements: [
        {
          name: 'CompaniesStock',
          modelType: 'CompaniesStockAlias',
          isOptional: false,
          type: 'model',
          id: '649accdc-5697-4372-a458-eacc48e428e6',
          isScalar: false,
          value:
            '{"id":"2fabac98-de0a-11e9-bb02-0e04bd33b2e4","name":"BCE 2017","isPrincipal":true,"color":null,"isCombined":false,"isComposed":true,"inNFD":false,"inFD":true,"inESOP":true,"inValoGraph":false,"expireAt":null,"companiesStockId":"9c395b54-3cdd-4bc6-8f81-419462828476","stockId":"a7ad7eee-83a0-4fbe-ad4f-1557dfd11f16","composedStock":{"id":"9fd7ce67-5b43-48e4-88e9-61974808e0cc","name":"AO Gen 2","parity":1}}',
          ptag: {
            name: 'companiesStock',
            id: 'cf0f727d-2983-43a7-be3d-01f295d57963'
          },
          order: 0
        },
        {
          method: 'getDelegations',
          name: 'delegation',
          modelType: 'CompaniesEvent',
          isOptional: true,
          type: 'dynamic',
          id: 'e4a58542-735b-4ac1-8652-fff26de4d89b',
          isScalar: false,
          value:
            '{"key":{"effectiveAt":"2020-06-01","name":"Délégation de compétence","priority":2},"id":"e62d1eb4-c679-11ea-ab94-068d0b27b94e"}',
          ptag: {
            name: 'delegation',
            id: '78fd4cce-b813-4d7e-8ab3-ad766fc14505'
          },
          order: 1
        },
        {
          name: 'contact',
          modelType: 'Contact',
          isOptional: false,
          type: 'model',
          id: '06679ccb-9e03-415a-bac1-db2b325020f6',
          isScalar: true,
          value:
            '{"key":"Axelle-Maxence Dupont","id":"30135ecb-c679-11ea-ab94-068d0b27b94e","options":{"id":"30135ecb-c679-11ea-ab94-068d0b27b94e","firstname":"Axelle-Maxence","lastname":"Dupont","denomination":null,"type":"NATURAL","pictureUrl":"https://uplaw-dev-public-content.s3.eu-west-3.amazonaws.com/pictures/c1610166-cf4c-49d3-92a1-ae80d4302719/30135ecb-c679-11ea-ab94-068d0b27b94e.jpg?v=1594771200000","color":null,"representativeContact":null,"formType":null,"group":{"id":"17e33530-c245-42b9-a06f-2bce943661a7","name":"others","color":"598CEF","order":13}}}',
          ptag: {
            name: 'contact',
            id: 'af5cbd7f-1924-4731-a6a7-bf67a228e98d'
          },
          order: 2
        },
        {
          name: 'quantity',
          modelType: null,
          isOptional: false,
          type: 'integer',
          id: 'ddfcf2e1-0df4-4c2f-b1d2-bcfadea4750f',
          isScalar: true,
          value: '2000',
          ptag: {
            name: 'quantity',
            id: '58e75274-7c6b-4e27-ac4c-e08eb8a24d66'
          },
          order: 3
        },
        {
          name: 'parity',
          modelType: null,
          isOptional: true,
          type: 'double',
          id: 'e91a2149-c077-4cc0-8e0f-cd3bbebc653c',
          isScalar: true,
          ptag: {
            name: 'parity',
            id: '87335f2b-3461-414e-8917-e9fb8e7e13e4'
          },
          order: 4
        },
        {
          name: 'subscriptionPrice',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: '5d628535-e875-4d76-8945-34c0d5644190',
          isScalar: true,
          value: '0',
          ptag: {
            name: 'subscriptionPrice',
            id: '6f2b0ec5-3296-4f2d-b6c7-c8c558e8639b'
          },
          order: 5
        },
        {
          name: 'exercisePrice',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: 'acc9e613-e52f-477b-bbf4-7be37c56af7e',
          isScalar: true,
          value: '90',
          ptag: {
            name: 'exercisePrice',
            id: '3a52986b-5d3d-4d38-b956-11f5201a8b41'
          },
          order: 6
        },
        {
          name: 'liberatedAmount',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: '47eb9ae4-8ecb-4e18-8dfe-9e0ef503316a',
          isScalar: true,
          ptag: {
            name: 'liberatedAmount',
            id: '28ebec26-9c4b-44be-9778-7bd2056db8da'
          },
          order: 7
        },
        {
          name: 'expireAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: 'bc082efd-7ea5-4eba-934c-46057c79d204',
          isScalar: true,
          value: '2030-06-01',
          ptag: {
            name: 'endDate',
            id: 'bbf6c789-ced3-47c3-8b85-161157218484'
          },
          order: 8
        },
        {
          name: 'vesting',
          modelType: 'CompaniesVesting',
          isOptional: true,
          type: 'model',
          id: '4dfa00c6-7f03-47bf-97c5-a98ac76d3cd5',
          isScalar: true,
          value:
            '{"id":"6bcdb585-c67a-11ea-ab94-068d0b27b94e","name":"BSPCE2017-1","exerciseDelayUnit":null,"exerciseDelayQuantity":null,"useSplitValue":false,"vestingPeriods":[{"id":"7131f3b2-16cb-439c-bceb-8862d409eac5","order":0,"quantity":null,"percentage":0,"fraction":null,"periodUnit":"DAYS","periodQty":0,"periodType":"VESTING","startDateType":"ENTRY","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"ANNIVERSARY"},{"id":"41a4b010-e38a-4488-a9a0-726007ef2de7","order":1,"quantity":null,"percentage":25,"fraction":null,"periodUnit":"MONTHS","periodQty":12,"periodType":"WAIT","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"ANNIVERSARY"},{"id":"8368a55c-335f-4635-839c-34fd0862fc19","order":2,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"8fad6f2e-cba9-4a7e-8ee4-9ba5bcc5ca66","order":3,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"64e23373-e4f9-4a95-8000-98cbee8e56a3","order":4,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"e5d15ebd-8a1b-40b3-b35c-caf9e4aca233","order":5,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"899c7267-fde9-44bc-86e2-5a29fbf647ae","order":6,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f876c88f-cf55-4447-83f2-5af47aa8fcf6","order":7,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"7bcf3559-ed00-4900-8dbb-4c0926d4a0c1","order":8,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"9904da0d-5ecf-4ac2-85d6-f79df00beb40","order":9,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"d24a9664-56b6-4fad-a876-5f1210fa5e6d","order":10,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"8996df1d-83b0-4dd1-82ff-8a049fdbb2e7","order":11,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"889ce04a-8c29-48c1-9599-516a103d03d1","order":12,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"69cbce43-769e-4fc0-b78b-507a949c22d1","order":13,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"2b0726cf-bbfa-497d-86d5-d69d810b606a","order":14,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"5a7ead1d-6dd9-4c52-8edd-117bcac016b2","order":15,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f533a15c-53d1-4eed-937d-ea0fea0c61f6","order":16,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"b870da00-a85f-431d-ab68-3e9bece39802","order":17,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"39e51db7-e6ba-485b-a5eb-30bdd02c7945","order":18,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"3687f079-bb21-45bf-a90d-6c804956f826","order":19,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"60db5a08-d255-4ac3-818d-50520f096542","order":20,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"cb8d0288-4a15-4bc7-b070-6a2932c1d944","order":21,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"55315ecb-5441-48fa-8814-1cb60c053330","order":22,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"9d26964d-1515-4e54-b784-7959978bac5d","order":23,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"24d47438-7fad-4fc8-af46-f948ffd82ff8","order":24,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"9b0f2747-30f1-45e5-bf90-f1d0c9d9b4b7","order":25,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f5881fd8-b6d3-4571-b9eb-937df493fc62","order":26,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"a4f99b4d-9090-436a-84f2-c89f722c80c4","order":27,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"43438a17-f5b7-444e-8b88-a3c909454cb9","order":28,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f1dc69d8-0bf3-452a-b779-46eca915410e","order":29,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"ee774449-140f-4450-a34f-0d5bdd20028b","order":30,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"658e1423-35c3-4473-a47f-41db58ce87e7","order":31,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"1e528b38-5787-4118-82b6-dfa1e4d1c7ba","order":32,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"02dd17a5-0d59-47b4-b82b-88abd35d42d1","order":33,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"c739d132-48f4-475c-a610-ccd149369d6f","order":34,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"6ec70f7a-cabd-4008-9df0-adeb3479eeb3","order":35,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"82b40382-628b-4906-9c71-42e903d8d1fa","order":36,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"bd1d7d82-7d2c-47e2-b4e9-80833cedf705","order":37,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"ANNIVERSARY"}]}',
          ptag: {
            name: 'vesting',
            id: '466a5e2b-9b98-42f8-b49b-7ad3c5001c73'
          },
          order: 9
        },
        {
          name: 'startAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: 'e96fcf7c-0856-4de6-ae8f-c41ccc4694f7',
          isScalar: true,
          ptag: {
            name: 'startDate',
            id: '9bc9e5ac-aa2a-42e1-9c92-50abd2c8c763'
          },
          order: 10
        }
      ],
      eventGroup: {
        id: '63525afd-e402-4161-a3c9-475092c0a307',
        name: 'Titres'
      },
      processes: [
        {
          name: 'emitStock',
          ptags: null,
          id: '30bbf0ba-93f5-498c-85a7-549a17c97eb6'
        },
        {
          name: 'cancelDelegation',
          ptags: null,
          id: '5c4c761a-f568-40c7-95e5-14634d8eb164'
        },
        {
          name: 'createVesting',
          ptags: null,
          id: 'c637258e-6bd1-4934-8be9-827daffa4535'
        }
      ],
      timelineTags: []
    },
    effectiveAt: '2020-06-01',
    effectiveAtSearch: '01/06/2020',
    isDraft: false,
    documents: [
      {
        documentType: {
          timelineTags: [],
          name: 'import | Acte enregistré (Statuts)',
          id: '9a3253a0-73d0-11e8-9c67-fa163ecedb5e'
        },
        name: 'democorp',
        signedAt: null,
        id: '5f3a4f14-13b2-11eb-8d78-068d0b27b94e'
      }
    ],
    companyId: 'c1610166-cf4c-49d3-92a1-ae80d4302719',
    hash: '229f65fc36069dac378151d47d722ca2e2b9d9c0cb6aa247c4e7c9998a2fbf21',
    audits: [],
    locked: false,
    id: 'b7314a3f-c67e-11ea-ab94-068d0b27b94e'
  },
  {
    event: {
      id: '3130a41c-fc7e-410d-9bc9-a67e4fe7cbec',
      name: 'Emission de titres',
      type: 'emit',
      isScalar: true,
      elements: [
        {
          name: 'CompaniesStock',
          modelType: 'CompaniesStockAlias',
          isOptional: false,
          type: 'model',
          id: '649accdc-5697-4372-a458-eacc48e428e6',
          isScalar: false,
          value:
            '{"id":"2fabac98-de0a-11e9-bb02-0e04bd33b2e4","name":"BCE 2017","isPrincipal":true,"color":null,"isCombined":false,"isComposed":true,"inNFD":false,"inFD":true,"inESOP":true,"inValoGraph":false,"expireAt":null,"companiesStockId":"9c395b54-3cdd-4bc6-8f81-419462828476","stockId":"a7ad7eee-83a0-4fbe-ad4f-1557dfd11f16","composedStock":{"id":"9fd7ce67-5b43-48e4-88e9-61974808e0cc","name":"AO Gen 2","parity":1}}',
          ptag: {
            name: 'companiesStock',
            id: 'cf0f727d-2983-43a7-be3d-01f295d57963'
          },
          order: 0
        },
        {
          method: 'getDelegations',
          name: 'delegation',
          modelType: 'CompaniesEvent',
          isOptional: true,
          type: 'dynamic',
          id: 'e4a58542-735b-4ac1-8652-fff26de4d89b',
          isScalar: false,
          value:
            '{"key":{"effectiveAt":"2020-06-01","name":"Délégation de compétence","priority":2},"id":"e62d1eb4-c679-11ea-ab94-068d0b27b94e"}',
          ptag: {
            name: 'delegation',
            id: '78fd4cce-b813-4d7e-8ab3-ad766fc14505'
          },
          order: 1
        },
        {
          name: 'contact',
          modelType: 'Contact',
          isOptional: false,
          type: 'model',
          id: '06679ccb-9e03-415a-bac1-db2b325020f6',
          isScalar: true,
          value:
            '{"key":"Fabrice Demaret","id":"1ab9c73f-c679-11ea-ab94-068d0b27b94e","options":{"id":"1ab9c73f-c679-11ea-ab94-068d0b27b94e","firstname":"Fabrice","lastname":"Demaret","denomination":null,"type":"NATURAL","pictureUrl":"https://uplaw-dev-public-content.s3.eu-west-3.amazonaws.com/pictures/c1610166-cf4c-49d3-92a1-ae80d4302719/1ab9c73f-c679-11ea-ab94-068d0b27b94e.jpg?v=1594771200000","color":null,"representativeContact":null,"formType":null,"group":{"id":"17e33530-c245-42b9-a06f-2bce943661a7","name":"others","color":"598CEF","order":13}}}',
          ptag: {
            name: 'contact',
            id: 'af5cbd7f-1924-4731-a6a7-bf67a228e98d'
          },
          order: 2
        },
        {
          name: 'quantity',
          modelType: null,
          isOptional: false,
          type: 'integer',
          id: 'ddfcf2e1-0df4-4c2f-b1d2-bcfadea4750f',
          isScalar: true,
          value: '2000',
          ptag: {
            name: 'quantity',
            id: '58e75274-7c6b-4e27-ac4c-e08eb8a24d66'
          },
          order: 3
        },
        {
          name: 'parity',
          modelType: null,
          isOptional: true,
          type: 'double',
          id: 'e91a2149-c077-4cc0-8e0f-cd3bbebc653c',
          isScalar: true,
          ptag: {
            name: 'parity',
            id: '87335f2b-3461-414e-8917-e9fb8e7e13e4'
          },
          order: 4
        },
        {
          name: 'subscriptionPrice',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: '5d628535-e875-4d76-8945-34c0d5644190',
          isScalar: true,
          value: '0',
          ptag: {
            name: 'subscriptionPrice',
            id: '6f2b0ec5-3296-4f2d-b6c7-c8c558e8639b'
          },
          order: 5
        },
        {
          name: 'exercisePrice',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: 'acc9e613-e52f-477b-bbf4-7be37c56af7e',
          isScalar: true,
          value: '90',
          ptag: {
            name: 'exercisePrice',
            id: '3a52986b-5d3d-4d38-b956-11f5201a8b41'
          },
          order: 6
        },
        {
          name: 'liberatedAmount',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: '47eb9ae4-8ecb-4e18-8dfe-9e0ef503316a',
          isScalar: true,
          ptag: {
            name: 'liberatedAmount',
            id: '28ebec26-9c4b-44be-9778-7bd2056db8da'
          },
          order: 7
        },
        {
          name: 'expireAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: 'bc082efd-7ea5-4eba-934c-46057c79d204',
          isScalar: true,
          value: '2030-06-01',
          ptag: {
            name: 'endDate',
            id: 'bbf6c789-ced3-47c3-8b85-161157218484'
          },
          order: 8
        },
        {
          name: 'vesting',
          modelType: 'CompaniesVesting',
          isOptional: true,
          type: 'model',
          id: '4dfa00c6-7f03-47bf-97c5-a98ac76d3cd5',
          isScalar: true,
          value:
            '{"id":"e538abb1-c67a-11ea-ab94-068d0b27b94e","name":"BSPCE2017-2","exerciseDelayUnit":null,"exerciseDelayQuantity":null,"useSplitValue":false,"vestingPeriods":[{"id":"d5ee9fdf-b9e3-4e16-a6d8-eb2806364bbf","order":0,"quantity":null,"percentage":0,"fraction":null,"periodUnit":"DAYS","periodQty":0,"periodType":"VESTING","startDateType":"ENTRY","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"fb81ae9e-bbe5-4487-a19d-64043f9e63d3","order":1,"quantity":null,"percentage":25,"fraction":null,"periodUnit":"MONTHS","periodQty":12,"periodType":"WAIT","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"370eb48d-d52e-4f8b-8747-448208275409","order":2,"quantity":null,"percentage":25,"fraction":null,"periodUnit":"MONTHS","periodQty":12,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"2452e6d9-f610-45cc-a313-2b234b7bc662","order":3,"quantity":null,"percentage":25,"fraction":null,"periodUnit":"MONTHS","periodQty":12,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"d3bba33a-7076-499b-b0a2-897934df5649","order":4,"quantity":null,"percentage":25,"fraction":null,"periodUnit":"MONTHS","periodQty":12,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"}]}',
          ptag: {
            name: 'vesting',
            id: '466a5e2b-9b98-42f8-b49b-7ad3c5001c73'
          },
          order: 9
        },
        {
          name: 'startAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: 'e96fcf7c-0856-4de6-ae8f-c41ccc4694f7',
          isScalar: true,
          ptag: {
            name: 'startDate',
            id: '9bc9e5ac-aa2a-42e1-9c92-50abd2c8c763'
          },
          order: 10
        }
      ],
      eventGroup: {
        id: '63525afd-e402-4161-a3c9-475092c0a307',
        name: 'Titres'
      },
      processes: [
        {
          name: 'emitStock',
          ptags: null,
          id: '30bbf0ba-93f5-498c-85a7-549a17c97eb6'
        },
        {
          name: 'cancelDelegation',
          ptags: null,
          id: '5c4c761a-f568-40c7-95e5-14634d8eb164'
        },
        {
          name: 'createVesting',
          ptags: null,
          id: 'c637258e-6bd1-4934-8be9-827daffa4535'
        }
      ],
      timelineTags: []
    },
    effectiveAt: '2020-06-01',
    effectiveAtSearch: '01/06/2020',
    isDraft: false,
    documents: [
      {
        documentType: {
          timelineTags: [],
          name: 'import | Acte enregistré (Statuts)',
          id: '9a3253a0-73d0-11e8-9c67-fa163ecedb5e'
        },
        name: 'democorp',
        signedAt: null,
        id: '5f3a4f14-13b2-11eb-8d78-068d0b27b94e'
      }
    ],
    companyId: 'c1610166-cf4c-49d3-92a1-ae80d4302719',
    hash: '229f65fc36069dac378151d47d722ca2e2b9d9c0cb6aa247c4e7c9998a2fbf21',
    audits: [],
    locked: false,
    id: 'b7311e42-c67e-11ea-ab94-068d0b27b94e'
  },
  {
    event: {
      id: '3130a41c-fc7e-410d-9bc9-a67e4fe7cbec',
      name: 'Emission de titres',
      type: 'emit',
      isScalar: true,
      elements: [
        {
          name: 'CompaniesStock',
          modelType: 'CompaniesStockAlias',
          isOptional: false,
          type: 'model',
          id: '649accdc-5697-4372-a458-eacc48e428e6',
          isScalar: false,
          value:
            '{"id":"2fabac98-de0a-11e9-bb02-0e04bd33b2e4","name":"BCE 2017","isPrincipal":true,"color":null,"isCombined":false,"isComposed":true,"inNFD":false,"inFD":true,"inESOP":true,"inValoGraph":false,"expireAt":null,"companiesStockId":"9c395b54-3cdd-4bc6-8f81-419462828476","stockId":"a7ad7eee-83a0-4fbe-ad4f-1557dfd11f16","composedStock":{"id":"9fd7ce67-5b43-48e4-88e9-61974808e0cc","name":"AO Gen 2","parity":1}}',
          ptag: {
            name: 'companiesStock',
            id: 'cf0f727d-2983-43a7-be3d-01f295d57963'
          },
          order: 0
        },
        {
          method: 'getDelegations',
          name: 'delegation',
          modelType: 'CompaniesEvent',
          isOptional: true,
          type: 'dynamic',
          id: 'e4a58542-735b-4ac1-8652-fff26de4d89b',
          isScalar: false,
          value:
            '{"key":{"effectiveAt":"2020-06-01","name":"Délégation de compétence","priority":2},"id":"e62d1eb4-c679-11ea-ab94-068d0b27b94e"}',
          ptag: {
            name: 'delegation',
            id: '78fd4cce-b813-4d7e-8ab3-ad766fc14505'
          },
          order: 1
        },
        {
          name: 'contact',
          modelType: 'Contact',
          isOptional: false,
          type: 'model',
          id: '06679ccb-9e03-415a-bac1-db2b325020f6',
          isScalar: true,
          value:
            '{"key":"Dieudonnée Bard","id":"f380ddbe-c678-11ea-ab94-068d0b27b94e","options":{"id":"f380ddbe-c678-11ea-ab94-068d0b27b94e","firstname":"Dieudonnée","lastname":"Bard","denomination":null,"type":"NATURAL","pictureUrl":"https://uplaw-dev-public-content.s3.eu-west-3.amazonaws.com/pictures/c1610166-cf4c-49d3-92a1-ae80d4302719/f380ddbe-c678-11ea-ab94-068d0b27b94e.jpg?v=1594771200000","color":null,"representativeContact":null,"formType":null,"group":{"id":"17e33530-c245-42b9-a06f-2bce943661a7","name":"others","color":"598CEF","order":13}}}',
          ptag: {
            name: 'contact',
            id: 'af5cbd7f-1924-4731-a6a7-bf67a228e98d'
          },
          order: 2
        },
        {
          name: 'quantity',
          modelType: null,
          isOptional: false,
          type: 'integer',
          id: 'ddfcf2e1-0df4-4c2f-b1d2-bcfadea4750f',
          isScalar: true,
          value: '2000',
          ptag: {
            name: 'quantity',
            id: '58e75274-7c6b-4e27-ac4c-e08eb8a24d66'
          },
          order: 3
        },
        {
          name: 'parity',
          modelType: null,
          isOptional: true,
          type: 'double',
          id: 'e91a2149-c077-4cc0-8e0f-cd3bbebc653c',
          isScalar: true,
          ptag: {
            name: 'parity',
            id: '87335f2b-3461-414e-8917-e9fb8e7e13e4'
          },
          order: 4
        },
        {
          name: 'subscriptionPrice',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: '5d628535-e875-4d76-8945-34c0d5644190',
          isScalar: true,
          value: '0',
          ptag: {
            name: 'subscriptionPrice',
            id: '6f2b0ec5-3296-4f2d-b6c7-c8c558e8639b'
          },
          order: 5
        },
        {
          name: 'exercisePrice',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: 'acc9e613-e52f-477b-bbf4-7be37c56af7e',
          isScalar: true,
          value: '90',
          ptag: {
            name: 'exercisePrice',
            id: '3a52986b-5d3d-4d38-b956-11f5201a8b41'
          },
          order: 6
        },
        {
          name: 'liberatedAmount',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: '47eb9ae4-8ecb-4e18-8dfe-9e0ef503316a',
          isScalar: true,
          ptag: {
            name: 'liberatedAmount',
            id: '28ebec26-9c4b-44be-9778-7bd2056db8da'
          },
          order: 7
        },
        {
          name: 'expireAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: 'bc082efd-7ea5-4eba-934c-46057c79d204',
          isScalar: true,
          value: '2030-06-01',
          ptag: {
            name: 'endDate',
            id: 'bbf6c789-ced3-47c3-8b85-161157218484'
          },
          order: 8
        },
        {
          name: 'vesting',
          modelType: 'CompaniesVesting',
          isOptional: true,
          type: 'model',
          id: '4dfa00c6-7f03-47bf-97c5-a98ac76d3cd5',
          isScalar: true,
          value:
            '{"id":"6bcdb585-c67a-11ea-ab94-068d0b27b94e","name":"BSPCE2017-1","exerciseDelayUnit":null,"exerciseDelayQuantity":null,"useSplitValue":false,"vestingPeriods":[{"id":"7131f3b2-16cb-439c-bceb-8862d409eac5","order":0,"quantity":null,"percentage":0,"fraction":null,"periodUnit":"DAYS","periodQty":0,"periodType":"VESTING","startDateType":"ENTRY","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"ANNIVERSARY"},{"id":"41a4b010-e38a-4488-a9a0-726007ef2de7","order":1,"quantity":null,"percentage":25,"fraction":null,"periodUnit":"MONTHS","periodQty":12,"periodType":"WAIT","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"ANNIVERSARY"},{"id":"8368a55c-335f-4635-839c-34fd0862fc19","order":2,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"8fad6f2e-cba9-4a7e-8ee4-9ba5bcc5ca66","order":3,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"64e23373-e4f9-4a95-8000-98cbee8e56a3","order":4,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"e5d15ebd-8a1b-40b3-b35c-caf9e4aca233","order":5,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"899c7267-fde9-44bc-86e2-5a29fbf647ae","order":6,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f876c88f-cf55-4447-83f2-5af47aa8fcf6","order":7,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"7bcf3559-ed00-4900-8dbb-4c0926d4a0c1","order":8,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"9904da0d-5ecf-4ac2-85d6-f79df00beb40","order":9,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"d24a9664-56b6-4fad-a876-5f1210fa5e6d","order":10,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"8996df1d-83b0-4dd1-82ff-8a049fdbb2e7","order":11,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"889ce04a-8c29-48c1-9599-516a103d03d1","order":12,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"69cbce43-769e-4fc0-b78b-507a949c22d1","order":13,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"2b0726cf-bbfa-497d-86d5-d69d810b606a","order":14,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"5a7ead1d-6dd9-4c52-8edd-117bcac016b2","order":15,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f533a15c-53d1-4eed-937d-ea0fea0c61f6","order":16,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"b870da00-a85f-431d-ab68-3e9bece39802","order":17,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"39e51db7-e6ba-485b-a5eb-30bdd02c7945","order":18,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"3687f079-bb21-45bf-a90d-6c804956f826","order":19,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"60db5a08-d255-4ac3-818d-50520f096542","order":20,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"cb8d0288-4a15-4bc7-b070-6a2932c1d944","order":21,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"55315ecb-5441-48fa-8814-1cb60c053330","order":22,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"9d26964d-1515-4e54-b784-7959978bac5d","order":23,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"24d47438-7fad-4fc8-af46-f948ffd82ff8","order":24,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"9b0f2747-30f1-45e5-bf90-f1d0c9d9b4b7","order":25,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f5881fd8-b6d3-4571-b9eb-937df493fc62","order":26,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"a4f99b4d-9090-436a-84f2-c89f722c80c4","order":27,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"43438a17-f5b7-444e-8b88-a3c909454cb9","order":28,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f1dc69d8-0bf3-452a-b779-46eca915410e","order":29,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"ee774449-140f-4450-a34f-0d5bdd20028b","order":30,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"658e1423-35c3-4473-a47f-41db58ce87e7","order":31,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"1e528b38-5787-4118-82b6-dfa1e4d1c7ba","order":32,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"02dd17a5-0d59-47b4-b82b-88abd35d42d1","order":33,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"c739d132-48f4-475c-a610-ccd149369d6f","order":34,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"6ec70f7a-cabd-4008-9df0-adeb3479eeb3","order":35,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"82b40382-628b-4906-9c71-42e903d8d1fa","order":36,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"bd1d7d82-7d2c-47e2-b4e9-80833cedf705","order":37,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"ANNIVERSARY"}]}',
          ptag: {
            name: 'vesting',
            id: '466a5e2b-9b98-42f8-b49b-7ad3c5001c73'
          },
          order: 9
        },
        {
          name: 'startAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: 'e96fcf7c-0856-4de6-ae8f-c41ccc4694f7',
          isScalar: true,
          ptag: {
            name: 'startDate',
            id: '9bc9e5ac-aa2a-42e1-9c92-50abd2c8c763'
          },
          order: 10
        }
      ],
      eventGroup: {
        id: '63525afd-e402-4161-a3c9-475092c0a307',
        name: 'Titres'
      },
      processes: [
        {
          name: 'emitStock',
          ptags: null,
          id: '30bbf0ba-93f5-498c-85a7-549a17c97eb6'
        },
        {
          name: 'cancelDelegation',
          ptags: null,
          id: '5c4c761a-f568-40c7-95e5-14634d8eb164'
        },
        {
          name: 'createVesting',
          ptags: null,
          id: 'c637258e-6bd1-4934-8be9-827daffa4535'
        }
      ],
      timelineTags: []
    },
    effectiveAt: '2020-06-01',
    effectiveAtSearch: '01/06/2020',
    isDraft: false,
    documents: [
      {
        documentType: {
          timelineTags: [],
          name: 'import | Acte enregistré (Statuts)',
          id: '9a3253a0-73d0-11e8-9c67-fa163ecedb5e'
        },
        name: 'democorp',
        signedAt: null,
        id: '5f3a4f14-13b2-11eb-8d78-068d0b27b94e'
      }
    ],
    companyId: 'c1610166-cf4c-49d3-92a1-ae80d4302719',
    hash: '229f65fc36069dac378151d47d722ca2e2b9d9c0cb6aa247c4e7c9998a2fbf21',
    audits: [],
    locked: false,
    id: 'b7307d22-c67e-11ea-ab94-068d0b27b94e'
  },
  {
    event: {
      id: '3130a41c-fc7e-410d-9bc9-a67e4fe7cbec',
      name: 'Emission de titres',
      type: 'emit',
      isScalar: true,
      elements: [
        {
          name: 'CompaniesStock',
          modelType: 'CompaniesStockAlias',
          isOptional: false,
          type: 'model',
          id: '649accdc-5697-4372-a458-eacc48e428e6',
          isScalar: false,
          value:
            '{"id":"2fabac98-de0a-11e9-bb02-0e04bd33b2e4","name":"BCE 2017","isPrincipal":true,"color":null,"isCombined":false,"isComposed":true,"inNFD":false,"inFD":true,"inESOP":true,"inValoGraph":false,"expireAt":null,"companiesStockId":"9c395b54-3cdd-4bc6-8f81-419462828476","stockId":"a7ad7eee-83a0-4fbe-ad4f-1557dfd11f16","composedStock":{"id":"9fd7ce67-5b43-48e4-88e9-61974808e0cc","name":"AO Gen 2","parity":1}}',
          ptag: {
            name: 'companiesStock',
            id: 'cf0f727d-2983-43a7-be3d-01f295d57963'
          },
          order: 0
        },
        {
          method: 'getDelegations',
          name: 'delegation',
          modelType: 'CompaniesEvent',
          isOptional: true,
          type: 'dynamic',
          id: 'e4a58542-735b-4ac1-8652-fff26de4d89b',
          isScalar: false,
          value:
            '{"key":{"effectiveAt":"2020-06-01","name":"Délégation de compétence","priority":2},"id":"e62d1eb4-c679-11ea-ab94-068d0b27b94e"}',
          ptag: {
            name: 'delegation',
            id: '78fd4cce-b813-4d7e-8ab3-ad766fc14505'
          },
          order: 1
        },
        {
          name: 'contact',
          modelType: 'Contact',
          isOptional: false,
          type: 'model',
          id: '06679ccb-9e03-415a-bac1-db2b325020f6',
          isScalar: true,
          value:
            '{"key":"Denis-Suzanne Chaigneau","id":"fd330fe0-c678-11ea-ab94-068d0b27b94e","options":{"id":"fd330fe0-c678-11ea-ab94-068d0b27b94e","firstname":"Denis-Suzanne","lastname":"Chaigneau","denomination":null,"type":"NATURAL","pictureUrl":"https://uplaw-dev-public-content.s3.eu-west-3.amazonaws.com/pictures/c1610166-cf4c-49d3-92a1-ae80d4302719/fd330fe0-c678-11ea-ab94-068d0b27b94e.jpg?v=1594771200000","color":null,"representativeContact":null,"formType":null,"group":{"id":"17e33530-c245-42b9-a06f-2bce943661a7","name":"others","color":"598CEF","order":13}}}',
          ptag: {
            name: 'contact',
            id: 'af5cbd7f-1924-4731-a6a7-bf67a228e98d'
          },
          order: 2
        },
        {
          name: 'quantity',
          modelType: null,
          isOptional: false,
          type: 'integer',
          id: 'ddfcf2e1-0df4-4c2f-b1d2-bcfadea4750f',
          isScalar: true,
          value: '2000',
          ptag: {
            name: 'quantity',
            id: '58e75274-7c6b-4e27-ac4c-e08eb8a24d66'
          },
          order: 3
        },
        {
          name: 'parity',
          modelType: null,
          isOptional: true,
          type: 'double',
          id: 'e91a2149-c077-4cc0-8e0f-cd3bbebc653c',
          isScalar: true,
          ptag: {
            name: 'parity',
            id: '87335f2b-3461-414e-8917-e9fb8e7e13e4'
          },
          order: 4
        },
        {
          name: 'subscriptionPrice',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: '5d628535-e875-4d76-8945-34c0d5644190',
          isScalar: true,
          value: '0',
          ptag: {
            name: 'subscriptionPrice',
            id: '6f2b0ec5-3296-4f2d-b6c7-c8c558e8639b'
          },
          order: 5
        },
        {
          name: 'exercisePrice',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: 'acc9e613-e52f-477b-bbf4-7be37c56af7e',
          isScalar: true,
          value: '90',
          ptag: {
            name: 'exercisePrice',
            id: '3a52986b-5d3d-4d38-b956-11f5201a8b41'
          },
          order: 6
        },
        {
          name: 'liberatedAmount',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: '47eb9ae4-8ecb-4e18-8dfe-9e0ef503316a',
          isScalar: true,
          ptag: {
            name: 'liberatedAmount',
            id: '28ebec26-9c4b-44be-9778-7bd2056db8da'
          },
          order: 7
        },
        {
          name: 'expireAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: 'bc082efd-7ea5-4eba-934c-46057c79d204',
          isScalar: true,
          value: '2030-06-01',
          ptag: {
            name: 'endDate',
            id: 'bbf6c789-ced3-47c3-8b85-161157218484'
          },
          order: 8
        },
        {
          name: 'vesting',
          modelType: 'CompaniesVesting',
          isOptional: true,
          type: 'model',
          id: '4dfa00c6-7f03-47bf-97c5-a98ac76d3cd5',
          isScalar: true,
          value:
            '{"id":"6bcdb585-c67a-11ea-ab94-068d0b27b94e","name":"BSPCE2017-1","exerciseDelayUnit":null,"exerciseDelayQuantity":null,"useSplitValue":false,"vestingPeriods":[{"id":"7131f3b2-16cb-439c-bceb-8862d409eac5","order":0,"quantity":null,"percentage":0,"fraction":null,"periodUnit":"DAYS","periodQty":0,"periodType":"VESTING","startDateType":"ENTRY","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"ANNIVERSARY"},{"id":"41a4b010-e38a-4488-a9a0-726007ef2de7","order":1,"quantity":null,"percentage":25,"fraction":null,"periodUnit":"MONTHS","periodQty":12,"periodType":"WAIT","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"ANNIVERSARY"},{"id":"8368a55c-335f-4635-839c-34fd0862fc19","order":2,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"8fad6f2e-cba9-4a7e-8ee4-9ba5bcc5ca66","order":3,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"64e23373-e4f9-4a95-8000-98cbee8e56a3","order":4,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"e5d15ebd-8a1b-40b3-b35c-caf9e4aca233","order":5,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"899c7267-fde9-44bc-86e2-5a29fbf647ae","order":6,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f876c88f-cf55-4447-83f2-5af47aa8fcf6","order":7,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"7bcf3559-ed00-4900-8dbb-4c0926d4a0c1","order":8,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"9904da0d-5ecf-4ac2-85d6-f79df00beb40","order":9,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"d24a9664-56b6-4fad-a876-5f1210fa5e6d","order":10,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"8996df1d-83b0-4dd1-82ff-8a049fdbb2e7","order":11,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"889ce04a-8c29-48c1-9599-516a103d03d1","order":12,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"69cbce43-769e-4fc0-b78b-507a949c22d1","order":13,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"2b0726cf-bbfa-497d-86d5-d69d810b606a","order":14,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"5a7ead1d-6dd9-4c52-8edd-117bcac016b2","order":15,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f533a15c-53d1-4eed-937d-ea0fea0c61f6","order":16,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"b870da00-a85f-431d-ab68-3e9bece39802","order":17,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"39e51db7-e6ba-485b-a5eb-30bdd02c7945","order":18,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"3687f079-bb21-45bf-a90d-6c804956f826","order":19,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"60db5a08-d255-4ac3-818d-50520f096542","order":20,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"cb8d0288-4a15-4bc7-b070-6a2932c1d944","order":21,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"55315ecb-5441-48fa-8814-1cb60c053330","order":22,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"9d26964d-1515-4e54-b784-7959978bac5d","order":23,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"24d47438-7fad-4fc8-af46-f948ffd82ff8","order":24,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"9b0f2747-30f1-45e5-bf90-f1d0c9d9b4b7","order":25,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f5881fd8-b6d3-4571-b9eb-937df493fc62","order":26,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"a4f99b4d-9090-436a-84f2-c89f722c80c4","order":27,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"43438a17-f5b7-444e-8b88-a3c909454cb9","order":28,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f1dc69d8-0bf3-452a-b779-46eca915410e","order":29,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"ee774449-140f-4450-a34f-0d5bdd20028b","order":30,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"658e1423-35c3-4473-a47f-41db58ce87e7","order":31,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"1e528b38-5787-4118-82b6-dfa1e4d1c7ba","order":32,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"02dd17a5-0d59-47b4-b82b-88abd35d42d1","order":33,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"c739d132-48f4-475c-a610-ccd149369d6f","order":34,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"6ec70f7a-cabd-4008-9df0-adeb3479eeb3","order":35,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"82b40382-628b-4906-9c71-42e903d8d1fa","order":36,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"bd1d7d82-7d2c-47e2-b4e9-80833cedf705","order":37,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"ANNIVERSARY"}]}',
          ptag: {
            name: 'vesting',
            id: '466a5e2b-9b98-42f8-b49b-7ad3c5001c73'
          },
          order: 9
        },
        {
          name: 'startAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: 'e96fcf7c-0856-4de6-ae8f-c41ccc4694f7',
          isScalar: true,
          ptag: {
            name: 'startDate',
            id: '9bc9e5ac-aa2a-42e1-9c92-50abd2c8c763'
          },
          order: 10
        }
      ],
      eventGroup: {
        id: '63525afd-e402-4161-a3c9-475092c0a307',
        name: 'Titres'
      },
      processes: [
        {
          name: 'emitStock',
          ptags: null,
          id: '30bbf0ba-93f5-498c-85a7-549a17c97eb6'
        },
        {
          name: 'cancelDelegation',
          ptags: null,
          id: '5c4c761a-f568-40c7-95e5-14634d8eb164'
        },
        {
          name: 'createVesting',
          ptags: null,
          id: 'c637258e-6bd1-4934-8be9-827daffa4535'
        }
      ],
      timelineTags: []
    },
    effectiveAt: '2020-06-01',
    effectiveAtSearch: '01/06/2020',
    isDraft: false,
    documents: [
      {
        documentType: {
          timelineTags: [],
          name: 'import | Acte enregistré (Statuts)',
          id: '9a3253a0-73d0-11e8-9c67-fa163ecedb5e'
        },
        name: 'democorp',
        signedAt: null,
        id: '5f3a4f14-13b2-11eb-8d78-068d0b27b94e'
      }
    ],
    companyId: 'c1610166-cf4c-49d3-92a1-ae80d4302719',
    hash: '229f65fc36069dac378151d47d722ca2e2b9d9c0cb6aa247c4e7c9998a2fbf21',
    audits: [],
    locked: false,
    id: 'b73094dc-c67e-11ea-ab94-068d0b27b94e'
  },
  {
    event: {
      id: '3130a41c-fc7e-410d-9bc9-a67e4fe7cbec',
      name: 'Emission de titres',
      type: 'emit',
      isScalar: true,
      elements: [
        {
          name: 'CompaniesStock',
          modelType: 'CompaniesStockAlias',
          isOptional: false,
          type: 'model',
          id: '649accdc-5697-4372-a458-eacc48e428e6',
          isScalar: false,
          value:
            '{"id":"2fabac98-de0a-11e9-bb02-0e04bd33b2e4","name":"BCE 2017","isPrincipal":true,"color":null,"isCombined":false,"isComposed":true,"inNFD":false,"inFD":true,"inESOP":true,"inValoGraph":false,"expireAt":null,"companiesStockId":"9c395b54-3cdd-4bc6-8f81-419462828476","stockId":"a7ad7eee-83a0-4fbe-ad4f-1557dfd11f16","composedStock":{"id":"9fd7ce67-5b43-48e4-88e9-61974808e0cc","name":"AO Gen 2","parity":1}}',
          ptag: {
            name: 'companiesStock',
            id: 'cf0f727d-2983-43a7-be3d-01f295d57963'
          },
          order: 0
        },
        {
          method: 'getDelegations',
          name: 'delegation',
          modelType: 'CompaniesEvent',
          isOptional: true,
          type: 'dynamic',
          id: 'e4a58542-735b-4ac1-8652-fff26de4d89b',
          isScalar: false,
          value:
            '{"key":{"effectiveAt":"2020-06-01","name":"Délégation de compétence","priority":2},"id":"e62d1eb4-c679-11ea-ab94-068d0b27b94e"}',
          ptag: {
            name: 'delegation',
            id: '78fd4cce-b813-4d7e-8ab3-ad766fc14505'
          },
          order: 1
        },
        {
          name: 'contact',
          modelType: 'Contact',
          isOptional: false,
          type: 'model',
          id: '06679ccb-9e03-415a-bac1-db2b325020f6',
          isScalar: true,
          value:
            '{"key":"Judith Evrard","id":"e3d29a96-c678-11ea-ab94-068d0b27b94e","options":{"id":"e3d29a96-c678-11ea-ab94-068d0b27b94e","firstname":"Judith","lastname":"Evrard","denomination":null,"type":"NATURAL","pictureUrl":"https://uplaw-dev-public-content.s3.eu-west-3.amazonaws.com/pictures/c1610166-cf4c-49d3-92a1-ae80d4302719/e3d29a96-c678-11ea-ab94-068d0b27b94e.jpg?v=1594771200000","color":null,"representativeContact":null,"formType":null,"group":{"id":"17e33530-c245-42b9-a06f-2bce943661a7","name":"others","color":"598CEF","order":13}}}',
          ptag: {
            name: 'contact',
            id: 'af5cbd7f-1924-4731-a6a7-bf67a228e98d'
          },
          order: 2
        },
        {
          name: 'quantity',
          modelType: null,
          isOptional: false,
          type: 'integer',
          id: 'ddfcf2e1-0df4-4c2f-b1d2-bcfadea4750f',
          isScalar: true,
          value: '2000',
          ptag: {
            name: 'quantity',
            id: '58e75274-7c6b-4e27-ac4c-e08eb8a24d66'
          },
          order: 3
        },
        {
          name: 'parity',
          modelType: null,
          isOptional: true,
          type: 'double',
          id: 'e91a2149-c077-4cc0-8e0f-cd3bbebc653c',
          isScalar: true,
          ptag: {
            name: 'parity',
            id: '87335f2b-3461-414e-8917-e9fb8e7e13e4'
          },
          order: 4
        },
        {
          name: 'subscriptionPrice',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: '5d628535-e875-4d76-8945-34c0d5644190',
          isScalar: true,
          value: '0',
          ptag: {
            name: 'subscriptionPrice',
            id: '6f2b0ec5-3296-4f2d-b6c7-c8c558e8639b'
          },
          order: 5
        },
        {
          name: 'exercisePrice',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: 'acc9e613-e52f-477b-bbf4-7be37c56af7e',
          isScalar: true,
          value: '90',
          ptag: {
            name: 'exercisePrice',
            id: '3a52986b-5d3d-4d38-b956-11f5201a8b41'
          },
          order: 6
        },
        {
          name: 'liberatedAmount',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: '47eb9ae4-8ecb-4e18-8dfe-9e0ef503316a',
          isScalar: true,
          ptag: {
            name: 'liberatedAmount',
            id: '28ebec26-9c4b-44be-9778-7bd2056db8da'
          },
          order: 7
        },
        {
          name: 'expireAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: 'bc082efd-7ea5-4eba-934c-46057c79d204',
          isScalar: true,
          value: '2030-06-01',
          ptag: {
            name: 'endDate',
            id: 'bbf6c789-ced3-47c3-8b85-161157218484'
          },
          order: 8
        },
        {
          name: 'vesting',
          modelType: 'CompaniesVesting',
          isOptional: true,
          type: 'model',
          id: '4dfa00c6-7f03-47bf-97c5-a98ac76d3cd5',
          isScalar: true,
          value:
            '{"id":"6bcdb585-c67a-11ea-ab94-068d0b27b94e","name":"BSPCE2017-1","exerciseDelayUnit":null,"exerciseDelayQuantity":null,"useSplitValue":false,"vestingPeriods":[{"id":"7131f3b2-16cb-439c-bceb-8862d409eac5","order":0,"quantity":null,"percentage":0,"fraction":null,"periodUnit":"DAYS","periodQty":0,"periodType":"VESTING","startDateType":"ENTRY","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"ANNIVERSARY"},{"id":"41a4b010-e38a-4488-a9a0-726007ef2de7","order":1,"quantity":null,"percentage":25,"fraction":null,"periodUnit":"MONTHS","periodQty":12,"periodType":"WAIT","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"ANNIVERSARY"},{"id":"8368a55c-335f-4635-839c-34fd0862fc19","order":2,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"8fad6f2e-cba9-4a7e-8ee4-9ba5bcc5ca66","order":3,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"64e23373-e4f9-4a95-8000-98cbee8e56a3","order":4,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"e5d15ebd-8a1b-40b3-b35c-caf9e4aca233","order":5,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"899c7267-fde9-44bc-86e2-5a29fbf647ae","order":6,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f876c88f-cf55-4447-83f2-5af47aa8fcf6","order":7,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"7bcf3559-ed00-4900-8dbb-4c0926d4a0c1","order":8,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"9904da0d-5ecf-4ac2-85d6-f79df00beb40","order":9,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"d24a9664-56b6-4fad-a876-5f1210fa5e6d","order":10,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"8996df1d-83b0-4dd1-82ff-8a049fdbb2e7","order":11,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"889ce04a-8c29-48c1-9599-516a103d03d1","order":12,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"69cbce43-769e-4fc0-b78b-507a949c22d1","order":13,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"2b0726cf-bbfa-497d-86d5-d69d810b606a","order":14,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"5a7ead1d-6dd9-4c52-8edd-117bcac016b2","order":15,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f533a15c-53d1-4eed-937d-ea0fea0c61f6","order":16,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"b870da00-a85f-431d-ab68-3e9bece39802","order":17,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"39e51db7-e6ba-485b-a5eb-30bdd02c7945","order":18,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"3687f079-bb21-45bf-a90d-6c804956f826","order":19,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"60db5a08-d255-4ac3-818d-50520f096542","order":20,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"cb8d0288-4a15-4bc7-b070-6a2932c1d944","order":21,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"55315ecb-5441-48fa-8814-1cb60c053330","order":22,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"9d26964d-1515-4e54-b784-7959978bac5d","order":23,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"24d47438-7fad-4fc8-af46-f948ffd82ff8","order":24,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"9b0f2747-30f1-45e5-bf90-f1d0c9d9b4b7","order":25,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f5881fd8-b6d3-4571-b9eb-937df493fc62","order":26,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"a4f99b4d-9090-436a-84f2-c89f722c80c4","order":27,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"43438a17-f5b7-444e-8b88-a3c909454cb9","order":28,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"f1dc69d8-0bf3-452a-b779-46eca915410e","order":29,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"ee774449-140f-4450-a34f-0d5bdd20028b","order":30,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"658e1423-35c3-4473-a47f-41db58ce87e7","order":31,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"1e528b38-5787-4118-82b6-dfa1e4d1c7ba","order":32,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"02dd17a5-0d59-47b4-b82b-88abd35d42d1","order":33,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"c739d132-48f4-475c-a610-ccd149369d6f","order":34,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"6ec70f7a-cabd-4008-9df0-adeb3479eeb3","order":35,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"82b40382-628b-4906-9c71-42e903d8d1fa","order":36,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"bd1d7d82-7d2c-47e2-b4e9-80833cedf705","order":37,"quantity":null,"percentage":2.08333,"fraction":null,"periodUnit":"MONTHS","periodQty":1,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"ANNIVERSARY"}]}',
          ptag: {
            name: 'vesting',
            id: '466a5e2b-9b98-42f8-b49b-7ad3c5001c73'
          },
          order: 9
        },
        {
          name: 'startAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: 'e96fcf7c-0856-4de6-ae8f-c41ccc4694f7',
          isScalar: true,
          ptag: {
            name: 'startDate',
            id: '9bc9e5ac-aa2a-42e1-9c92-50abd2c8c763'
          },
          order: 10
        }
      ],
      eventGroup: {
        id: '63525afd-e402-4161-a3c9-475092c0a307',
        name: 'Titres'
      },
      processes: [
        {
          name: 'emitStock',
          ptags: null,
          id: '30bbf0ba-93f5-498c-85a7-549a17c97eb6'
        },
        {
          name: 'cancelDelegation',
          ptags: null,
          id: '5c4c761a-f568-40c7-95e5-14634d8eb164'
        },
        {
          name: 'createVesting',
          ptags: null,
          id: 'c637258e-6bd1-4934-8be9-827daffa4535'
        }
      ],
      timelineTags: []
    },
    effectiveAt: '2020-06-01',
    effectiveAtSearch: '01/06/2020',
    isDraft: false,
    documents: [
      {
        documentType: {
          timelineTags: [],
          name: 'import | Acte enregistré (Statuts)',
          id: '9a3253a0-73d0-11e8-9c67-fa163ecedb5e'
        },
        name: 'democorp',
        signedAt: null,
        id: '5f3a4f14-13b2-11eb-8d78-068d0b27b94e'
      }
    ],
    companyId: 'c1610166-cf4c-49d3-92a1-ae80d4302719',
    hash: '229f65fc36069dac378151d47d722ca2e2b9d9c0cb6aa247c4e7c9998a2fbf21',
    audits: [],
    locked: false,
    id: '2ef386ed-c67d-11ea-ab94-068d0b27b94e'
  },
  {
    event: {
      id: '3130a41c-fc7e-410d-9bc9-a67e4fe7cbec',
      name: 'Emission de titres',
      type: 'emit',
      isScalar: true,
      elements: [
        {
          name: 'CompaniesStock',
          modelType: 'CompaniesStockAlias',
          isOptional: false,
          type: 'model',
          id: '649accdc-5697-4372-a458-eacc48e428e6',
          isScalar: false,
          value:
            '{"id":"2fabac98-de0a-11e9-bb02-0e04bd33b2e4","name":"BCE 2017","isPrincipal":true,"color":null,"isCombined":false,"isComposed":true,"inNFD":false,"inFD":true,"inESOP":true,"inValoGraph":false,"expireAt":null,"companiesStockId":"9c395b54-3cdd-4bc6-8f81-419462828476","stockId":"a7ad7eee-83a0-4fbe-ad4f-1557dfd11f16","composedStock":{"id":"9fd7ce67-5b43-48e4-88e9-61974808e0cc","name":"AO Gen 2","parity":1}}',
          ptag: {
            name: 'companiesStock',
            id: 'cf0f727d-2983-43a7-be3d-01f295d57963'
          },
          order: 0
        },
        {
          method: 'getDelegations',
          name: 'delegation',
          modelType: 'CompaniesEvent',
          isOptional: true,
          type: 'dynamic',
          id: 'e4a58542-735b-4ac1-8652-fff26de4d89b',
          isScalar: false,
          value:
            '{"key":{"effectiveAt":"2020-06-01","name":"Délégation de compétence","priority":2},"id":"e62d1eb4-c679-11ea-ab94-068d0b27b94e"}',
          ptag: {
            name: 'delegation',
            id: '78fd4cce-b813-4d7e-8ab3-ad766fc14505'
          },
          order: 1
        },
        {
          name: 'contact',
          modelType: 'Contact',
          isOptional: false,
          type: 'model',
          id: '06679ccb-9e03-415a-bac1-db2b325020f6',
          isScalar: true,
          value:
            '{"key":"Simon-Céline Pech","id":"77cd7876-c678-11ea-ab94-068d0b27b94e","options":{"id":"77cd7876-c678-11ea-ab94-068d0b27b94e","firstname":"Simon-Céline","lastname":"Pech","denomination":null,"type":"NATURAL","pictureUrl":"https://uplaw-dev-public-content.s3.eu-west-3.amazonaws.com/pictures/c1610166-cf4c-49d3-92a1-ae80d4302719/77cd7876-c678-11ea-ab94-068d0b27b94e.jpg?v=1594771200000","color":null,"representativeContact":null,"formType":null,"group":{"id":"17e33530-c245-42b9-a06f-2bce943661a7","name":"others","color":"598CEF","order":13}}}',
          ptag: {
            name: 'contact',
            id: 'af5cbd7f-1924-4731-a6a7-bf67a228e98d'
          },
          order: 2
        },
        {
          name: 'quantity',
          modelType: null,
          isOptional: false,
          type: 'integer',
          id: 'ddfcf2e1-0df4-4c2f-b1d2-bcfadea4750f',
          isScalar: true,
          value: '2000',
          ptag: {
            name: 'quantity',
            id: '58e75274-7c6b-4e27-ac4c-e08eb8a24d66'
          },
          order: 3
        },
        {
          name: 'parity',
          modelType: null,
          isOptional: true,
          type: 'double',
          id: 'e91a2149-c077-4cc0-8e0f-cd3bbebc653c',
          isScalar: true,
          ptag: {
            name: 'parity',
            id: '87335f2b-3461-414e-8917-e9fb8e7e13e4'
          },
          order: 4
        },
        {
          name: 'subscriptionPrice',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: '5d628535-e875-4d76-8945-34c0d5644190',
          isScalar: true,
          value: '0',
          ptag: {
            name: 'subscriptionPrice',
            id: '6f2b0ec5-3296-4f2d-b6c7-c8c558e8639b'
          },
          order: 5
        },
        {
          name: 'exercisePrice',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: 'acc9e613-e52f-477b-bbf4-7be37c56af7e',
          isScalar: true,
          value: '90',
          ptag: {
            name: 'exercisePrice',
            id: '3a52986b-5d3d-4d38-b956-11f5201a8b41'
          },
          order: 6
        },
        {
          name: 'liberatedAmount',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: '47eb9ae4-8ecb-4e18-8dfe-9e0ef503316a',
          isScalar: true,
          ptag: {
            name: 'liberatedAmount',
            id: '28ebec26-9c4b-44be-9778-7bd2056db8da'
          },
          order: 7
        },
        {
          name: 'expireAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: 'bc082efd-7ea5-4eba-934c-46057c79d204',
          isScalar: true,
          value: '2030-06-01',
          ptag: {
            name: 'endDate',
            id: 'bbf6c789-ced3-47c3-8b85-161157218484'
          },
          order: 8
        },
        {
          name: 'vesting',
          modelType: 'CompaniesVesting',
          isOptional: true,
          type: 'model',
          id: '4dfa00c6-7f03-47bf-97c5-a98ac76d3cd5',
          isScalar: true,
          value:
            '{"id":"e538abb1-c67a-11ea-ab94-068d0b27b94e","name":"BSPCE2017-2","exerciseDelayUnit":null,"exerciseDelayQuantity":null,"useSplitValue":false,"vestingPeriods":[{"id":"d5ee9fdf-b9e3-4e16-a6d8-eb2806364bbf","order":0,"quantity":null,"percentage":0,"fraction":null,"periodUnit":"DAYS","periodQty":0,"periodType":"VESTING","startDateType":"ENTRY","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"fb81ae9e-bbe5-4487-a19d-64043f9e63d3","order":1,"quantity":null,"percentage":25,"fraction":null,"periodUnit":"MONTHS","periodQty":12,"periodType":"WAIT","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"370eb48d-d52e-4f8b-8747-448208275409","order":2,"quantity":null,"percentage":25,"fraction":null,"periodUnit":"MONTHS","periodQty":12,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"2452e6d9-f610-45cc-a313-2b234b7bc662","order":3,"quantity":null,"percentage":25,"fraction":null,"periodUnit":"MONTHS","periodQty":12,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"d3bba33a-7076-499b-b0a2-897934df5649","order":4,"quantity":null,"percentage":25,"fraction":null,"periodUnit":"MONTHS","periodQty":12,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"}]}',
          ptag: {
            name: 'vesting',
            id: '466a5e2b-9b98-42f8-b49b-7ad3c5001c73'
          },
          order: 9
        },
        {
          name: 'startAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: 'e96fcf7c-0856-4de6-ae8f-c41ccc4694f7',
          isScalar: true,
          ptag: {
            name: 'startDate',
            id: '9bc9e5ac-aa2a-42e1-9c92-50abd2c8c763'
          },
          order: 10
        }
      ],
      eventGroup: {
        id: '63525afd-e402-4161-a3c9-475092c0a307',
        name: 'Titres'
      },
      processes: [
        {
          name: 'emitStock',
          ptags: null,
          id: '30bbf0ba-93f5-498c-85a7-549a17c97eb6'
        },
        {
          name: 'cancelDelegation',
          ptags: null,
          id: '5c4c761a-f568-40c7-95e5-14634d8eb164'
        },
        {
          name: 'createVesting',
          ptags: null,
          id: 'c637258e-6bd1-4934-8be9-827daffa4535'
        }
      ],
      timelineTags: []
    },
    effectiveAt: '2020-06-01',
    effectiveAtSearch: '01/06/2020',
    isDraft: false,
    documents: [
      {
        documentType: {
          timelineTags: [],
          name: 'import | Acte enregistré (Statuts)',
          id: '9a3253a0-73d0-11e8-9c67-fa163ecedb5e'
        },
        name: 'democorp',
        signedAt: null,
        id: '5f3a4f14-13b2-11eb-8d78-068d0b27b94e'
      }
    ],
    companyId: 'c1610166-cf4c-49d3-92a1-ae80d4302719',
    hash: '229f65fc36069dac378151d47d722ca2e2b9d9c0cb6aa247c4e7c9998a2fbf21',
    audits: [],
    locked: false,
    id: '2ef2f804-c67d-11ea-ab94-068d0b27b94e'
  },
  {
    event: {
      id: '3130a41c-fc7e-410d-9bc9-a67e4fe7cbec',
      name: 'Emission de titres',
      type: 'emit',
      isScalar: true,
      elements: [
        {
          name: 'CompaniesStock',
          modelType: 'CompaniesStockAlias',
          isOptional: false,
          type: 'model',
          id: '649accdc-5697-4372-a458-eacc48e428e6',
          isScalar: false,
          value:
            '{"id":"2fabac98-de0a-11e9-bb02-0e04bd33b2e4","name":"BCE 2017","isPrincipal":true,"color":null,"isCombined":false,"isComposed":true,"inNFD":false,"inFD":true,"inESOP":true,"inValoGraph":false,"expireAt":null,"companiesStockId":"9c395b54-3cdd-4bc6-8f81-419462828476","stockId":"a7ad7eee-83a0-4fbe-ad4f-1557dfd11f16","composedStock":{"id":"9fd7ce67-5b43-48e4-88e9-61974808e0cc","name":"AO Gen 2","parity":1}}',
          ptag: {
            name: 'companiesStock',
            id: 'cf0f727d-2983-43a7-be3d-01f295d57963'
          },
          order: 0
        },
        {
          method: 'getDelegations',
          name: 'delegation',
          modelType: 'CompaniesEvent',
          isOptional: true,
          type: 'dynamic',
          id: 'e4a58542-735b-4ac1-8652-fff26de4d89b',
          isScalar: false,
          value:
            '{"key":{"effectiveAt":"2020-06-01","name":"Délégation de compétence","priority":2},"id":"e62d1eb4-c679-11ea-ab94-068d0b27b94e"}',
          ptag: {
            name: 'delegation',
            id: '78fd4cce-b813-4d7e-8ab3-ad766fc14505'
          },
          order: 1
        },
        {
          name: 'contact',
          modelType: 'Contact',
          isOptional: false,
          type: 'model',
          id: '06679ccb-9e03-415a-bac1-db2b325020f6',
          isScalar: true,
          value:
            '{"key":"Franck Viel","id":"28caf0ab-c679-11ea-ab94-068d0b27b94e","options":{"id":"28caf0ab-c679-11ea-ab94-068d0b27b94e","firstname":"Franck","lastname":"Viel","denomination":null,"type":"NATURAL","pictureUrl":"https://uplaw-dev-public-content.s3.eu-west-3.amazonaws.com/pictures/c1610166-cf4c-49d3-92a1-ae80d4302719/28caf0ab-c679-11ea-ab94-068d0b27b94e.jpg?v=1594771200000","color":null,"representativeContact":null,"formType":null,"group":{"id":"17e33530-c245-42b9-a06f-2bce943661a7","name":"others","color":"598CEF","order":13}}}',
          ptag: {
            name: 'contact',
            id: 'af5cbd7f-1924-4731-a6a7-bf67a228e98d'
          },
          order: 2
        },
        {
          name: 'quantity',
          modelType: null,
          isOptional: false,
          type: 'integer',
          id: 'ddfcf2e1-0df4-4c2f-b1d2-bcfadea4750f',
          isScalar: true,
          value: '2000',
          ptag: {
            name: 'quantity',
            id: '58e75274-7c6b-4e27-ac4c-e08eb8a24d66'
          },
          order: 3
        },
        {
          name: 'parity',
          modelType: null,
          isOptional: true,
          type: 'double',
          id: 'e91a2149-c077-4cc0-8e0f-cd3bbebc653c',
          isScalar: true,
          ptag: {
            name: 'parity',
            id: '87335f2b-3461-414e-8917-e9fb8e7e13e4'
          },
          order: 4
        },
        {
          name: 'subscriptionPrice',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: '5d628535-e875-4d76-8945-34c0d5644190',
          isScalar: true,
          value: '0',
          ptag: {
            name: 'subscriptionPrice',
            id: '6f2b0ec5-3296-4f2d-b6c7-c8c558e8639b'
          },
          order: 5
        },
        {
          name: 'exercisePrice',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: 'acc9e613-e52f-477b-bbf4-7be37c56af7e',
          isScalar: true,
          value: '90',
          ptag: {
            name: 'exercisePrice',
            id: '3a52986b-5d3d-4d38-b956-11f5201a8b41'
          },
          order: 6
        },
        {
          name: 'liberatedAmount',
          modelType: null,
          isOptional: true,
          type: 'money',
          id: '47eb9ae4-8ecb-4e18-8dfe-9e0ef503316a',
          isScalar: true,
          ptag: {
            name: 'liberatedAmount',
            id: '28ebec26-9c4b-44be-9778-7bd2056db8da'
          },
          order: 7
        },
        {
          name: 'expireAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: 'bc082efd-7ea5-4eba-934c-46057c79d204',
          isScalar: true,
          value: '2030-06-01',
          ptag: {
            name: 'endDate',
            id: 'bbf6c789-ced3-47c3-8b85-161157218484'
          },
          order: 8
        },
        {
          name: 'vesting',
          modelType: 'CompaniesVesting',
          isOptional: true,
          type: 'model',
          id: '4dfa00c6-7f03-47bf-97c5-a98ac76d3cd5',
          isScalar: true,
          value:
            '{"id":"e538abb1-c67a-11ea-ab94-068d0b27b94e","name":"BSPCE2017-2","exerciseDelayUnit":null,"exerciseDelayQuantity":null,"useSplitValue":false,"vestingPeriods":[{"id":"d5ee9fdf-b9e3-4e16-a6d8-eb2806364bbf","order":0,"quantity":null,"percentage":0,"fraction":null,"periodUnit":"DAYS","periodQty":0,"periodType":"VESTING","startDateType":"ENTRY","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"fb81ae9e-bbe5-4487-a19d-64043f9e63d3","order":1,"quantity":null,"percentage":25,"fraction":null,"periodUnit":"MONTHS","periodQty":12,"periodType":"WAIT","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"370eb48d-d52e-4f8b-8747-448208275409","order":2,"quantity":null,"percentage":25,"fraction":null,"periodUnit":"MONTHS","periodQty":12,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"2452e6d9-f610-45cc-a313-2b234b7bc662","order":3,"quantity":null,"percentage":25,"fraction":null,"periodUnit":"MONTHS","periodQty":12,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"},{"id":"d3bba33a-7076-499b-b0a2-897934df5649","order":4,"quantity":null,"percentage":25,"fraction":null,"periodUnit":"MONTHS","periodQty":12,"periodType":"VESTING","startDateType":"LAST","roundType":"FLOOR","fractionReport":false,"hasObjective":false,"dateAdjustment":"BEGIN"}]}',
          ptag: {
            name: 'vesting',
            id: '466a5e2b-9b98-42f8-b49b-7ad3c5001c73'
          },
          order: 9
        },
        {
          name: 'startAt',
          modelType: null,
          isOptional: true,
          type: 'date',
          id: 'e96fcf7c-0856-4de6-ae8f-c41ccc4694f7',
          isScalar: true,
          ptag: {
            name: 'startDate',
            id: '9bc9e5ac-aa2a-42e1-9c92-50abd2c8c763'
          },
          order: 10
        }
      ],
      eventGroup: {
        id: '63525afd-e402-4161-a3c9-475092c0a307',
        name: 'Titres'
      },
      processes: [
        {
          name: 'emitStock',
          ptags: null,
          id: '30bbf0ba-93f5-498c-85a7-549a17c97eb6'
        },
        {
          name: 'cancelDelegation',
          ptags: null,
          id: '5c4c761a-f568-40c7-95e5-14634d8eb164'
        },
        {
          name: 'createVesting',
          ptags: null,
          id: 'c637258e-6bd1-4934-8be9-827daffa4535'
        }
      ],
      timelineTags: []
    },
    effectiveAt: '2020-06-01',
    effectiveAtSearch: '01/06/2020',
    isDraft: false,
    documents: [
      {
        documentType: {
          timelineTags: [],
          name: 'import | Acte enregistré (Statuts)',
          id: '9a3253a0-73d0-11e8-9c67-fa163ecedb5e'
        },
        name: 'democorp',
        signedAt: null,
        id: '5f3a4f14-13b2-11eb-8d78-068d0b27b94e'
      }
    ],
    companyId: 'c1610166-cf4c-49d3-92a1-ae80d4302719',
    hash: '229f65fc36069dac378151d47d722ca2e2b9d9c0cb6aa247c4e7c9998a2fbf21',
    audits: [],
    locked: false,
    id: 'b731345e-c67e-11ea-ab94-068d0b27b94e'
  }
]

export const CompanyOverviewExample = {
  capital: {
    socialCapital: {
      value: 14815.9,
      type: 'currency',
      currency: 'EUR'
    },
    nominalValue: {
      value: 0.1,
      type: 'currency',
      currency: 'EUR'
    },
    nbNFD: {
      value: 1481590,
      type: 'number'
    },
    nbFD: {
      value: 1563122,
      type: 'number'
    },
    emitPrime: {
      value: 1124209.1,
      type: 'currency',
      currency: 'EUR'
    },
    nbShareholders: {
      value: 82,
      type: 'number'
    },
    capitalSplitByGroup: {
      labels: [
        i18n.global.t('groups.founders'),
        i18n.global.t('groups.investors'),
        i18n.global.t('groups.employees'),
        i18n.global.t('global.zz-others')
      ],
      dataset: [
        {
          data: [73.31, 21.32, 5.37, 0],
          backgroundColor: [
            '#8580F6',
            '#5c6dac',
            '#C3FDFF',
            '#aa80f6',
            '#5aa4ac'
          ]
        }
      ],

      title: 'overview.capital.capitalByGroup',
      subtitle: 'overview.capital.capitalByGroup_sub'
    },
    capitalSplitByMedium: {
      labels: [
        'Actions ordinaires',
        'BSPCE',
        'Stock-Options',
        'Actions gratuites'
      ],
      dataset: [
        {
          data: [94.78, 2.68, 2.54, 0],
          backgroundColor: [
            '#8580F6',
            '#5c6dac',
            '#C3FDFF',
            '#80ebf6',
            '#5aa4ac'
          ]
        }
      ],
      title: 'overview.capital.capitalByGroup',
      subtitle: 'overview.capital.capitalByStock_sub'
    }
  },
  financials: {
    preMoneyValue: {
      value: '-',
      type: 'string',
      currency: 'EUR'
    },
    postMoneyValue: {
      value: '-',
      type: 'string',
      currency: 'EUR'
    },
    lastPricePerStock: {
      value: '-',
      type: 'string',
      currency: 'EUR'
    },
    totalAmountFunding: {
      value: '-',
      type: 'string',
      currency: 'EUR'
    },
    fundingRounds: {
      value: '-',
      type: 'string'
    },
    dilutionRate: {
      value: '-',
      type: 'string',
      style: ''
    },
    fundingHistory: {
      labels: ['Tour 1', 'Tour 2', 'Tour 3'],
      dataset: [
        {
          data: [200000, 450000, 1026448.18],
          backgroundColor: [
            '#8580F6',
            '#5c6dac',
            '#aa80f6',
            '#80ebf6',
            '#5aa4ac'
          ]
        }
      ],
      title: 'overview.financials.fundingHistory'
    }
  },
  esop: {
    attributedQuantity: {
      value: '-',
      type: 'string'
    },
    vestedQuantity: {
      value: '-',
      type: 'string'
    },
    cancelledQuantity: {
      value: '-',
      type: 'string'
    },
    totalDilution: {
      value: '-',
      type: 'string',
      style: 'string'
    },
    grantableAmount: {
      value: '-',
      type: 'string'
    },
    shareholders: {
      value: '-',
      type: 'string'
    },
    optionPlanHistory: {
      labels: ['Plan 1', 'Plan 2', 'Plan 3'],
      dataset: [
        {
          label: 'caduc',
          data: [1000, 1000, 500],
          backgroundColor: '#5c6dac',
          hoverBackgroundColor: '#5aa4ac',
          borderWidth: 0,
          order: 3
        },
        {
          label: 'Non Exerçable',
          data: [3000, 12000, 18500],
          backgroundColor: '#aa80f6',
          hoverBackgroundColor: '#5aa4ac',
          borderWidth: 0,
          order: 2
        },
        {
          label: 'Exercable',
          data: [9000, 2000, 1000],
          backgroundColor: '#80ebf6',
          hoverBackgroundColor: '#5aa4ac',
          borderWidth: 0,
          order: 1
        }
      ],
      title: 'overview.esop.optionPlanHistory',
      options: {}
    },
    optionPlanDistribution: {
      labels: ['BSPCE', 'Actions gratuites', 'Stock-Options', 'BSA'],
      dataset: [
        {
          data: [70, 20, 10, 0],
          backgroundColor: [
            '#8580F6',
            '#5c6dac',
            '#aa80f6',
            '#80ebf6',
            '#5aa4ac'
          ]
        }
      ],
      title: 'overview.esop.optionPlanDistribution'
    }
  },
  results: {
    columns: [
      { label: i18n.global.t('datatable.column.closing'), field: 'closing' },
      { label: i18n.global.t('datatable.column.ca'), field: 'ca' },
      { label: i18n.global.t('datatable.column.results'), field: 'results' },
      { label: i18n.global.t('datatable.column.real'), field: 'effectif' }
    ],
    rows: [
      {
        closing: '2019-12-31',
        ca: '2000000',
        results: 'Comptes annuels non deposes',
        effectif: '50+'
      },
      {
        closing: '2018-12-31',
        ca: '1000000',
        results: 'Comptes annuels non deposes',
        effectif: '20+'
      },
      {
        closing: '2017-12-31',
        ca: '500000',
        results: 'Comptes annuels non deposes',
        effectif: '10+'
      }
    ]
  },
  bodacc: {
    columns: [
      { label: 'date de publication', field: 'date' },
      { label: 'No BODACC', field: 'bodacc' },
      { label: 'Annonce No', field: 'announcement' },
      { label: 'Type', field: 'type' }
    ],
    rows: [
      {
        date: '2020-10-07',
        bodacc: '20200195',
        announcement: '626s',
        type: 'Modifications et mutations diverses'
      }
    ]
  }
}

export const captable = {
  index: [
    '2020-07-05',
    '2020-06-01',
    '2018-09-01',
    '2018-07-12',
    '2018-03-30',
    '2018-01-14',
    '2017-06-16',
    '2017-02-15',
    '2016-06-29'
  ],
  captable: {
    date: '2020-07-05',
    nominalValue: 1,
    esop: {
      total: 0,
      companiesStockAlias: [
        {
          uuid: 'e62d6313-c679-11ea-ab94-068d0b27b94e',
          name: 'AGA2020 ',
          fd: 0,
          nfd: 0,
          funding: 0
        },
        {
          uuid: '2fabac98-de0a-11e9-bb02-0e04bd33b2e4',
          name: 'BCE 2017',
          fd: 0,
          nfd: 0,
          funding: 0
        }
      ]
    },
    lastSubscriptionPrice: 1,
    subscriptionPriceAvg: 23.258342707161606,
    entries: [
      {
        contact: {
          uuid: '89fe7d49-59e2-11e8-9f5c-fa163ecedb5e',
          key: 'Alban  Jaubert',
          group: i18n.global.t('groups.founders')
        },
        companiesStockAlias: [
          {
            uuid: 'c7f56bc5-1da4-11ea-b217-068d0b27b94e',
            name: 'AO',
            isComposed: false,
            isCombined: false,
            funding: 10000,
            fd: 9800,
            nfd: 9800,
            fd_p: 0.18254633510291515,
            nfd_p: 0.7349081364829396
          },
          {
            uuid: '706466fd-de0c-11e9-bb02-0e04bd33b2e4',
            name: 'BCE Dirigeants',
            isComposed: true,
            isCombined: false,
            composedStock: {
              uuid: 'df7a6fcc-e1c7-4844-88ff-b3b2db05ec4a',
              name: 'AO Gen 7',
              parity: 1
            },
            funding: 0,
            fd: 200,
            nfd: 0,
            fd_p: 0.0037254354102635744,
            nfd_p: 0
          }
        ],
        nfd: 9800,
        fd: 10000,
        funding: 10000,
        fd_p: 0.18627177051317872,
        nfd_p: 0.7349081364829396
      },
      {
        contact: {
          uuid: '89fe84ed-59e2-11e8-9f5c-fa163ecedb5e',
          key: 'Hyperism Venture',
          group: 'investors'
        },
        companiesStockAlias: [
          {
            uuid: 'c7f56bc5-1da4-11ea-b217-068d0b27b94e',
            name: 'AO',
            isComposed: false,
            isCombined: false,
            funding: 142020,
            fd: 1578,
            nfd: 1578,
            fd_p: 0.029393685386979604,
            nfd_p: 0.11833520809898762
          }
        ],
        nfd: 1578,
        fd: 1578,
        funding: 142020,
        fd_p: 0.029393685386979604,
        nfd_p: 0.11833520809898762
      },
      {
        contact: {
          uuid: '89fe8425-59e2-11e8-9f5c-fa163ecedb5e',
          key: 'Vinyl Records',
          group: 'investors'
        },
        companiesStockAlias: [
          {
            uuid: 'c7f56bc5-1da4-11ea-b217-068d0b27b94e',
            name: 'AO',
            isComposed: false,
            isCombined: false,
            funding: 158130,
            fd: 1757,
            nfd: 1757,
            fd_p: 0.0327279500791655,
            nfd_p: 0.13175853018372705
          }
        ],
        nfd: 1757,
        fd: 1757,
        funding: 158130,
        fd_p: 0.0327279500791655,
        nfd_p: 0.13175853018372705
      },
      {
        contact: {
          uuid: '89fe88b8-59e2-11e8-9f5c-fa163ecedb5e',
          key: 'Teleloo Holding',
          group: 'others'
        },
        companiesStockAlias: [
          {
            uuid: '30aed701-8fe3-11e8-9c67-fa163ecedb5e',
            name: 'BSA 2017',
            isComposed: true,
            isCombined: false,
            composedStock: {
              uuid: '507a45cf-f234-44e6-97da-d97fe80d01eb',
              name: 'AO Gen 1',
              parity: 1
            },
            funding: 1800,
            fd: 200,
            nfd: 0,
            fd_p: 0.0037254354102635744,
            nfd_p: 0
          }
        ],
        nfd: 0,
        fd: 200,
        funding: 1800,
        fd_p: 0.0037254354102635744,
        nfd_p: 0
      },
      {
        contact: {
          uuid: '89fe87f7-59e2-11e8-9f5c-fa163ecedb5e',
          key: 'Ameline Thibodeau',
          group: 'others'
        },
        companiesStockAlias: [
          {
            uuid: '30aed701-8fe3-11e8-9c67-fa163ecedb5e',
            name: 'BSA 2017',
            isComposed: true,
            isCombined: false,
            composedStock: {
              uuid: '507a45cf-f234-44e6-97da-d97fe80d01eb',
              name: 'AO Gen 1',
              parity: 1
            },
            funding: 1800,
            fd: 200,
            nfd: 0,
            fd_p: 0.0037254354102635744,
            nfd_p: 0
          }
        ],
        nfd: 0,
        fd: 200,
        funding: 1800,
        fd_p: 0.0037254354102635744,
        nfd_p: 0
      },
      {
        contact: {
          uuid: '89fe8739-59e2-11e8-9f5c-fa163ecedb5e',
          key: 'Seminix Management',
          group: 'others'
        },
        companiesStockAlias: [
          {
            uuid: '30aed701-8fe3-11e8-9c67-fa163ecedb5e',
            name: 'BSA 2017',
            isComposed: true,
            isCombined: false,
            composedStock: {
              uuid: '507a45cf-f234-44e6-97da-d97fe80d01eb',
              name: 'AO Gen 1',
              parity: 1
            },
            funding: 1800,
            fd: 200,
            nfd: 0,
            fd_p: 0.0037254354102635744,
            nfd_p: 0
          }
        ],
        nfd: 0,
        fd: 200,
        funding: 1800,
        fd_p: 0.0037254354102635744,
        nfd_p: 0
      },
      {
        contact: {
          uuid: '89fe9091-59e2-11e8-9f5c-fa163ecedb5e',
          key: 'Jules  Jacquemoud',
          group: 'others'
        },
        companiesStockAlias: [
          {
            uuid: 'e25f059a-de09-11e9-bb02-0e04bd33b2e4',
            name: 'BCE 2018',
            isComposed: true,
            isCombined: false,
            composedStock: {
              uuid: 'bec9ca16-c8be-4dbe-86e6-0a0b9ffb0e52',
              name: 'AO Gen 5',
              parity: 1
            },
            funding: 0,
            fd: 200,
            nfd: 0,
            fd_p: 0.0037254354102635744,
            nfd_p: 0
          }
        ],
        nfd: 0,
        fd: 200,
        funding: 0,
        fd_p: 0.0037254354102635744,
        nfd_p: 0
      },
      {
        contact: {
          uuid: '89fe8975-59e2-11e8-9f5c-fa163ecedb5e',
          key: 'Gervais  Duchamp',
          group: 'others'
        },
        companiesStockAlias: [
          {
            uuid: 'e25f059a-de09-11e9-bb02-0e04bd33b2e4',
            name: 'BCE 2018',
            isComposed: true,
            isCombined: false,
            composedStock: {
              uuid: 'bec9ca16-c8be-4dbe-86e6-0a0b9ffb0e52',
              name: 'AO Gen 5',
              parity: 1
            },
            funding: 0,
            fd: 450,
            nfd: 0,
            fd_p: 0.008382229673093043,
            nfd_p: 0
          }
        ],
        nfd: 0,
        fd: 450,
        funding: 0,
        fd_p: 0.008382229673093043,
        nfd_p: 0
      },
      {
        contact: {
          uuid: '89fe8677-59e2-11e8-9f5c-fa163ecedb5e',
          key: 'Matthieu Manoury',
          group: 'employees'
        },
        companiesStockAlias: [
          {
            uuid: 'e25f059a-de09-11e9-bb02-0e04bd33b2e4',
            name: 'BCE 2018',
            isComposed: true,
            isCombined: false,
            composedStock: {
              uuid: 'bec9ca16-c8be-4dbe-86e6-0a0b9ffb0e52',
              name: 'AO Gen 5',
              parity: 1
            },
            funding: 0,
            fd: 600,
            nfd: 0,
            fd_p: 0.011176306230790724,
            nfd_p: 0
          }
        ],
        nfd: 0,
        fd: 600,
        funding: 0,
        fd_p: 0.011176306230790724,
        nfd_p: 0
      },
      {
        contact: {
          uuid: '89fe9150-59e2-11e8-9f5c-fa163ecedb5e',
          key: 'Dominique Vaugrenard',
          group: i18n.global.t('groups.founders')
        },
        companiesStockAlias: [
          {
            uuid: 'e25f059a-de09-11e9-bb02-0e04bd33b2e4',
            name: 'BCE 2018',
            isComposed: true,
            isCombined: false,
            composedStock: {
              uuid: 'bec9ca16-c8be-4dbe-86e6-0a0b9ffb0e52',
              name: 'AO Gen 5',
              parity: 1
            },
            funding: 0,
            fd: 350,
            nfd: 0,
            fd_p: 0.006519511967961256,
            nfd_p: 0
          },
          {
            uuid: 'c7f56bc5-1da4-11ea-b217-068d0b27b94e',
            name: 'AO',
            isComposed: false,
            isCombined: false,
            funding: 0,
            fd: 200,
            nfd: 200,
            fd_p: 0.0037254354102635744,
            nfd_p: 0.014998125234345707
          }
        ],
        nfd: 200,
        fd: 550,
        funding: 0,
        fd_p: 0.01024494737822483,
        nfd_p: 0.014998125234345707
      },
      {
        contact: {
          uuid: '89fe8af3-59e2-11e8-9f5c-fa163ecedb5e',
          key: 'Just Looking Ventures',
          group: 'investors'
        },
        companiesStockAlias: [
          {
            uuid: '53cd8ef5-1da5-11ea-b217-068d0b27b94e',
            name: 'OC 2018',
            isComposed: true,
            isCombined: false,
            composedStock: {
              uuid: 'c3d8a10c-138e-4e22-b33c-f5da8a84fc71',
              name: 'AO Gen 6',
              parity: 1
            },
            funding: 487500,
            fd: 650,
            nfd: 0,
            fd_p: 0.012107665083356617,
            nfd_p: 0
          }
        ],
        nfd: 0,
        fd: 650,
        funding: 487500,
        fd_p: 0.012107665083356617,
        nfd_p: 0
      },
      {
        contact: {
          uuid: '89fe8d97-59e2-11e8-9f5c-fa163ecedb5e',
          key: 'Symoid Ventures',
          group: 'investors'
        },
        companiesStockAlias: [
          {
            uuid: '53cd8ef5-1da5-11ea-b217-068d0b27b94e',
            name: 'OC 2018',
            isComposed: true,
            isCombined: false,
            composedStock: {
              uuid: 'c3d8a10c-138e-4e22-b33c-f5da8a84fc71',
              name: 'AO Gen 6',
              parity: 1
            },
            funding: 600000,
            fd: 800,
            nfd: 0,
            fd_p: 0.014901741641054298,
            nfd_p: 0
          }
        ],
        nfd: 0,
        fd: 800,
        funding: 600000,
        fd_p: 0.014901741641054298,
        nfd_p: 0
      },
      {
        contact: {
          uuid: '0fe18399-c679-11ea-ab94-068d0b27b94e',
          key: 'Ferdinand-Acace Mignon',
          group: 'others'
        },
        companiesStockAlias: [
          {
            uuid: '2fabac98-de0a-11e9-bb02-0e04bd33b2e4',
            name: 'BCE 2017',
            isComposed: true,
            isCombined: false,
            composedStock: {
              uuid: '9fd7ce67-5b43-48e4-88e9-61974808e0cc',
              name: 'AO Gen 2',
              parity: 1
            },
            funding: 0,
            fd: 4000,
            nfd: 0,
            fd_p: 0.07450870820527149,
            nfd_p: 0
          }
        ],
        nfd: 0,
        fd: 4000,
        funding: 0,
        fd_p: 0.07450870820527149,
        nfd_p: 0
      },
      {
        contact: {
          uuid: '15521bcd-c679-11ea-ab94-068d0b27b94e',
          key: 'Florent Chirac',
          group: 'others'
        },
        companiesStockAlias: [
          {
            uuid: '2fabac98-de0a-11e9-bb02-0e04bd33b2e4',
            name: 'BCE 2017',
            isComposed: true,
            isCombined: false,
            composedStock: {
              uuid: '9fd7ce67-5b43-48e4-88e9-61974808e0cc',
              name: 'AO Gen 2',
              parity: 1
            },
            funding: 0,
            fd: 500,
            nfd: 0,
            fd_p: 0.009313588525658936,
            nfd_p: 0
          }
        ],
        nfd: 0,
        fd: 500,
        funding: 0,
        fd_p: 0.009313588525658936,
        nfd_p: 0
      },
      {
        contact: {
          uuid: '1ab9c73f-c679-11ea-ab94-068d0b27b94e',
          key: 'Fabrice Demaret',
          group: 'others'
        },
        companiesStockAlias: [
          {
            uuid: '2fabac98-de0a-11e9-bb02-0e04bd33b2e4',
            name: 'BCE 2017',
            isComposed: true,
            isCombined: false,
            composedStock: {
              uuid: '9fd7ce67-5b43-48e4-88e9-61974808e0cc',
              name: 'AO Gen 2',
              parity: 1
            },
            funding: 0,
            fd: 2000,
            nfd: 0,
            fd_p: 0.037254354102635744,
            nfd_p: 0
          }
        ],
        nfd: 0,
        fd: 2000,
        funding: 0,
        fd_p: 0.037254354102635744,
        nfd_p: 0
      },
      {
        contact: {
          uuid: '28caf0ab-c679-11ea-ab94-068d0b27b94e',
          key: 'Franck Viel',
          group: 'others'
        },
        companiesStockAlias: [
          {
            uuid: '2fabac98-de0a-11e9-bb02-0e04bd33b2e4',
            name: 'BCE 2017',
            isComposed: true,
            isCombined: false,
            composedStock: {
              uuid: '9fd7ce67-5b43-48e4-88e9-61974808e0cc',
              name: 'AO Gen 2',
              parity: 1
            },
            funding: 0,
            fd: 2000,
            nfd: 0,
            fd_p: 0.037254354102635744,
            nfd_p: 0
          }
        ],
        nfd: 0,
        fd: 2000,
        funding: 0,
        fd_p: 0.037254354102635744,
        nfd_p: 0
      },
      {
        contact: {
          uuid: '30135ecb-c679-11ea-ab94-068d0b27b94e',
          key: 'Axelle-Maxence Dupont',
          group: 'others'
        },
        companiesStockAlias: [
          {
            uuid: '2fabac98-de0a-11e9-bb02-0e04bd33b2e4',
            name: 'BCE 2017',
            isComposed: true,
            isCombined: false,
            composedStock: {
              uuid: '9fd7ce67-5b43-48e4-88e9-61974808e0cc',
              name: 'AO Gen 2',
              parity: 1
            },
            funding: 0,
            fd: 2000,
            nfd: 0,
            fd_p: 0.037254354102635744,
            nfd_p: 0
          }
        ],
        nfd: 0,
        fd: 2000,
        funding: 0,
        fd_p: 0.037254354102635744,
        nfd_p: 0
      },
      {
        contact: {
          uuid: '37dbf9ff-c679-11ea-ab94-068d0b27b94e',
          key: 'Salomé-Soline Aguilar',
          group: 'others'
        },
        companiesStockAlias: [
          {
            uuid: '2fabac98-de0a-11e9-bb02-0e04bd33b2e4',
            name: 'BCE 2017',
            isComposed: true,
            isCombined: false,
            composedStock: {
              uuid: '9fd7ce67-5b43-48e4-88e9-61974808e0cc',
              name: 'AO Gen 2',
              parity: 1
            },
            funding: 0,
            fd: 2000,
            nfd: 0,
            fd_p: 0.037254354102635744,
            nfd_p: 0
          }
        ],
        nfd: 0,
        fd: 2000,
        funding: 0,
        fd_p: 0.037254354102635744,
        nfd_p: 0
      },
      {
        contact: {
          uuid: '77cd7876-c678-11ea-ab94-068d0b27b94e',
          key: 'Simon-Céline Pech',
          group: 'others'
        },
        companiesStockAlias: [
          {
            uuid: '2fabac98-de0a-11e9-bb02-0e04bd33b2e4',
            name: 'BCE 2017',
            isComposed: true,
            isCombined: false,
            composedStock: {
              uuid: '9fd7ce67-5b43-48e4-88e9-61974808e0cc',
              name: 'AO Gen 2',
              parity: 1
            },
            funding: 0,
            fd: 2000,
            nfd: 0,
            fd_p: 0.037254354102635744,
            nfd_p: 0
          }
        ],
        nfd: 0,
        fd: 2000,
        funding: 0,
        fd_p: 0.037254354102635744,
        nfd_p: 0
      },
      {
        contact: {
          uuid: 'a76d4ce5-c678-11ea-ab94-068d0b27b94e',
          key: 'Moïse  Guerard',
          group: 'others'
        },
        companiesStockAlias: [
          {
            uuid: '2fabac98-de0a-11e9-bb02-0e04bd33b2e4',
            name: 'BCE 2017',
            isComposed: true,
            isCombined: false,
            composedStock: {
              uuid: '9fd7ce67-5b43-48e4-88e9-61974808e0cc',
              name: 'AO Gen 2',
              parity: 1
            },
            funding: 0,
            fd: 2000,
            nfd: 0,
            fd_p: 0.037254354102635744,
            nfd_p: 0
          }
        ],
        nfd: 0,
        fd: 2000,
        funding: 0,
        fd_p: 0.037254354102635744,
        nfd_p: 0
      },
      {
        contact: {
          uuid: 'cb09647d-c678-11ea-ab94-068d0b27b94e',
          key: 'Ariane  Renault',
          group: 'others'
        },
        companiesStockAlias: [
          {
            uuid: '2fabac98-de0a-11e9-bb02-0e04bd33b2e4',
            name: 'BCE 2017',
            isComposed: true,
            isCombined: false,
            composedStock: {
              uuid: '9fd7ce67-5b43-48e4-88e9-61974808e0cc',
              name: 'AO Gen 2',
              parity: 1
            },
            funding: 0,
            fd: 2000,
            nfd: 0,
            fd_p: 0.037254354102635744,
            nfd_p: 0
          }
        ],
        nfd: 0,
        fd: 2000,
        funding: 0,
        fd_p: 0.037254354102635744,
        nfd_p: 0
      },
      {
        contact: {
          uuid: 'd4967096-c678-11ea-ab94-068d0b27b94e',
          key: 'Laureline-Titen Peres',
          group: 'others'
        },
        companiesStockAlias: [
          {
            uuid: '2fabac98-de0a-11e9-bb02-0e04bd33b2e4',
            name: 'BCE 2017',
            isComposed: true,
            isCombined: false,
            composedStock: {
              uuid: '9fd7ce67-5b43-48e4-88e9-61974808e0cc',
              name: 'AO Gen 2',
              parity: 1
            },
            funding: 0,
            fd: 2000,
            nfd: 0,
            fd_p: 0.037254354102635744,
            nfd_p: 0
          }
        ],
        nfd: 0,
        fd: 2000,
        funding: 0,
        fd_p: 0.037254354102635744,
        nfd_p: 0
      },
      {
        contact: {
          uuid: 'dbb4d070-c678-11ea-ab94-068d0b27b94e',
          key: 'Roseline-Mathis Brun',
          group: 'others'
        },
        companiesStockAlias: [
          {
            uuid: '2fabac98-de0a-11e9-bb02-0e04bd33b2e4',
            name: 'BCE 2017',
            isComposed: true,
            isCombined: false,
            composedStock: {
              uuid: '9fd7ce67-5b43-48e4-88e9-61974808e0cc',
              name: 'AO Gen 2',
              parity: 1
            },
            funding: 0,
            fd: 2000,
            nfd: 0,
            fd_p: 0.037254354102635744,
            nfd_p: 0
          }
        ],
        nfd: 0,
        fd: 2000,
        funding: 0,
        fd_p: 0.037254354102635744,
        nfd_p: 0
      },
      {
        contact: {
          uuid: 'e3d29a96-c678-11ea-ab94-068d0b27b94e',
          key: 'Judith Evrard',
          group: 'others'
        },
        companiesStockAlias: [
          {
            uuid: '2fabac98-de0a-11e9-bb02-0e04bd33b2e4',
            name: 'BCE 2017',
            isComposed: true,
            isCombined: false,
            composedStock: {
              uuid: '9fd7ce67-5b43-48e4-88e9-61974808e0cc',
              name: 'AO Gen 2',
              parity: 1
            },
            funding: 0,
            fd: 2000,
            nfd: 0,
            fd_p: 0.037254354102635744,
            nfd_p: 0
          }
        ],
        nfd: 0,
        fd: 2000,
        funding: 0,
        fd_p: 0.037254354102635744,
        nfd_p: 0
      },
      {
        contact: {
          uuid: 'db441bf2-c677-11ea-ab94-068d0b27b94e',
          key: 'Michel-Adric Delacourt',
          group: 'others'
        },
        companiesStockAlias: [
          {
            uuid: '2fabac98-de0a-11e9-bb02-0e04bd33b2e4',
            name: 'BCE 2017',
            isComposed: true,
            isCombined: false,
            composedStock: {
              uuid: '9fd7ce67-5b43-48e4-88e9-61974808e0cc',
              name: 'AO Gen 2',
              parity: 1
            },
            funding: 0,
            fd: 2000,
            nfd: 0,
            fd_p: 0.037254354102635744,
            nfd_p: 0
          }
        ],
        nfd: 0,
        fd: 2000,
        funding: 0,
        fd_p: 0.037254354102635744,
        nfd_p: 0
      },
      {
        contact: {
          uuid: 'f380ddbe-c678-11ea-ab94-068d0b27b94e',
          key: 'Dieudonnée Bard',
          group: 'others'
        },
        companiesStockAlias: [
          {
            uuid: '2fabac98-de0a-11e9-bb02-0e04bd33b2e4',
            name: 'BCE 2017',
            isComposed: true,
            isCombined: false,
            composedStock: {
              uuid: '9fd7ce67-5b43-48e4-88e9-61974808e0cc',
              name: 'AO Gen 2',
              parity: 1
            },
            funding: 0,
            fd: 2000,
            nfd: 0,
            fd_p: 0.037254354102635744,
            nfd_p: 0
          }
        ],
        nfd: 0,
        fd: 2000,
        funding: 0,
        fd_p: 0.037254354102635744,
        nfd_p: 0
      },
      {
        contact: {
          uuid: 'fd330fe0-c678-11ea-ab94-068d0b27b94e',
          key: 'Denis-Suzanne Chaigneau',
          group: 'others'
        },
        companiesStockAlias: [
          {
            uuid: '2fabac98-de0a-11e9-bb02-0e04bd33b2e4',
            name: 'BCE 2017',
            isComposed: true,
            isCombined: false,
            composedStock: {
              uuid: '9fd7ce67-5b43-48e4-88e9-61974808e0cc',
              name: 'AO Gen 2',
              parity: 1
            },
            funding: 0,
            fd: 2000,
            nfd: 0,
            fd_p: 0.037254354102635744,
            nfd_p: 0
          }
        ],
        nfd: 0,
        fd: 2000,
        funding: 0,
        fd_p: 0.037254354102635744,
        nfd_p: 0
      },
      {
        contact: {
          uuid: '2a24d344-c678-11ea-ab94-068d0b27b94e',
          key: 'Florence Lasserre',
          group: 'others'
        },
        companiesStockAlias: [
          {
            uuid: '2fabac98-de0a-11e9-bb02-0e04bd33b2e4',
            name: 'BCE 2017',
            isComposed: true,
            isCombined: false,
            composedStock: {
              uuid: '9fd7ce67-5b43-48e4-88e9-61974808e0cc',
              name: 'AO Gen 2',
              parity: 1
            },
            funding: 0,
            fd: 2000,
            nfd: 0,
            fd_p: 0.037254354102635744,
            nfd_p: 0
          }
        ],
        nfd: 0,
        fd: 2000,
        funding: 0,
        fd_p: 0.037254354102635744,
        nfd_p: 0
      },
      {
        contact: {
          uuid: '05445e3f-c679-11ea-ab94-068d0b27b94e',
          key: 'Perceval Aubert',
          group: 'others'
        },
        companiesStockAlias: [
          {
            uuid: '2fabac98-de0a-11e9-bb02-0e04bd33b2e4',
            name: 'BCE 2017',
            isComposed: true,
            isCombined: false,
            composedStock: {
              uuid: '9fd7ce67-5b43-48e4-88e9-61974808e0cc',
              name: 'AO Gen 2',
              parity: 1
            },
            funding: 0,
            fd: 2000,
            nfd: 0,
            fd_p: 0.037254354102635744,
            nfd_p: 0
          }
        ],
        nfd: 0,
        fd: 2000,
        funding: 0,
        fd_p: 0.037254354102635744,
        nfd_p: 0
      },
      {
        contact: {
          uuid: '3ecca6e3-c679-11ea-ab94-068d0b27b94e',
          key: 'Alphonse Krebs',
          group: 'others'
        },
        companiesStockAlias: [
          {
            uuid: '2fabac98-de0a-11e9-bb02-0e04bd33b2e4',
            name: 'BCE 2017',
            isComposed: true,
            isCombined: false,
            composedStock: {
              uuid: '9fd7ce67-5b43-48e4-88e9-61974808e0cc',
              name: 'AO Gen 2',
              parity: 1
            },
            funding: 0,
            fd: 2000,
            nfd: 0,
            fd_p: 0.037254354102635744,
            nfd_p: 0
          }
        ],
        nfd: 0,
        fd: 2000,
        funding: 0,
        fd_p: 0.037254354102635744,
        nfd_p: 0
      },
      {
        contact: {
          uuid: 'e858ce4a-c678-11ea-ab94-068d0b27b94e',
          key: 'Lucas Sala',
          group: 'others'
        },
        companiesStockAlias: [],
        nfd: 0,
        fd: 0,
        funding: 0,
        fd_p: 0,
        nfd_p: 0
      }
    ],
    totalFD: 53685,
    totalNFD: 13335
  }
}
